{
  "accept_invitation": {
    "account_exists": {
      "description_prefix": "इस ईमेल के साथ खाता",
      "description_suffix": "पहले से मौजूद है। कृपया निमंत्रण स्वीकार करने के लिए लॉग इन करें।",
      "title": "खाता पहले से मौजूद है"
    },
    "actions": {
      "create_and_accept": "खाता बनाएं और स्वीकार करें",
      "creating_account": "खाता बनाया जा रहा है...",
      "go_to_login": "लॉगिन पर जाएँ",
      "login_to_accept": "स्वीकार करने के लिए लॉग इन करें"
    },
    "errors": {
      "accept_failed": "निमंत्रण स्वीकार करने में विफल",
      "all_fields_required": "सभी फ़ील्ड आवश्यक हैं",
      "invalid_link": "अमान्य निमंत्रण लिंक",
      "password_min_length": "पासवर्ड कम से कम 8 अक्षरों का होना चाहिए",
      "verify_failed": "निमंत्रण सत्यापित करने में विफल"
    },
    "form": {
      "first_name": "पहला नाम",
      "last_name": "अंतिम नाम",
      "new_account_needed": "नया खाता आवश्यक है। कृपया अपनी जानकारी दें।",
      "password": "पासवर्ड",
      "subtitle": "संगठन से जुड़ने के लिए पंजीकरण पूरा करें",
      "title": "निमंत्रण स्वीकार करें",
      "username_note": "आपका यूज़रनेम आपके नाम के आधार पर स्वतः बनेगा।"
    },
    "invalid": {
      "title": "अमान्य निमंत्रण"
    },
    "joining": {
      "adding_you_to": "आपको जोड़ा जा रहा है",
      "title": "संगठन में जोड़ा जा रहा है"
    },
    "loading": {
      "verify_invitation": "आपके निमंत्रण की पुष्टि की जा रही है..."
    }
  },
  "account": {
    "notifications": {
      "daily_usage_digest": "दैनिक उपयोग सारांश",
      "daily_usage_digest_desc": "AI उपयोग और वॉलेट बैलेंस का दैनिक ईमेल सारांश पाएं (ईमेल सूचनाएँ आवश्यक)।"
    }
  },
  "activity_logs": {
    "action": "कार्य",
    "card_description": "सभी उपयोगकर्ता और सिस्टम गतिविधियाँ नीचे सूचीबद्ध हैं।",
    "card_title": "लॉग",
    "count_one": "{{count}} कुल गतिविधियाँ",
    "count_other": "{{count}} कुल गतिविधियाँ",
    "create_index_link": "Firebase कंसोल में इंडेक्स बनाएँ",
    "date": "दिनांक",
    "description": "सभी सिस्टम गतिविधि और ऑडिट लॉग देखें।",
    "details": "विवरण",
    "filters": {
      "all_actions": "सभी क्रियाएँ"
    },
    "headers": {
      "action": "क्रिया",
      "details": "विवरण",
      "timestamp": "टाइमस्टैम्प",
      "user": "उपयोगकर्ता"
    },
    "no_logs_desc": "निर्धारित अवधि में इस उपयोगकर्ता के लिए कोई रिकॉर्डेड इवेंट नहीं हैं।",
    "recent_events": "हाल की घटनाएँ",
    "retry_instruction": "(फिर नीचे पुनः प्रयास करें)।",
    "search_placeholder": "लॉग खोजें...",
    "title": "गतिविधि लॉग"
  },
  "admin_dashboard": {
    "organizations": {
      "active_orgs": "सक्रिय बिल्डर",
      "desc": "बिल्डर आँकड़े और प्रबंधन का अवलोकन।",
      "manage_btn": "बिल्डर प्रबंधित करें",
      "new_orgs_week": "इस सप्ताह नए बिल्डर",
      "title": "बिल्डर",
      "total_orgs": "कुल बिल्डर"
    },
    "rbac": {
      "active_assignments": "सक्रिय कार्य",
      "desc": "भूमिकाएँ, अनुमतियाँ और अभिगम नियंत्रण का अवलोकन।",
      "manage_roles_btn": "भूमिकाएँ प्रबंधित करें",
      "new_assignments": "कार्य",
      "title": "भूमिका-आधारित अभिगम नियंत्रण",
      "total_permissions": "कुल अनुमतियाँ",
      "total_roles": "कुल भूमिकाएँ",
      "view_perms_btn": "अनुमतियाँ देखें"
    },
    "user_management": {
      "active_users": "सक्रिय उपयोगकर्ता",
      "desc": "उपयोगकर्ता आँकड़े और प्रबंधन का अवलोकन।",
      "manage_btn": "उपयोगकर्ता प्रबंधित करें",
      "new_users_week": "इस सप्ताह नए उपयोगकर्ता",
      "title": "उपयोगकर्ता प्रबंधन",
      "total_users": "कुल उपयोगकर्ता"
    }
  },
  "admin_subs": {
    "description": "प्लेटफ़ॉर्म पर सभी सदस्यताओं की निगरानी और प्रबंधन करें",
    "headers": {
      "auto_renew": "स्वतः नवीनीकरण",
      "end_date": "अंतिम तिथि",
      "organization": "संगठन",
      "plan": "योजना",
      "price": "मूल्य",
      "start_date": "प्रारंभ तिथि",
      "stripe_id": "स्ट्राइप आईडी",
      "user": "उपयोगकर्ता"
    },
    "stats": {
      "active_subscriptions": "सक्रिय सदस्यताएँ",
      "monthly_revenue": "मासिक राजस्व",
      "total_subscriptions": "कुल सदस्यताएँ"
    },
    "table": {
      "description": "फ़िल्टरिंग और खोज क्षमताओं के साथ सभी सदस्यताओं का विस्तृत दृश्य",
      "title": "सभी सदस्यताएँ"
    },
    "title": "सभी सदस्यताओं का प्रबंधन करें"
  },
  "admin_user_detail": {
    "actions": {
      "edit_identifier": "आईडेंटिफ़ायर संपादित करें",
      "reset_password": "पासवर्ड रीसेट करें",
      "return_dashboard": "डैशबोर्ड पर लौटें",
      "return_org_users": "ऑर्ग यूज़र्स पर लौटें"
    },
    "activity": {
      "description": "खाते और सिस्टम घटनाओं का समयानुसार रिकॉर्ड।",
      "empty": "कोई गतिविधि नहीं।",
      "system_event": "सिस्टम इवेंट ट्रिगर हुआ।",
      "title": "गतिविधि लॉग"
    },
    "errors": {
      "access_denied": "प्रवेश निषिद्ध",
      "identity_not_found": "मांगी गई पहचान नहीं मिली।",
      "load_user_failed": "यूज़र विवरण लोड करने में विफल।",
      "transmission_failed": "ट्रांसमिशन विफल",
      "update_status_failed": "स्थिति अपडेट करने में विफल"
    },
    "labels": {
      "organization_users": "संगठन यूज़र्स",
      "system_users": "सिस्टम यूज़र्स"
    },
    "loading_profile": "यूज़र प्रोफ़ाइल लोड हो रही है",
    "organizations": {
      "description": "इस यूज़र से जुड़े संगठन।",
      "independent_user": "स्वतंत्र यूज़र (कोई संगठन नहीं)",
      "title": "संगठन सदस्यता"
    },
    "profile": {
      "access_enabled": "यूज़र को प्लेटफ़ॉर्म एक्सेस है",
      "access_restricted": "एक्सेस सीमित है",
      "account_status": "खाता स्थिति",
      "active_status": "सक्रिय स्थिति",
      "awaiting_verification": "सत्यापन लंबित",
      "billing_wallet": "",
      "email": "ईमेल",
      "email_notifications": "ईमेल सूचनाएँ",
      "email_verified": "ईमेल सत्यापित",
      "identity_confirmed": "पहचान पुष्टि",
      "in_app_notifications": "इन-ऐप सूचनाएँ",
      "info": "प्रोफ़ाइल जानकारी",
      "language": "भाषा",
      "last_login": "अंतिम लॉगिन",
      "member_since": "सदस्यता तिथि",
      "never": "कभी नहीं",
      "notifications": "सूचनाएँ",
      "phone": "फ़ोन",
      "username": "यूज़रनेम"
    },
    "roles_tab": {
      "assigned_roles": "असाइन किए गए रोल्स",
      "description": "इस यूज़र को दिए गए मौजूदा अनुमति स्तर।",
      "direct_role": "सीधे असाइन किया गया रोल",
      "global_access": "ग्लोबल एक्सेस",
      "organization_scoped": "संगठन-सीमित",
      "platform_wide_role": "प्लेटफ़ॉर्म-वाइड रोल",
      "total_one": "",
      "total_other": ""
    },
    "tabs": {
      "activity": "गतिविधि",
      "organizations": "संगठन",
      "profile": "प्रोफ़ाइल",
      "roles": "रोल्स",
      "usage": "उपयोग और क्रेडिट्स"
    },
    "toasts": {
      "recovery_initiated": "रिकवरी ट्रांसमिशन शुरू किया गया",
      "user_activated": "यूज़र सफलतापूर्वक सक्रिय हुआ",
      "user_deactivated": "यूज़र सफलतापूर्वक निष्क्रिय हुआ"
    },
    "usage": {
      "amount_inr": "",
      "amount_placeholder": "0.00",
      "amount_usd": "राशि (USD)",
      "credits_added_to": "क्रेडिट जोड़े जाएंगे",
      "current_balance": "वर्तमान बैलेंस",
      "description": "विवरण",
      "description_placeholder": "उद्देश्य (जैसे Refund, Bonus)",
      "errors": {
        "grant_failed": "क्रेडिट देने में विफल"
      },
      "grant_credits": "क्रेडिट दें",
      "grant_org": "ऑर्ग वॉलेट में दें",
      "grant_org_desc": "संगठन के साझा वॉलेट में क्रेडिट जोड़ें।",
      "grant_personal": "पर्सनल वॉलेट में दें",
      "grant_personal_desc": "यूज़र खाते में उपयोग क्रेडिट जोड़ें।",
      "lifetime_credits": "कुल क्रेडिट्स",
      "lifetime_usage": "कुल उपयोग",
      "no_transactions": "कोई लेन-देन दर्ज नहीं।",
      "org_wallet": "ऑर्ग वॉलेट",
      "toast": {
        "org_granted": "{{amount}} क्रेडिट {{orgName}} ऑर्ग वॉलेट में दिए गए",
        "personal_granted": "{{amount}} क्रेडिट पर्सनल वॉलेट में दिए गए"
      },
      "transaction_history": "लेन-देन इतिहास",
      "transaction_history_desc": "बैलेंस और उपयोग परिवर्तनों का इतिहास।"
    }
  },
  "admin_users": {
    "access_denied": {
      "description": "उपयोगकर्ता प्रबंधन देखने के लिए आपके पास आवश्यक अनुमतियाँ नहीं हैं।",
      "title": "पहुँच अस्वीकृत"
    },
    "add_user": "उपयोगकर्ता जोड़ें",
    "billing_country": "",
    "billing_country_locked": "",
    "billing_country_super_admin_only": "",
    "bulk_actions": {
      "activate": "सक्रिय करें",
      "activate_now": "उपयोगकर्ताओं को सक्रिय करें",
      "confirm_activate": "सक्रिय करने की पुष्टि करें",
      "confirm_deactivate": "निष्क्रिय करने की पुष्टि करें",
      "confirm_reset_password": "व्यवस्थापक उपयोगकर्ताओं की थोक कार्रवाइयों के लिए पासवर्ड रीसेट की पुष्टि करें",
      "deactivate": "निष्क्रिय करें",
      "deactivate_now": "उपयोगकर्ताओं को निष्क्रिय करें",
      "description": "सभी चयनित प्रतिभागियों पर लागू करने के लिए एक क्रिया चुनें।",
      "export": "CSV निर्यात करें",
      "grant_button": "क्रेडिट अभी प्रदान करें",
      "grant_credits": "क्रेडिट प्रदान करें",
      "grant_credits_failed": "कुछ उपयोगकर्ताओं को क्रेडिट प्रदान करने में विफल रहा।",
      "grant_to_multiple": "एक साथ कई उपयोगकर्ताओं को क्रेडिट प्रदान करें।",
      "reset_password": "रीसेट लिंक भेजें",
      "reset_password_success": "व्यवस्थापक उपयोगकर्ताओं की थोक कार्रवाइयों के लिए पासवर्ड रीसेट सफल",
      "selected": "उपयोगकर्ता चयनित",
      "selected_users": "उपयोगकर्ता चयनित",
      "send_now": "लिंक अभी भेजें",
      "users_affected": "उपयोगकर्ता प्रभावित होंगे"
    },
    "cannot_deactivate_self": "अपना स्वयं का खाता निष्क्रिय नहीं कर सकते।",
    "card": {
      "description": "आपके सिस्टम के सभी उपयोगकर्ताओं की सूची।",
      "title": "सभी उपयोगकर्ता"
    },
    "edit_user": "प्रतिभागी संपादित करें",
    "email_reset": "ईमेल रीसेट लिंक",
    "email_reset_desc": "उपयोगकर्ता ईमेल के माध्यम से मानक प्रवाह",
    "errors": {
      "fetch_failed": "उपयोगकर्ता या भूमिकाएँ प्राप्त करने में विफल।",
      "no_users": "कोई उपयोगकर्ता नहीं मिला।"
    },
    "filters": {
      "all": "सभी",
      "all_roles": "सभी भूमिकाएँ",
      "all_status": "सभी स्थितियाँ"
    },
    "invalid_amount": "कृपया एक वैध राशि दर्ज करें।",
    "list_description": "सभी पंजीकृत खातों और उनके पहुँच स्तरों की एक केंद्रीकृत सूची।",
    "pagination_info": "{{total}} प्रतिभागियों में से {{start}} से {{end}} तक दिखाया जा रहा है",
    "pending": {
      "aadhaar": "आधार लंबित",
      "all_complete": "पूर्ण",
      "country": "देश नहीं",
      "email": "ईमेल असत्यापित",
      "phone": "फ़ोन नहीं"
    },
    "search_placeholder": "उपयोगकर्ताओं को खोजें...",
    "sections": {
      "access": "पहुँच और पहचान",
      "billing": "",
      "personal": "व्यक्तिगत प्रोफाइल",
      "preferences": "सिस्टम प्राथमिकताएँ",
      "security": "सुरक्षा प्रबंधन"
    },
    "send_link": "लिंक भेजें",
    "set_password": "प्रशासनिक पासवर्ड रीसेट",
    "status_modal": {
      "activate_desc": "के लिए खाता सक्रियण की पुष्टि करें",
      "activate_title": "खाता सक्रिय करें",
      "activate_warning": "इस खाते को सक्रिय करने से तत्काल सभी प्लेटफ़ॉर्म विशेषाधिकार बहाल हो जाएंगे।",
      "deactivate_desc": "के लिए खाता निष्क्रियकरण की पुष्टि करें",
      "deactivate_title": "खाता निष्क्रिय करें",
      "deactivate_warning": "इस खाते को निष्क्रिय करने से, जब तक इसे फिर से सक्रिय नहीं किया जाता, प्लेटफ़ॉर्म तक सभी पहुंच तुरंत रद्द हो जाएगी।"
    },
    "status_update_failed": "उपयोगकर्ता स्थिति अपडेट करने में विफल",
    "subtitle": "अपने संगठन के उपयोगकर्ताओं को प्रबंधित करें।",
    "system_participants": "सिस्टम प्रतिभागी",
    "table": {
      "aadhaar": "आधार",
      "aadhaar_last_four": "आधार समाप्त होता है {{lastFour}}",
      "aadhaar_not_verified": "सत्यापित नहीं",
      "aadhaar_verified": "सत्यापित",
      "actions": "कार्य",
      "country_currency": "देश / मुद्रा",
      "created": "बनाया गया",
      "email_verified": "ईमेल सत्यापन",
      "id": "आईडी",
      "member_since": "सदस्यता तिथि",
      "name": "नाम",
      "roles": "भूमिकाएँ",
      "status": "स्थिति",
      "view_usage": "उपयोग देखें"
    },
    "title": "उपयोगकर्ता",
    "total_users": "कुल उपयोगकर्ता",
    "unverification_success": "",
    "usage_sheet": {
      "amount": "राशि",
      "amount_inr": "",
      "amount_usd": "राशि (USD)",
      "date": "दिनांक",
      "description": "विवरण (वैकल्पिक)",
      "description_placeholder": "जैसे, प्रचार क्रेडिट",
      "grant_button": "क्रेडिट प्रदान करें",
      "grant_credits": "क्रेडिट प्रदान करें",
      "grant_org_button": "",
      "grant_success": "",
      "ledger": "हालिया बहीखाता",
      "no_entries": "अभी तक कोई बहीखाता प्रविष्टियाँ नहीं हैं।",
      "org_wallet": "",
      "personal_balance": "",
      "personal_wallet": "",
      "select_wallet_label": "",
      "title": "क्रेडिट और उपयोग",
      "type": "प्रकार"
    },
    "user_activated": "उपयोगकर्ता खाता सक्रिय किया गया",
    "user_deactivated": "उपयोगकर्ता खाता निष्क्रिय किया गया",
    "verification_error": "",
    "verification_success": "",
    "verify_desc": "ईमेल सत्यापन स्थिति के लिए मैन्युअल ओवरराइड",
    "wallet_currency": "",
    "wallet_currency_locked": "",
    "wallet_currency_pending": ""
  },
  "analytics": {
    "actions": {
      "export_data": "डेटा निर्यात करें",
      "view_detailed_report": "विस्तृत रिपोर्ट देखें",
      "view_system_logs": "सिस्टम लॉग देखें"
    },
    "activity": {
      "desc_super_admin": "पूरे पारिस्थितिकी तंत्र से नवीनतम अपडेट।",
      "desc_user": "इस महीने सबसे अधिक देखे गए गुण।",
      "title_super_admin": "प्लेटफ़ॉर्म गतिविधि",
      "title_user": "शीर्ष प्रदर्शन वाली लिस्टिंग"
    },
    "charts": {
      "engagement_overview": "जुड़ाव का अवलोकन",
      "engagement_overview_desc": "सभी संपत्तियों में दैनिक दृश्य और पूछताछ।",
      "growth_revenue": "विकास और राजस्व",
      "growth_revenue_desc": "मासिक आवर्ती राजस्व और उपयोगकर्ता अधिग्रहण रुझान।"
    },
    "description_super_admin": "प्लेटफ़ॉर्म स्वास्थ्य, उपयोगकर्ता वृद्धि और व्यावसायिक मेट्रिक्स की निगरानी करें।",
    "description_user": "अपनी लिस्टिंग के प्रदर्शन और जुड़ाव मेट्रिक्स को ट्रैक करें।",
    "filters": {
      "last_30_days": "पिछले 30 दिन"
    },
    "metrics": {
      "inquiries": "पूछताछ",
      "views_count_one": "{{count}} दृश्य",
      "views_count_other": "{{count}} दृश्य"
    },
    "stats": {
      "interested_tenants": "इच्छुक किराएदार",
      "total_properties": "कुल संपत्तियां",
      "total_views": "कुल दृश्य"
    },
    "super_admin": {
      "active_organizations": "सक्रिय संगठन",
      "estimated_revenue": "अनुमानित राजस्व",
      "total_platform_users": "कुल प्लेटफ़ॉर्म उपयोगकर्ता"
    },
    "title_super_admin": "प्लेटफ़ॉर्म अवलोकन",
    "title_user": "प्रदर्शन विश्लेषण"
  },
  "analytics_report_modal": {
    "actions": {
      "export_csv": "CSV निर्यात करें"
    },
    "description": "व्यू और एंगेजमेंट के आधार पर आपकी शीर्ष प्रदर्शन करने वाली संपत्तियों का विश्लेषण।",
    "empty": "इस रिपोर्ट के लिए कोई डेटा उपलब्ध नहीं है।",
    "errors": {
      "load_failed": "रिपोर्ट डेटा लोड करने में विफल"
    },
    "loading": "रिपोर्ट डेटा लोड हो रहा है...",
    "success": {
      "exported": "रिपोर्ट सफलतापूर्वक डाउनलोड हुई"
    },
    "table": {
      "inquiries": "पूछताछ",
      "location": "स्थान",
      "price": "मूल्य",
      "property": "संपत्ति",
      "status": "स्थिति",
      "views": "व्यू"
    },
    "title": "विस्तृत सामग्री प्रदर्शन रिपोर्ट"
  },
  "api_usage": {
    "description": "अनुरोध गणना, उपयोगकर्ता या संगठन द्वारा उपयोग और दैनिक विवरण देखें। केवल सुपरएडमिन।",
    "summary": {
      "card_description": "चयनित अवधि के लिए कुल एपीआई अनुरोध और एंडपॉइंट द्वारा विवरण।",
      "card_title": "सारांश"
    },
    "tabs": {
      "by_org": "संगठन द्वारा",
      "by_user": "उपयोगकर्ता द्वारा",
      "daily": "दैनिक",
      "recent": "हाल का",
      "summary": "सारांश"
    },
    "title": "एपीआई उपयोग"
  },
  "assistant": {
    "badge_search": "खोज",
    "confirm_delete_desc": "क्या आप वाकई इस खोज को हटाना चाहते हैं? चैट और सहेजे गए परिणाम स्थायी रूप से हट जाएँगे।",
    "confirm_delete_title": "खोज हटाएँ?",
    "delete_search": "खोज हटाएँ",
    "exit_dashboard": "डैशबोर्ड पर वापस जाएँ",
    "header_credits_hint": "उपयोग और बिलिंग",
    "header_home_aria": "होम पर जाएँ",
    "header_profile_aria": "खाता मेनू",
    "header_sign_in_aria": "साइन इन",
    "hero_greeting": "आज आप क्या ढूँढना चाहेंगे?",
    "hero_tagline": "घर, प्लॉट और कार्यस्थल—सीधे शब्दों में पूछें।",
    "hide_map": "नक्शा छुपाएँ",
    "language": "भाषा",
    "map_city_center_short": "{{city}} पर केंद्रित",
    "map_pin_count_one": "नक्शे पर {{count}}",
    "map_pin_count_other": "नक्शे पर {{count}}",
    "map_short": "नक्शा",
    "no_searches_yet": "अभी कोई खोज नहीं। संपत्ति खोजने के लिए चैट शुरू करें।",
    "on_map": "नक्शे पर",
    "placeholder": "जिस प्रॉपर्टी की तलाश है, उसे बताएँ…",
    "quick_menu_aria": "दिखावट और सेटिंग्स",
    "recent_searches": "हाल की खोजें",
    "results_map": "खोज परिणाम नक्शा",
    "resume": {
      "continue": "पिछली खोज जारी रखें",
      "description": "आपकी एक हाल की प्रॉपर्टी खोज है। जहाँ छोड़ा था वहीं से जारी रखें, या नई खोज शुरू करें।",
      "start_new": "नई खोज शुरू करें",
      "title": "पिछली खोज जारी रखें?"
    },
    "search_delete_failed": "खोज हटाने में विफल",
    "search_deleted": "खोज हटाई गई",
    "searching_hint": "आपके क्षेत्र में लिस्टिंग स्कैन की जा रही हैं…",
    "searching_status": "मिलती-जुलती संपत्तियाँ खोजी जा रही हैं",
    "sidebar_title": "मेरी खोजें",
    "theme": "थीम",
    "theme_dark": "डार्क",
    "theme_light": "लाइट",
    "voice_toggle": "आवाज़ शुरू / बंद करने के लिए टैप करें"
  },
  "auth": {
    "accept_terms_required": "आपको नियम स्वीकार करने होंगे",
    "after_verifying": "अपने ईमेल की पुष्टि करने के बाद।",
    "agree_to_terms": "मैं सहमत हूँ",
    "already_have_account": "पहले से ही एक खाता है?",
    "and": "और",
    "billing_country": "निवास देश",
    "billing_country_hint": "आपका वॉलेट {{currency}} उपयोग करेगा। यह पंजीकरण पर सेट होता है और बाद में नहीं बदला जा सकता।",
    "checking_availability": "उपलब्धता की जाँच हो रही है...",
    "city": "शहर",
    "confirm_password": "पासवर्ड की पुष्टि करें",
    "confirm_your_password": "अपने पासवर्ड की पुष्टि करें",
    "continue_with_facebook": "Facebook के साथ जारी रखें",
    "continue_with_google": "Google के साथ जारी रखें",
    "continue_with_phone": "फोन के साथ जारी रखें",
    "create_account": "अपना खाता बनाएँ",
    "create_password": "एक पासवर्ड बनाएँ",
    "creating_account": "खाता बनाया जा रहा है...",
    "dont_have_account": "क्या आपके पास खाता नहीं है?",
    "email": "ईमेल",
    "email_or_username": "ईमेल या उपयोगकर्ता नाम",
    "enter_city": "उदाहरण: हैदराबाद, अहमदाबाद",
    "enter_credentials": "अपने खाते तक पहुंचने के लिए अपने क्रेडेंशियल्स दर्ज करें",
    "enter_email": "अपना ईमेल दर्ज करें",
    "enter_email_or_username": "अपना ईमेल या उपयोगकर्ता नाम दर्ज करें",
    "enter_first_name": "जॉन",
    "enter_info": "अपना खाता बनाने के लिए अपनी जानकारी दर्ज करें",
    "enter_last_name": "डो",
    "enter_organization_name": "आपका बिल्डर नाम",
    "enter_password": "अपना पासवर्ड दर्ज करें",
    "enter_phone": "9876543210",
    "enter_phone_national": "अपना फ़ोन नंबर दर्ज करें",
    "enter_username": "जॉनडो",
    "fill_all_required": "कृपया चयनित पंजीकरण प्रकार के सभी आवश्यक फ़ील्ड भरें",
    "first_name": "पहला नाम",
    "first_name_required": "पहला नाम आवश्यक है",
    "forgot_password": "पासवर्ड भूल गए?",
    "forgot_password_page": {
      "description": "अपना ईमेल पता दर्ज करें और हम आपको अपना पासवर्ड रीसेट करने के लिए एक लिंक भेजेंगे।",
      "email_label": "ईमेल पता",
      "email_placeholder": "आप@उदाहरण.कॉम",
      "error_generic": "कुछ गलत हो गया। कृपया पुनः प्रयास करें।",
      "send_link": "रीसेट लिंक भेजें",
      "sending": "भेजा जा रहा है...",
      "success_check": "अपना इनबॉक्स और स्पैम फ़ोल्डर जांचें।",
      "success_title": "यदि ईमेल मौजूद है, तो पासवर्ड रीसेट लिंक भेज दिया गया है।",
      "title": "अपना पासवर्ड भूल गए?"
    },
    "google_signin_failed": "Google साइन-इन विफल। कृपया पुनः प्रयास करें।",
    "i_am_a": "मैं एक हूँ",
    "identifier_required": "ईमेल या उपयोगकर्ता नाम आवश्यक है",
    "identifier_too_long": "254 अक्षर या उससे कम होना चाहिए",
    "individual_desc": "खोजें, किराए पर लें, खरीदें या अपनी संपत्ति लिस्ट करें",
    "invalid_session": "अमान्य सत्र",
    "last_name": "अंतिम नाम",
    "last_name_required": "अंतिम नाम आवश्यक है",
    "list_properties": "संपत्तियों की सूची बनाएँ",
    "login_failed": "लॉगिन विफल रहा। कृपया पुनः प्रयास करें।",
    "login_here": "यहां लॉग इन करें",
    "looking_for_properties": "संपत्तियों की तलाश है",
    "or_continue_with": "या इसके साथ जारी रखें",
    "org_desc": "मैं रियल एस्टेट परियोजनाएं विकसित या बेचता/बेचती हूं",
    "organization_name": "बिल्डर का नाम",
    "organization_slug": "बिल्डर स्लग",
    "password": "पासवर्ड",
    "password_complexity": "पासवर्ड में अपरकेस, लोअरकेस और एक संख्या होनी चाहिए",
    "password_min_length": "पासवर्ड कम से कम 6 वर्णों का होना चाहिए",
    "passwords_dont_match": "पासवर्ड मेल नहीं खाते",
    "phone": {
      "code_placeholder": "123456",
      "description": "हम आपके फ़ोन नंबर पर एक बार का कोड भेजेंगे।",
      "errors": {
        "code_expired": "कोड समाप्त हो गया है। कृपया सत्यापन कोड पुनः भेजें।",
        "invalid_code": "अवैध सत्यापन कोड। कृपया पुनः प्रयास करें।",
        "invalid_phone": "अमान्य फ़ोन नंबर। कृपया E.164 प्रारूप का उपयोग करें (उदाहरण के लिए +1 650-555-3434)।",
        "missing_confirmation": "पुष्टि स्थिति अनुपलब्ध है। कृपया कोड पुनः भेजें।"
      },
      "format_hint": "E.164 प्रारूप का उपयोग करें (जो '+' से शुरू होता है)।",
      "label": "फ़ोन नंबर",
      "localhost_note": "ध्यान दें: जब ऐप चेक सक्षम/लागू हो, तो लोकलहोस्ट को डिबग टोकन की आवश्यकता होती है। स्थानीय रूप से परीक्षण फ़ोन नंबरों का उपयोग करें या ऐप चेक डिबग टोकन को कॉन्फ़िगर करें।",
      "placeholder": "+1 650-555-3434",
      "send_code": "कोड भेजें",
      "sending": "भेजा जा रहा है…",
      "title": "फ़ोन से जारी रखें",
      "verification_code": "सत्यापन कोड",
      "verify_continue": "सत्यापित करें और जारी रखें",
      "verifying": "सत्यापित किया जा रहा है…"
    },
    "phone_number": "फ़ोन नंबर",
    "phone_session_expired": "आपका फ़ोन सत्यापन सत्र समाप्त हो गया है। कृपया पुनः प्रयास करें।",
    "phone_verified": "फ़ोन नंबर सत्यापित",
    "pm_desc": "मैं मालिकों के लिए कई संपत्तियों का प्रबंधन करता हूं",
    "privacy_policy": "गोपनीयता नीति",
    "register": "पंजीकरण करें",
    "register_btn": "खाता बनाएँ",
    "registering_as_builder": "बिल्डर के रूप में पंजीकरण कर रहे हैं",
    "registering_as_individual": "आपका व्यक्तिगत खाता बनाया जा रहा है",
    "registering_as_pm": "संपत्ति प्रबंधक के रूप में पंजीकरण कर रहे हैं",
    "registration_failed": "पंजीकरण विफल रहा। कृपया फिर से प्रयास करें।",
    "registration_failed_title": "पंजीकरण विफल",
    "registration_success_desc": "आपका खाता सफलतापूर्वक बनाया गया, {{name}}!",
    "registration_success_message": "लगभग हो गया! कृपया अपना ईमेल जांचें और अपने खाते को सक्रिय करने के लिए अपना पता सत्यापित करें। आपका खाता सत्यापन लिंक पर क्लिक करने के बाद ही बनाया जाएगा।",
    "remember_me": "मुझे याद रखें",
    "role_org_desc": "मैं रियल एस्टेट परियोजनाएं विकसित या बेचता/बेचती हूं",
    "role_pm_desc": "मैं मालिकों के लिए कई संपत्तियाँ प्रबंधित करता/करती हूँ",
    "search_country_or_code": "देश या कोड खोजें…",
    "select_billing_country": "अपना देश चुनें",
    "sign_in": "साइन इन करें",
    "sign_in_link": "साइन इन करें",
    "sign_in_subtitle": "जारी रखने के लिए अपने खाते में साइन इन करें",
    "sign_up": "साइन अप करें",
    "signing_in": "साइन इन किया जा रहा है...",
    "start_free_trial": "आज ही अपना मुफ्त ट्रायल शुरू करें",
    "start_trial": "आज ही अपना निःशुल्क परीक्षण शुरू करें",
    "success_login_message": "आप इस टैब को बंद कर सकते हैं या",
    "tabs": {
      "organization": "बिल्डर",
      "property_manager": "संपत्ति प्रबंधक"
    },
    "terms_service": "सेवा की शर्तें",
    "try_suggestions": "आज़माएँ:",
    "username": "उपयोगकर्ता नाम",
    "username_available": "उपयोगकर्ता नाम उपलब्ध है!",
    "username_min_length": "उपयोगकर्ता नाम कम से कम 3 अक्षर का होना चाहिए",
    "username_taken": "उपयोगकर्ता नाम पहले से ही लिया गया है। इनमें से किसी एक को आजमाएँ:",
    "valid_email": "कृपया एक मान्य ईमेल पता दर्ज करें",
    "welcome_back": "वापसी पर स्वागत है",
    "welcome_title": "LetMeIn में आपका स्वागत है! 🎉",
    "work_city": "वह शहर जहां आप काम करते हैं"
  },
  "auto_test": {
    "card_1": {
      "button": "सभी संपत्तियां देखें",
      "desc": "अपने क्षेत्र में उपलब्ध संपत्तियों को ब्राउज़ करें।",
      "title": "रियल एस्टेट लिस्टिंग"
    },
    "card_2": {
      "button": "एआई खोज शुरू करें",
      "desc": "प्राकृतिक भाषा का उपयोग करके अपने सपनों का घर ढूंढें।",
      "title": "स्मार्ट एआई खोज"
    },
    "card_3": {
      "button": "सूचनाएं सक्षम करें",
      "desc": "जैसे ही कोई नया सौदा आपकी प्रोफ़ाइल से मेल खाता है, तुरंत सूचित हों।",
      "title": "तत्काल सूचनाएं"
    },
    "footer_message": "यह पृष्ठ 100% स्वचालित अनुवाद वर्कफ़्लो का परीक्षण करने के लिए बनाया गया था।",
    "page_subtitle": "देखें कि सिस्टम कैसे स्वचालित रूप से इस पूरे पृष्ठ का पता लगाता है, निकालता है और अनुवाद करता है।",
    "page_title": "एआई अनुवाद जादू"
  },
  "automation_test": {
    "action_button": "स्वचालन परीक्षण कार्रवाई बटन",
    "description": "स्वचालन परीक्षण विवरण",
    "title": "स्वचालन परीक्षण शीर्षक"
  },
  "billing": {
    "add_credits": "क्रेडिट जोड़ें",
    "amount": "राशि",
    "balance": "शेष राशि",
    "billing_country": "बिलिंग देश",
    "billing_locale": "बिलिंग और वॉलेट",
    "billing_locale_desc": "क्रेडिट और उपयोग के लिए आपका बिलिंग देश और वॉलेट मुद्रा।",
    "country_currency_mismatch_note": "जब क्रेडिट किसी और मुद्रा में जारी किए गए हों, तब आपकी वॉलेट मुद्रा बिलिंग देश से अलग हो सकती है।",
    "date": "दिनांक",
    "description": "विवरण",
    "est_cost": "अनुमानित लागत",
    "last_days": "पिछले {{days}} दिन",
    "ledger_description": "हालिया क्रेडिट लेनदेन",
    "near_cap_warning": "आप अपनी उपयोग सीमा के करीब हैं।",
    "no_transactions": "अभी तक कोई लेनदेन नहीं हुआ है।",
    "no_usage": "कोई उपयोग डेटा नहीं",
    "over_cap_warning": "आप अपनी उपयोग सीमा तक पहुँच चुके हैं। अगली अवधि तक आगे के शुल्क अवरुद्ध किए जा सकते हैं।",
    "showing_range": "{{total}} में से {{from}}–{{to}} दिखाए जा रहे हैं",
    "topup_success": "क्रेडिट सफलतापूर्वक जोड़े गए। आपका बैलेंस अपडेट हो गया है।",
    "total_calls": "कुल कॉल",
    "total_cost": "कुल लागत",
    "total_tokens": "कुल टोकन",
    "transaction_history": "लेनदेन इतिहास",
    "type": "प्रकार",
    "upgrade_plan": "प्लान अपग्रेड करें",
    "usage_cap": "उपयोग सीमा",
    "usage_cap_description": "आपकी योजना से वर्तमान अवधि की खर्च सीमा।",
    "usage_description": "अपने क्रेडिट बैलेंस, API उपयोग और लेनदेन इतिहास देखें।",
    "usage_this_period": "इस अवधि का उपयोग",
    "usage_title": "उपयोग और बिलिंग",
    "used_this_period": "इस अवधि में उपयोग किया गया",
    "wallet_currency": "वॉलेट मुद्रा"
  },
  "brokerage": {
    "actions": {
      "accept": "स्वीकार करें",
      "cancel_invite": "आमंत्रण रद्द करें",
      "decline": "अस्वीकार करें",
      "revoke_access": "पहुँच रद्द करें",
      "view_building": "भवन देखें"
    },
    "description": "अपने पोर्टफोलियो में संपत्ति असाइनमेंट, पेशेवर कनेक्शन और संचालन प्रबंधित करें।",
    "empty_states": {
      "invitations_desc": "आने वाले और जाने वाले अनुरोध यहां दिखाई देंगे।",
      "no_active": "अभी तक कोई सक्रिय असाइनमेंट नहीं है।",
      "no_invitations": "इस समय कोई लंबित निमंत्रण नहीं है।"
    },
    "invite_manager": "प्रबंधक को आमंत्रित करें",
    "labels": {
      "full_access": "पूर्ण परिचालन पहुँच",
      "incoming": "आवक",
      "invited_manager": "आमंत्रित: {{manager}}",
      "managed_by": "द्वारा प्रबंधित:",
      "manager_fallback": "प्रबंधक",
      "outgoing": "जावक",
      "owner": "मालिक:",
      "owner_fallback": "मालिक",
      "property_fallback": "संपत्ति",
      "requested_perms": "अनुरोधित अनुमतियाँ:"
    },
    "messages": {
      "status_update_failed": "आमंत्रण अपडेट करने में विफल रहा",
      "status_updated": "ब्रोकरेज संदेश स्थिति अपडेट की गई"
    },
    "modals": {
      "choose_manager": "-- एक प्रबंधक चुनें --",
      "choose_property": "-- एक संपत्ति चुनें --",
      "default_permissions": "डिफ़ॉल्ट अनुमतियाँ",
      "invite_desc": "अपनी संपत्ति को एक पेशेवर ब्रोकर से जोड़ें।",
      "invite_failed": "आमंत्रण भेजने में विफल रहा",
      "invite_success": "आमंत्रण सफलतापूर्वक भेजा गया!",
      "invite_title": "एक संपत्ति प्रबंधक को आमंत्रित करें",
      "no_managers": "सिस्टम में अभी तक कोई संपत्ति प्रबंधक नहीं मिला है।",
      "permissions_note": "प्रबंधक दैनिक कार्यों को देख और प्रबंधित कर सकते हैं लेकिन संपत्ति को हटा नहीं सकते हैं।",
      "select_manager": "संपत्ति प्रबंधक चुनें",
      "select_property": "संपत्ति चुनें",
      "send_invitation": "निमंत्रण भेजें",
      "sending": "भेजा जा रहा है..."
    },
    "permissions": {
      "edit_details": "विवरण संपादित करें",
      "manage_tenants": "किरायेदार प्रबंधित करें",
      "send_alerts": "अलर्ट भेजें"
    },
    "status": {
      "active": "सक्रिय",
      "managed": "प्रबंधित",
      "pending": "लंबित",
      "rejected": "अस्वीकृत",
      "revoked": "रद्द"
    },
    "tabs": {
      "active_portfolio": "सक्रिय पोर्टफोलियो",
      "invitations": "निमंत्रण",
      "maintenance": "रखरखाव"
    },
    "title": "ब्रोकरेज और प्राधिकरण"
  },
  "buttons": {
    "submit": "सबमिट करें"
  },
  "chat": {
    "add_credits": "क्रेडिट जोड़ें",
    "assistant_status": "आपका अगला घर खोजने के लिए तैयार",
    "assistant_title": "AI संपत्ति सहायक",
    "error_generic": "क्षमा करें, मुझे एक त्रुटि का सामना करना पड़ा। कृपया पुनः प्रयास करें।",
    "error_voice": "क्षमा करें, मुझे आपकी ध्वनि इनपुट को संसाधित करने में समस्या हुई।",
    "greeting": "नमस्ते! मैं आपको आपकी सही संपत्ति ढूंढने में मदद करने के लिए यहाँ हूँ। मुझे बताएं कि आप क्या ढूंढ रहे हैं - प्रकार, स्थान, बजट, सुविधाएं, या कोई विशेष आवश्यकताएँ।",
    "guest_limit_reached": "आप आज की मुफ्त संपत्ति खोज सीमा पहुँच चुके हैं। अधिक खोजों के लिए रजिस्टर या साइन इन करें।",
    "guest_limit_reached_mid": "या",
    "guest_limit_reached_prefix": "आप आज की निःशुल्क खोज सीमा तक पहुँच गए हैं।",
    "guest_limit_reached_suffix": "अधिक खोजों के लिए पंजीकरण या साइन इन करें, या कल पुनः प्रयास करें।",
    "history_title": "वार्तालाप इतिहास",
    "image_alert_size": "छवि 10 MB से कम होनी चाहिए।",
    "image_alert_type": "कृपया JPEG, PNG, या WebP छवि चुनें।",
    "image_input_placeholder": "स्थान संदर्भ जोड़ें जैसे कि \"गच्चीबौली के पास\" (वैकल्पिक)...",
    "image_search_badge": "छवि खोज",
    "image_search_failed_generic": "छवि खोज विफल। कृपया पुनः प्रयास करें।",
    "image_search_label": "🔍 छवि खोज",
    "input_placeholder": "अपना संदेश यहाँ टाइप करें...",
    "insufficient_balance": "आपका क्रेडिट बैलेंस समाप्त हो गया है। जारी रखने के लिए क्रेडिट जोड़ें।",
    "insufficient_balance_prefix": "आपका क्रेडिट बैलेंस समाप्त हो गया है।",
    "insufficient_balance_suffix": "जारी रखने के लिए।",
    "location_dialog": {
      "description": "आपके लिए सर्वोत्तम संपत्तियां खोजने के लिए, हमें यह जानना होगा कि आपकी किस शहर में रुचि है।",
      "footer": "आपका स्थान हमारे AI को आपके क्षेत्र में सटीक मिलान खोजने में मदद करता है।",
      "title": "स्थान आवश्यक है"
    },
    "may_take_a_while": "इसमें थोड़ा समय लग सकता है...",
    "my_location_unavailable": "आपका वर्तमान लोकेशन प्राप्त नहीं हुआ। ब्राउज़र में लोकेशन अनुमति सक्षम करें और पुनः प्रयास करें।",
    "new_chat": "नया चैट",
    "new_search": "नयी खोज",
    "posting_greeting": "नमस्ते! संपत्ति सूचीबद्ध करने में मदद के लिए यहाँ हूँ। पिनकोड या पूरा पता सबसे अच्छा है — या प्रकार, इलाका/शहर, मूल्य और फ़ोटो बताएँ।",
    "processing_details": "विवरण संसाधित हो रहा है…",
    "register": "पंजीकरण",
    "search": "खोजें",
    "search_by_image": "छवि से खोजें",
    "search_by_image_title": "छवि से खोजें",
    "search_conversations": "वार्तालाप खोजें…",
    "search_image": "छवि खोजें",
    "setting_up": "अगला चरण तैयार हो रहा है…",
    "sign_in": "साइन इन",
    "voice_label": "आवाज़",
    "wait_for_moment": "कृपया थोड़ा इंतज़ार करें..."
  },
  "checkout_page": {
    "actions": {
      "back_to_plans": "प्लान्स पर वापस जाएँ",
      "pay_amount": "{{amount}} भुगतान करें",
      "processing": "प्रोसेस हो रहा है..."
    },
    "error_state": {
      "title": "चेकआउट त्रुटि"
    },
    "errors": {
      "init_failed": "भुगतान प्रारंभ करने में विफल",
      "missing_plan": "प्लान जानकारी अनुपलब्ध है",
      "payment_failed": "भुगतान विफल",
      "subscription_create_failed": "भुगतान सफल रहा, लेकिन सदस्यता बनाना विफल हुआ। कृपया सहायता से संपर्क करें।"
    },
    "loading": {
      "preparing": "चेकआउट तैयार किया जा रहा है..."
    },
    "order_summary": {
      "billing": "बिलिंग:",
      "billing_fallback": "मासिक",
      "plan": "प्लान:",
      "plan_fallback": "प्लान",
      "selected_plan": "चयनित प्लान",
      "title": "ऑर्डर सारांश",
      "total": "कुल:"
    },
    "subtitle": "अपनी सदस्यता पूरी करने के लिए भुगतान विवरण दर्ज करें",
    "title": "अपना भुगतान पूरा करें"
  },
  "common": {
    "actions": "कार्य",
    "activate": "सक्रिय करें",
    "active": "सक्रिय",
    "add": "जोड़ें",
    "app_notifications": "इन-ऐप अलर्ट",
    "back": "वापस",
    "cancel": "रद्द करें",
    "checking": "जाँचा जा रहा है…",
    "close": "गतिविधि विंडो बंद करें",
    "confirm": "पुष्टि करें",
    "continue": "जारी रखें",
    "date": "दिनांक",
    "days": "दिन",
    "deactivate": "निष्क्रिय करें",
    "delete": "हटाएं",
    "done": "हो गया",
    "edit": "संपादित करें",
    "email": "ईमेल पता",
    "email_notifications": "ईमेल अलर्ट",
    "error_fetch_data": "ब्रोकरेज डेटा लोड करने में विफल रहा",
    "error_occurred": "एक त्रुटि हुई",
    "filter": "फ़िल्टर",
    "filter_all": "सभी",
    "first_name": "पहला नाम",
    "generating": "उत्पन्न हो रहा है...",
    "go_back": "पीछे जाएं",
    "id": "आईडी",
    "inactive": "निष्क्रिय",
    "is_required": "आवश्यक है",
    "language": "पसंदीदा भाषा",
    "last_name": "अंतिम नाम",
    "live": "लाइव",
    "load": "लोड करें",
    "loading": "लोड हो रहा है...",
    "loading_dashboard": "डैशबोर्ड लोड हो रहा है...",
    "mark_unverified": "असत्यापित करने के लिए क्लिक करें",
    "mark_verified": "सत्यापित करने के लिए क्लिक करें",
    "menu": "मेनू",
    "next": "अगला",
    "no": "नहीं",
    "no_results_desc": "कोई संपत्ति नहीं मिली। भिन्न खोज का प्रयास करें।",
    "no_results_found": "कोई परिणाम नहीं मिला",
    "not_available": "—",
    "off": "बंद",
    "on": "चालू",
    "organization": "संगठन",
    "pending": "पेंडिंग",
    "phone": "फ़ोन नंबर",
    "previous": "पिछला",
    "properties_found": "संपत्तियां मिलीं",
    "refresh": "ताज़ा करें",
    "remove": "हटाएँ",
    "required_fields": "आवश्यक क्षेत्र",
    "results": "परिणाम देखें",
    "retry": "पुनः प्रयास",
    "role": "प्राथमिक भूमिका",
    "save": "सहेजें",
    "save_changes": "परिवर्तन सहेजें",
    "saving": "सहेजा जा रहा है...",
    "search": "संपत्तियों को खोजें",
    "search_results": "खोज परिणाम",
    "searching_properties": "संपत्तियों की खोज की जा रही है...",
    "select": "",
    "select_all_that_apply": "",
    "send": "भेजें",
    "share": "शेयर",
    "skip": "",
    "status": "स्थिति",
    "statuses": {
      "completed": "पूरा हुआ",
      "error": "त्रुटि",
      "failed": "विफल",
      "healthy": "स्वस्थ",
      "not_checked": "जाँचा नहीं",
      "pending": "लंबित",
      "unconfigured": "कॉन्फिगर नहीं"
    },
    "submit": "",
    "system": "सिस्टम",
    "translating": "अनुवाद किया जा रहा है...",
    "try_again": "पुनः प्रयास करें",
    "type": "प्रकार",
    "update": "अपडेट करें",
    "username": "उपयोगकर्ता नाम",
    "verified": "ईमेल सत्यापन",
    "view": "देखें",
    "yes": "हाँ"
  },
  "compare_page": {
    "actions": {
      "browse_properties": "",
      "retry_search": ""
    },
    "empty": {
      "add_one_more": "",
      "no_base_hint": "",
      "no_base_selected": "",
      "no_recent_or_suggested": "",
      "no_search_results": "",
      "use_search_panels": ""
    },
    "errors": {
      "base_load_failed": "",
      "base_unavailable": "",
      "search_failed": "",
      "suggestions_load_failed": ""
    },
    "labels": {
      "base_property": "",
      "last_viewed": "",
      "property_n": "",
      "suggested_properties": ""
    },
    "loading": {
      "page": "",
      "suggestions": ""
    },
    "search": {
      "placeholder": ""
    },
    "side_by_side_title": "",
    "table": {
      "amenities": "",
      "bathrooms": "",
      "bedrooms": "",
      "built_up_area": "",
      "floor": "",
      "furnishing": "फर्निशिंग",
      "location": "",
      "price": "",
      "status": "",
      "type": ""
    },
    "title": ""
  },
  "contact_page": {
    "desc": "",
    "form_card": {
      "email": "",
      "error_failed": "",
      "error_fields": "",
      "first_name": "",
      "last_name": "",
      "message": "",
      "placeholder_email": "",
      "placeholder_first_name": "",
      "placeholder_last_name": "",
      "placeholder_message": "",
      "placeholder_subject": "",
      "subject": "",
      "submit_btn": "",
      "submitting_btn": "",
      "success_msg": "",
      "title": ""
    },
    "info_card": {
      "call_schedule": "",
      "call_title": "",
      "email_title": "",
      "title": "",
      "visit_address": "",
      "visit_title": ""
    },
    "title": ""
  },
  "currency": {
    "cr": "करोड़",
    "lakhs": "लाख"
  },
  "dashboard": {
    "aadhaar_reminder": {
      "cta": "अभी सत्यापित करें",
      "description": "लिस्टिंग और किरायेदार इंटरैक्शन में विश्वास बढ़ाने के लिए आधार सत्यापन पूरा करें।",
      "dismiss": "रिमाइंडर खारिज करें",
      "title": "आधार से अपनी पहचान सत्यापित करें"
    },
    "admin_desc": "सिस्टम एनालिटिक्स और प्रबंधन का अवलोकन।",
    "admin_title": "एडमिन डैशबोर्ड",
    "find_home_desc": "क्या आप अपना अगला घर ढूंढने के लिए तैयार हैं?",
    "find_home_title": "एआई खोज",
    "merged_desc": "घर खोजें, अपनी लिस्टिंग प्रबंधित करें और सब कुछ एक जगह ट्रैक करें।",
    "org_desc": "अपने संगठन और सदस्य गतिविधियों का प्रबंधन करें।",
    "org_title": "संगठन डैशबोर्ड",
    "own_property_desc": "अपनी संपत्ति की लिस्टिंग पोस्ट करें और मालिक खाते पर स्विच करें — हमारा एआई इसे तेज़ और आसान बनाता है।",
    "own_property_title": "क्या आपके पास संपत्ति है?",
    "owner_dashboard_title": "मालिक डैशबोर्ड",
    "pm_desc": "अपनी संपत्तियों और किरायेदार के इंटरैक्शन को ट्रैक करें।",
    "pm_title": "संपत्ति प्रबंधक डैशबोर्ड",
    "post_my_property": "मेरी संपत्ति पोस्ट करें",
    "recent_searches_desc": "आपकी पिछली एआई खोज की संपत्तियाँ",
    "recent_searches_title": "हाल की खोजें",
    "start_ai_search": "एआई खोज शुरू करें",
    "tenant_dashboard_title": "किरायेदार डैशबोर्ड",
    "tenant_desc": "आज आपके खाते में क्या हो रहा है, यह यहाँ है।",
    "welcome_back": "वापस स्वागत है, {{name}}"
  },
  "dashboard_page": {
    "title": "डैशबोर्ड",
    "welcome": "आपके डैशबोर्ड में आपका स्वागत है।"
  },
  "deleteUser": {
    "adminWarningDesc": "आप एक प्रशासनिक खाते को हटाने वाले हैं। इस कार्रवाई के लिए अतिरिक्त पुष्टि की आवश्यकता है और इसका सिस्टम पर महत्वपूर्ण प्रभाव पड़ता है।",
    "adminWarningTitle": "उच्च-विशेषाधिकार खाता",
    "cancel": "रद्द करें",
    "confirmMessage": "पुष्टि संदेश",
    "deactivate": "निष्क्रिय करें",
    "deleteButton": "हटाएँ बटन",
    "deleting": "हटाया जा रहा है...",
    "errorGeneric": "उपयोगकर्ता को हटाने में विफल। कृपया अपनी अनुमतियाँ जांचें।",
    "hardDelete": {
      "description": "स्थायी रूप से हटाने का विवरण",
      "title": "स्थायी रूप से हटाएँ"
    },
    "permanent": "स्थायी",
    "softDelete": {
      "description": "अस्थायी रूप से हटाने का विवरण",
      "title": "अस्थायी रूप से हटाएँ"
    },
    "title": "उपयोगकर्ता हटाएँ"
  },
  "demo": {
    "auto_test_all": "यह कुंजी स्वचालित रूप से अंग्रेजी, हिंदी और तेलुगु में दिखाई देनी चाहिए!",
    "buttons": {
      "later": "बाद में",
      "start": "शुरू करें"
    },
    "descriptions": {
      "main": "इस घटक का उपयोग यह प्रदर्शित करने के लिए किया जाता है कि i18next-parser कैसे काम करता है।"
    },
    "footer": {
      "info": {
        "v1": "डेमो संस्करण 1.0.0"
      }
    },
    "trans_demo": "आप अनुवादों के अंदर <1>HTML टैग</1> का भी उपयोग कर सकते हैं!",
    "welcome_title": "डेमो में आपका स्वागत है"
  },
  "example": {
    "description": "यह एक उदाहरण विवरण है।",
    "title": "उदाहरण शीर्षक",
    "trans_component": "यह एक अनुवाद योग्य घटक है।"
  },
  "favourites_page": {
    "empty_desc": "संपत्तियाँ देखना शुरू करें और यहाँ अपनी पसंद सहेजें!",
    "empty_title": "अभी कोई पसंद नहीं",
    "load_failed": "पसंद लोड करने में विफल",
    "loading": "आपकी पसंद लोड हो रही हैं...",
    "showing_one_one": "",
    "showing_one_other": "",
    "showing_other_one": "",
    "showing_other_other": "",
    "subtitle": "वे संपत्तियाँ जिन्हें आपने पसंद किया और बाद के लिए सहेजा",
    "title": "मेरी पसंद"
  },
  "features_page": {
    "badge": "",
    "create_account_btn": "",
    "cta_quote": "",
    "cta_title": "",
    "features": {
      "conversational_ui": "",
      "conversational_ui_desc": "",
      "instant_translation": "",
      "instant_translation_desc": "",
      "intelligent_matching": "",
      "intelligent_matching_desc": "",
      "market_insights": "",
      "market_insights_desc": "",
      "multilingual_support": "",
      "multilingual_support_desc": "",
      "owner_dashboard": "",
      "owner_dashboard_desc": "",
      "smart_ai_search": "",
      "smart_ai_search_desc": "",
      "verified_listings": "",
      "verified_listings_desc": "",
      "virtual_tours": "",
      "virtual_tours_desc": "",
      "voice_search": "",
      "voice_search_desc": ""
    },
    "hero_desc": "",
    "hero_title": "",
    "try_ai_btn": "",
    "view_pricing_btn": ""
  },
  "gemini_listing": {
    "badge_draft": "ड्राफ्ट",
    "badge_live": "लाइव",
    "collapse_sidebar": "साइडबार बंद करें",
    "hero": "आज आप कौन सी संपत्ति सूचीबद्ध कर रहे हैं?",
    "hero_hint": "जब संभव हो पिनकोड या पता पहले बताएं; अन्यथा प्रकार, इलाका, शहर, मूल्य, फ़ोटो या PG/व्यावसायिक विवरण — चैट करते समय पूर्वावलोकन अपडेट होता है।",
    "list_new_property": "नई संपत्ति सूचीबद्ध करें",
    "location_pick_catalog_hint": "आपके सक्षम स्थानों से — एक चुनें, नंबर टाइप करें, या कोई फिट न हो तो मानचित्र पर खोजें।",
    "location_pick_choose_city_hint": "कई शहर मेल खाते हैं — पहले अपना शहर चुनें, फिर आप अपना इलाका चुनेंगे।",
    "location_pick_cities_heading": "अपना शहर चुनें",
    "location_pick_decline": "इनमें से कोई नहीं — मानचित्र पर खोजें",
    "location_pick_decline_user": "इनमें से कोई नहीं — मानचित्र पर खोजें",
    "location_pick_kind_city": "शहर",
    "location_pick_kind_locality": "क्षेत्र",
    "location_pick_localities_heading": "लोकैलिटी / पड़ोस",
    "location_pick_localities_in_metro": "{{metro}} में क्षेत्र",
    "location_pick_map_hint": "मानचित्र मिलान — एक चुनें या नंबर टाइप करें।",
    "location_pick_matching_cities": "मिलते शहर: {{cities}}",
    "location_pick_next": "और लोड करें",
    "location_pick_next_user": "और लोकैलिटी लोड करें",
    "location_pick_page_num": "पृष्ठ {{page}} / {{pages}}",
    "location_pick_page_range": "{{total}} में से {{start}}–{{end}} लोकैलिटी",
    "location_pick_prev": "पिछला",
    "location_pick_prev_user": "पिछली लोकैलिटी",
    "nav_menu": "मेनू",
    "no_listings_yet": "अभी कोई ड्राफ्ट या लिस्टिंग नहीं। बनाने के लिए चैट शुरू करें।",
    "open_preview": "पूर्वावलोकन",
    "placeholder": "अपनी संपत्ति का विवरण दें (प्रकार, स्थान, मूल्य, आकार) या पिनकोड/पता दर्ज करें…",
    "publishing_splash_subtitle": "विवरण को अंतिम रूप दिया जा रहा है और आपका लाइव पेज तैयार किया जा रहा है…",
    "publishing_splash_title": "आपकी प्रॉपर्टी लिस्टिंग सबमिट की जा रही है...",
    "recent_listings": "हाल की लिस्टिंग",
    "sidebar_title": "मेरी लिस्टिंग्स",
    "untitled_published": "सूचीबद्ध संपत्ति"
  },
  "genui_playground": {
    "area_details_confirmed": "",
    "documents_uploaded_message": "मैंने {{count}} दस्तावेज़{{suffix}} अपलोड किए हैं",
    "error_connecting_backend": "❌ GenUI बैकएंड से कनेक्ट करने में त्रुटि।",
    "images_uploaded_message": "मैंने {{count}} छवि{{suffix}} अपलोड की हैं",
    "maintenance_confirmed": "रखरखाव: {{amount}} ({{frequency}})",
    "maintenance_included": "रखरखाव शामिल",
    "pg_available_from": "",
    "pg_common_amenities_selected": "",
    "pg_common_amenities_skip": "",
    "pg_detail_beds_per_room_one": "",
    "pg_detail_beds_per_room_other": "",
    "pg_detail_deposit": "",
    "pg_detail_rent": "",
    "pg_detail_rooms_one": "",
    "pg_detail_rooms_other": "",
    "pg_food_no": "",
    "pg_food_yes": "",
    "pg_food_yes_meals": "",
    "pg_gate_closing_none": "",
    "pg_gate_closing_set": "",
    "pg_present_in_selected": "",
    "pg_room_facilities_selected": "",
    "pg_room_facilities_skip": "",
    "pg_rules_selected": "",
    "pg_rules_skip": "",
    "pg_services_confirmed": "",
    "pg_sharing_types_selected": "",
    "pg_tenant_preference": "",
    "pg_usp_added": "",
    "pg_usp_skip": "",
    "preferred_tenants_selected": "पसंदीदा किराएदार: {{list}}",
    "preferred_tenants_skip": "पसंदीदा किराएदार: कोई नहीं",
    "title": "GenUI प्लेग्राउंड"
  },
  "genui_widgets": {
    "age_of_construction": {
      "options": {
        "10_to_15_years": "10 से 15 वर्ष",
        "15_to_20_years": "15 से 20 वर्ष",
        "5_to_10_years": "5 से 10 वर्ष",
        "above_20_years": "20 वर्ष से अधिक",
        "less_than_5_years": "5 वर्ष से कम",
        "new_construction": "नया निर्माण",
        "not_available": "",
        "single_phase": "",
        "three_phase": ""
      },
      "placeholder": "चुनें",
      "title": "निर्माण की आयु"
    },
    "amenities": {
      "add_your_own": "अपनी जोड़ें",
      "confirm": "चयन की पुष्टि करें",
      "custom_placeholder": "उदा. छत पर टेरेस...",
      "items": {
        "balcony": "बालकनी",
        "children_play_area": "बच्चों का खेल क्षेत्र",
        "clubhouse": "क्लबहाउस",
        "garden": "बगीचा",
        "gas_pipeline": "गैस पाइपलाइन",
        "gymnasium": "जिम",
        "internet_wifi": "इंटरनेट/Wi-Fi",
        "lift": "लिफ्ट",
        "maintenance_staff": "रखरखाव कर्मचारी",
        "park": "पार्क",
        "parking": "पार्किंग",
        "power_backup": "पावर बैकअप",
        "rain_water_harvesting": "वर्षा जल संचयन",
        "reserved_parking": "आरक्षित पार्किंग",
        "security_24x7": "24x7 सुरक्षा",
        "swimming_pool": "स्विमिंग पूल",
        "visitor_parking": "आगंतुक पार्किंग",
        "water_storage": "पानी का भंडारण"
      },
      "selected_count_one": "{{count}} चयनित",
      "selected_count_other": "{{count}} चयनित",
      "title": "सुविधाएँ चुनें"
    },
    "area_details": {
      "confirm": "क्षेत्र की पुष्टि करें",
      "error_ordering": "कृपया सुनिश्चित करें कि कारपेट एरिया ≤ बिल्ट-अप एरिया ≤ सुपर बिल्ट-अप एरिया हो, और सुपर बिल्ट-अप एरिया बिल्ट-अप एरिया से अधिक होना चाहिए।",
      "error_positive": "एरिया मान 0 से अधिक होना चाहिए।",
      "error_units": "कृपया सुनिश्चित करें कि सभी एरिया फ़ील्ड एक ही मापन इकाई का उपयोग करते हैं।",
      "help": "क्षेत्र सहायता",
      "help_text": "कम से कम एक क्षेत्र दर्ज करें। कालीन, बिल्ट-अप और सुपर बिल्ट-अप जोड़ सकते हैं।",
      "mandatory": "कम से कम एक क्षेत्र प्रकार अनिवार्य है",
      "plot": "प्लॉट क्षेत्र",
      "title": "क्षेत्र विवरण जोड़ें",
      "total": "कुल क्षेत्र"
    },
    "area_input": {
      "confirm": "क्षेत्र की पुष्टि करें",
      "placeholder": "उदा. 1500",
      "title": "संपत्ति का आकार",
      "units": {
        "acres": "एकड़",
        "bigha": "बीघा",
        "cents": "सेंट",
        "guntas": "गुंठा",
        "marla": "मरला",
        "sqft": "वर्ग फुट",
        "sqyd": "वर्ग गज"
      }
    },
    "area_type": {
      "built_up": "बिल्ट-अप क्षेत्र",
      "carpet": "कार्पेट क्षेत्र",
      "plot": "प्लॉट क्षेत्र",
      "super_built_up": "सुपर बिल्ट-अप क्षेत्र",
      "title": "क्षेत्र प्रकार"
    },
    "available_from": {
      "immediately": "तुरंत",
      "month_year": "या महीना / वर्ष दर्ज करें",
      "placeholder": "उदा. जून 2026",
      "title": "उपलब्धता से"
    },
    "booking_token_amount": {
      "confirm": "पुष्टि करें",
      "placeholder": "उदा. 100000",
      "title": "बुकिंग / टोकन राशि"
    },
    "commercial_furnishing": {
      "title": "फर्निशिंग स्थिति"
    },
    "commercial_subtype": {
      "commercial_land": "व्यावसायिक भूमि",
      "commercial_office_space": "व्यावसायिक कार्यालय स्थान",
      "commercial_shop": "व्यावसायिक दुकान",
      "commercial_showroom": "व्यावसायिक शोरूम",
      "industrial_building": "औद्योगिक भवन",
      "industrial_land": "औद्योगिक भूमि",
      "industrial_shed": "औद्योगिक शेड",
      "office_it_park_sez": "आईटी पार्क / SEZ में कार्यालय",
      "title": "व्यावसायिक संपत्ति प्रकार",
      "warehouse_godown": "गोदाम / गोदाम"
    },
    "commercial_zone": {
      "agricultural_zone": "कृषि क्षेत्र",
      "commercial": "व्यावसायिक",
      "government_use": "सरकारी उपयोग",
      "industrial": "औद्योगिक",
      "natural_conservation_zone": "प्राकृतिक संरक्षण क्षेत्र",
      "open_spaces": "खुले स्थान",
      "public_semi_public": "सार्वजनिक और अर्ध-सार्वजनिक उपयोग",
      "public_utilities": "सार्वजनिक उपयोगिताएँ",
      "residential": "आवासीय",
      "special_economic_zone": "विशेष आर्थिक क्षेत्र",
      "title": "भूमि ज़ोनिंग",
      "transport_communication": "परिवहन और संचार"
    },
    "connectivity": {
      "add_your_own": "अपनी जोड़ें",
      "continue_one": "जारी रखें ({{count}} चयनित)",
      "continue_other": "जारी रखें ({{count}} चयनित)",
      "items": {
        "airport": "एयरपोर्ट",
        "bus_stop": "बस स्टॉप",
        "highway_orr": "हाईवे/ORR",
        "main_road": "मुख्य सड़क",
        "metro_station": "मेट्रो स्टेशन",
        "nearby_landmark": "नज़दीकी लैंडमार्क"
      },
      "placeholder": "उदा. हाईटेक सिटी मेट्रो - 5 मिनट",
      "selected_count_one": "{{count}} चयनित",
      "selected_count_other": "{{count}} चयनित",
      "skip": "छोड़ें",
      "title": "कनेक्टिविटी"
    },
    "counter": {
      "confirm_one": "{{count}} {{label}} की पुष्टि करें",
      "confirm_other": "{{count}} {{label}} की पुष्टि करें",
      "labels": {
        "balconies_one": "बालकनी",
        "balconies_other": "बालकनी",
        "bathrooms_one": "बाथरूम",
        "bathrooms_other": "बाथरूम",
        "bedrooms_one": "बेडरूम",
        "bedrooms_other": "बेडरूम",
        "lifts_one": "लिफ्ट/एलिवेटर",
        "lifts_other": "लिफ्ट/एलिवेटर",
        "open_sides_one": "खुला किनारा",
        "open_sides_other": "खुले किनारे",
        "total_floors_one": "कुल मंजिल",
        "total_floors_other": "कुल मंजिलें"
      },
      "skip": "छोड़ें"
    },
    "extra_pantry": {
      "dry_pantry": "ड्राई पैंट्री",
      "not_available": "उपलब्ध नहीं",
      "wet_pantry": "वेट पैंट्री"
    },
    "facing": {
      "east": "पूर्व",
      "north": "उत्तर",
      "north_east": "उत्तर-पूर्व",
      "north_west": "उत्तर-पश्चिम",
      "south": "दक्षिण",
      "south_east": "दक्षिण-पूर्व",
      "south_west": "दक्षिण-पश्चिम",
      "title": "संपत्ति का मुख",
      "west": "पश्चिम"
    },
    "floor_details": {
      "ground_floor": "ग्राउंड फ्लोर",
      "title": "मंजिल और भवन विवरण"
    },
    "furnishing": {
      "fully_furnished": "पूर्ण सुसज्जित",
      "fully_sub": "फर्नीचर और उपकरण के साथ मूव-इन तैयार",
      "semi_furnished": "अर्ध सुसज्जित",
      "semi_sub": "बुनियादी फिटिंग; अपना फर्नीचर लाएँ",
      "title": "फर्निशिंग स्थिति",
      "unfurnished": "बिना फर्नीचर",
      "unfurnished_sub": "खाली यूनिट; कोई फर्नीचर शामिल नहीं"
    },
    "ideal_for_businesses": {
      "title": "व्यवसायों के लिए उपयुक्त"
    },
    "locality_tier": {
      "developed": "विकसित इलाके",
      "developed_sub": "परिपक्व सुविधाओं वाले स्थापित आवासीय और व्यावसायिक हब",
      "label": "लोकेलिटी टियर",
      "premium": "प्रीमियम इलाके",
      "premium_sub": "शीर्ष स्तरीय जीवनशैली वाले प्रीमियम/लग्ज़री इलाके",
      "subtitle": "वह टियर चुनें जो इस क्षेत्र का सबसे अच्छा वर्णन करे",
      "tier_1": "टियर 1 प्राइम / लक्ज़री",
      "tier_2": "टियर 2 विकसित / परिपक्व",
      "tier_3": "टियर 3 उभरते / विकासशील",
      "title": "लोकेलिटी वर्गीकरण",
      "upcoming": "आगामी इलाके",
      "upcoming_sub": "उच्च विकास क्षमता, विकसित हो रहा इंफ्रा और भविष्य की वृद्धि"
    },
    "location": {
      "allow_or_pick": "लोकेशन अनुमति दें या अपना देश चुनें। लोकेलिटी और पिनकोड उसी देश में रहेंगे।",
      "area_label": "क्षेत्र / पड़ोस",
      "label": "स्थान / पड़ोस",
      "placeholder": "उदा. गाचीबोवलि",
      "press_enter": "लोकेशन पुष्टि करने के लिए Enter दबाएं",
      "press_enter_locality": "लोकेलिटी पुष्टि करने के लिए Enter दबाएं या खोज पर क्लिक करें",
      "searching_in": "यहाँ खोज रहे हैं",
      "set_country_first": "पहले अपना देश सेट करें",
      "use_current": "मेरा वर्तमान लोकेशन उपयोग करें"
    },
    "maintenance_charges": {
      "amount_label": "रखरखाव शुल्क",
      "amount_placeholder": "रखरखाव शुल्क",
      "confirm": "पुष्टि करें",
      "frequency": {
        "monthly": "मासिक",
        "one_time": "एक बार",
        "per_sq_unit_monthly": "प्रति वर्ग इकाई मासिक",
        "quarterly": "त्रैमासिक",
        "yearly": "वार्षिक"
      },
      "included_hint": "किराये में रखरखाव शामिल है — अलग शुल्क नहीं।",
      "included_hint_sale": "अलग रखरखाव शुल्क नहीं — शामिल है या लागू नहीं।",
      "included_label": "रखरखाव शामिल",
      "per_label": "प्रति",
      "skip": "छोड़ें",
      "title": "रखरखाव शुल्क"
    },
    "maintenance_frequency": {
      "title": "रखरखाव आवृत्ति"
    },
    "media": {
      "add": "जोड़ें",
      "add_anyway": "वास्तव में, फोटो या वीडियो जोड़ें",
      "add_photos": "फोटो या वीडियो टूर जोड़ें",
      "click_or_drag": "यहाँ क्लिक करें या फ़ाइलें खींचें",
      "documents_hint": "(ब्रोशर, फ़्लोर प्लान, कानूनी दस्तावेज़)",
      "documents_title": "संपत्ति दस्तावेज़",
      "documents_types": "PDF, DOC, DOCX, XLS, XLSX, JPG, PNG · प्रत्येक {{mb}} MB तक",
      "done": "हो गया",
      "file_too_large": "फ़ाइल बहुत बड़ी है (अधिकतम {{mb}} MB)",
      "limit_partial": "{{max}} सीमा के अंदर रहने के लिए केवल {{remaining}} ऑइटम जोड़े जा सके।",
      "limit_reached": "अधिकतम {{max}} मीडिया आइटम पहुँच चुके हैं (फोटो + वीडियो टूर)।",
      "no_media": "कोई मीडिया नहीं",
      "no_media_ok": "कोई मीडिया नहीं — कोई बात नहीं!",
      "photos_formats": "फोटो (JPEG, PNG) · वीडियो (अधिकतम {{mb}}MB)",
      "preview_alt": "पूर्वावलोकन",
      "remove": "हटाएं",
      "skip": "छोड़ें",
      "skip_media": "मीडिया छोड़ें",
      "summary_none": "अभी कोई मीडिया नहीं (अधिकतम {{max}})",
      "summary_photos_one": "{{photos}} फोटो ({{count}}/{{max}})",
      "summary_photos_other": "",
      "summary_photos_one_one": "",
      "summary_photos_one_other": "",
      "summary_photos_video_one": "{{photos}} फोटो, 1 वीडियो ({{count}}/{{max}})",
      "summary_photos_video_other": "",
      "summary_photos_video_one_one": "",
      "summary_photos_video_one_other": "",
      "summary_video_one": "",
      "summary_video_other": "",
      "unsupported_type": "असमर्थित फ़ाइल प्रकार",
      "upload": "अपलोड करें",
      "upload_one": "{{count}} दस्तावेज़ अपलोड करें",
      "upload_n_one": "",
      "upload_n_other": "",
      "upload_one_one": "",
      "upload_one_other": "",
      "video": "वीडियो",
      "video_too_large": "वीडियो \"{{name}}\" {{mb}} MB सीमा बड़ी है।"
    },
    "mode_selector": {
      "rent": "किराया / लीज़",
      "rent_hint": "मैं किराए पर देना चाहता/चाहती हूँ",
      "sell": "बिक्री",
      "sell_hint": "मैं संपत्ति बेचना चाहता/चाहती हूँ"
    },
    "nearby_businesses": {
      "items": {
        "bank": "बैंक",
        "cafe": "कैफ़े",
        "clinic": "क्लिनिक",
        "hospital": "अस्पताल",
        "mall": "मॉल",
        "pharmacy": "फार्मेसी",
        "restaurant": "रेस्तरां",
        "retail_shops": "रिटेल दुकानें",
        "school": "स्कूल"
      },
      "title": "आसपास के व्यवसाय"
    },
    "nearby_places": {
      "add_your_own": "अपनी जोड़ें",
      "continue_one": "जारी रखें ({{count}} चयनित)",
      "continue_other": "जारी रखें ({{count}} चयनित)",
      "items": {
        "gym": "जिम",
        "hospital": "अस्पताल",
        "park": "पार्क",
        "restaurant": "रेस्तरां",
        "school": "स्कूल",
        "shopping_mall": "शॉपिंग मॉल"
      },
      "placeholder": "उदा. अपोलो अस्पताल - 2 किमी",
      "selected_count_one": "{{count}} चयनित",
      "selected_count_other": "{{count}} चयनित",
      "skip": "छोड़ें",
      "title": "आस-पास के स्थान"
    },
    "number_input": {
      "booking_token_amount": "बुकिंग / टोकन राशि",
      "ceiling_height": "छत की ऊँचाई (फीट)",
      "confirm": "पुष्टि करें",
      "entrance_width": "प्रवेश द्वार की चौड़ाई (फीट)",
      "example_prefix": "उदा.",
      "floor_number": "मंजिल संख्या",
      "floors_allowed_for_construction": "अनुमत मंजिलें",
      "open_sides": "खुले किनारे",
      "parking_spots": "पार्किंग स्थान",
      "plot_breadth": "प्लॉट की चौड़ाई (फीट)",
      "plot_length": "प्लॉट की लंबाई (फीट)",
      "road_width": "सड़क की चौड़ाई",
      "road_width_facing_plot": "प्लॉट के सामने सड़क",
      "total_floors": "भवन की कुल मंजिलें",
      "washroom_count": "वॉशरूम संख्या"
    },
    "ownership": {
      "freehold": "फ्रीहोल्ड",
      "freehold_sub": "भूमि और संरचना दोनों का पूर्ण स्वामित्व, कोई समय सीमा नहीं",
      "label": "स्वामित्व",
      "leasehold": "लीज़होल्ड",
      "leasehold_sub": "सरकार या मकान मालिक द्वारा निश्चित अवधि के लिए स्वामित्व",
      "poa": "पावर ऑफ अटॉर्नी",
      "poa_sub": "कानूनी पावर ऑफ़ अटॉर्नी के माध्यम से बिक्री अधिकार",
      "society": "सहकारी सोसाइटी",
      "society_sub": "पंजीकृत हाउसिंग सहकारी सोसाइटी के माध्यम से शेयर और हस्तांतरण अधिकार",
      "subtitle": "संपत्ति का कानूनी शीर्षक / स्वामित्व स्थिति चुनें",
      "title": "स्वामित्व प्रकार"
    },
    "parking": {
      "confirm": "पुष्टि करें",
      "options": {
        "bike": "सिर्फ बाइक",
        "bike_sub": "केवल दोपहिया वाहन पार्किंग",
        "both": "दोनों (कार और बाइक)",
        "both_sub": "कार और दोपहिया वाहन के लिए जगह",
        "car": "सिर्फ कार",
        "car_sub": "केवल चार पहिया वाहन पार्किंग",
        "none": "कोई पार्किंग नहीं",
        "none_sub": "कोई समर्पित वाहन पार्किंग नहीं"
      },
      "skip": "छोड़ें",
      "slots_label": "कार पार्किंग स्लॉट",
      "subtitle": "उपलब्ध वाहन पार्किंग चुनें",
      "title": "पार्किंग सुविधा"
    },
    "pg_available_from": {
      "confirm": "पुष्टि करें",
      "immediately": "तुरंत",
      "or_custom": "या महीना / वर्ष दर्ज करें",
      "placeholder": "उदा. जून 2026",
      "section_label": "उपलब्धता से"
    },
    "pg_available_services": {
      "confirm": "पुष्टि करें",
      "laundry": "लॉन्ड्री",
      "room_cleaning": "कमरे की सफाई",
      "subtitle": "आपके PG में किराएदारों के लिए कौन-सी सेवाएँ उपलब्ध हैं?",
      "title": "उपलब्ध सेवाएँ",
      "warden": "वार्डन सुविधा"
    },
    "pg_common_amenities": {
      "confirm": "पुष्टि करें",
      "fridge": "फ्रिज",
      "gym": "जिम",
      "kitchen": "रसोई",
      "lift": "लिफ्ट",
      "microwave": "माइक्रोवेव",
      "power_backup": "पावर बैकअप",
      "ro_water": "आरओ पानी",
      "skip": "छोड़ें",
      "subtitle": "अपने PG के साझा क्षेत्रों में उपलब्ध सभी सुविधाएँ चुनें",
      "title": "साझा क्षेत्र सुविधाएँ",
      "tv": "टीवी",
      "wifi": "वाई-फाई"
    },
    "pg_food": {
      "confirm": "पुष्टि करें",
      "meals": {
        "breakfast": "नाश्ता",
        "dinner": "रात का खाना",
        "lunch": "दोपहर का खाना"
      },
      "meals_label": "कौन से भोजन? (वैकल्पिक)",
      "subtitle": "क्या आपका PG किरायेदारों के लिए भोजन प्रदान करता है?",
      "title": "भोजन उपलब्ध"
    },
    "pg_gate_closing": {
      "confirm": "पुष्टि करें",
      "field_label": "गेट बंद होने का समय",
      "none": "कोई गेट क्लोजिंग नहीं",
      "placeholder": "समय चुनें",
      "title": "किरायेदारों को PG में इससे पहले लौटना होगा"
    },
    "pg_occupancy": {
      "available_floors": "उपलब्ध मंजिलें (वैकल्पिक)",
      "beds_per_room": "प्रति कमरे बिस्तरों की संख्या",
      "confirm_details": "पुष्टि करें",
      "continue": "जारी रखें",
      "deposit_per_bed": "प्रति बिस्तर सिक्योरिटी डिपॉजिट (₹)",
      "double": "डबल",
      "double_title": "डबल शेयरिंग (2 बिस्तर)",
      "four": "चार",
      "four_title": "चार शेयरिंग (4 बिस्तर)",
      "other": "अन्य",
      "other_title": "कस्टम / डॉर्मिटरी लेआउट",
      "rent_details_for": "{{type}} रूम के लिए किराया विवरण",
      "rent_per_bed": "प्रति बिस्तर मासिक किराया (₹)",
      "rooms_count": "PG में {{type}} रूम की संख्या",
      "selected_count": "{{count}} चयनित",
      "selected_count_one": "{{count}} चयनित",
      "selected_count_other": "{{count}} चयनित",
      "sell_details_for": "{{type}} शेयरिंग के लिए कमरे",
      "single": "सिंगल",
      "single_title": "सिंगल ऑक्यूपेंसी (1 बिस्तर)",
      "step_hint": "{{remaining}} विकल्प शेष",
      "subtitle": "आप जो भी शेयरिंग विकल्प देते हैं, सभी चुनें",
      "title": "अधिभोग विवरण",
      "triple": "ट्रिपल",
      "triple_title": "ट्रिपल शेयरिंग (3 बिस्तर)"
    },
    "pg_present_in": {
      "independent_building": "एक स्वतंत्र भवन",
      "independent_flats": "एक स्वतंत्र फ्लैट",
      "society": "सोसाइटी में स्थित",
      "title": "PG कहाँ स्थित है"
    },
    "pg_room_facilities": {
      "ac": "एसी",
      "air_cooler": "एयर कूलर",
      "balcony": "अटैच्ड बालकनी",
      "confirm": "पुष्टि करें",
      "copy_notice": "{{type}} जैसी ही सुविधाएँ लागू करें",
      "cot": "खाट",
      "cupboard": "अलमारी",
      "geyser": "गीज़र",
      "locked_notice": "पिछले कमरे से सुविधाएँ चुनी और लॉक की गईं",
      "mattress": "गद्दा",
      "same_as_previous": "पिछले कमरे जैसा ही",
      "side_table": "साइड टेबल",
      "skip": "छोड़ें",
      "subtitle": "प्रत्येक कमरे में उपलब्ध सभी सुविधाएँ चुनें",
      "subtitle_for_type": "{{type}} शेयरिंग कमरों में उपलब्ध सुविधाएँ चुनें",
      "title": "कमरे की सुविधाएँ",
      "title_for_type": "कमरे की सुविधाएँ — {{type}}",
      "tv": "टीवी",
      "washrooms": "वॉशरूम"
    },
    "pg_rules": {
      "confirm": "पुष्टि करें",
      "no_drinking": "शराब निषेध",
      "no_guardian": "अभिभावक नहीं",
      "no_opposite_gender": "विपरीत लिंग निषेध",
      "no_smoking": "धूम्रपान निषेध",
      "skip": "छोड़ें",
      "subtitle": "अपने PG पर लागू सभी नियम चुनें",
      "title": "PG नियम",
      "veg_only": "केवल शाकाहारी"
    },
    "pg_tenant_preference": {
      "both": "दोनों",
      "professionals": "प्रोफेशनल्स",
      "student": "स्टूडेंट",
      "subtitle": "आप किरायेदार के रूप में किसे पसंद करते हैं?",
      "title": "किरायेदार प्राथमिकताएँ"
    },
    "pg_usp": {
      "added": "जोड़े गए USP",
      "confirm": "पुष्टि करें",
      "examples_title": "उदाहरण USP",
      "heading": "अपने PG के बारे में और बताएँ",
      "placeholder": "उदा. मेट्रो स्टेशन के पास",
      "select_category": "श्रेणी चुनें",
      "skip": "छोड़ें",
      "subtitle": "अपने PG का USP लिखें",
      "write_usp": "PG USP लिखें"
    },
    "possession_status": {
      "ready_to_move": "रहने के लिए तैयार",
      "title": "कब्ज़े की स्थिति",
      "under_construction": "निर्माणाधीन"
    },
    "power_supply": {
      "options": {
        "not_available": "उपलब्ध नहीं",
        "single_phase": "सिंगल फेज",
        "three_phase": "थ्री फेज"
      },
      "title": "बिजली आपूर्ति"
    },
    "preferred_tenants": {
      "anyone": "कोई भी",
      "bachelor_female": "बैचलर महिला",
      "bachelor_male": "बैचलर पुरुष",
      "company": "कंपनी",
      "confirm": "पुष्टि करें",
      "family": "परिवार",
      "subtitle": "आप किसे किराए पर देना चाहते हैं? लागू होने वाले सभी चुनें।",
      "title": "पसंदीदा किराएदार"
    },
    "price_input": {
      "confirm": "कीमत की पुष्टि करें",
      "placeholder": "राशि दर्ज करें",
      "price_negotiable": "कीमत पर बातचीत संभव है",
      "quick_picks": "त्वरित विकल्प",
      "rent_suffix": "/ महीना",
      "title": "अपनी कीमत सेट करें"
    },
    "property_address": {
      "confirm": "पता पुष्टि करें",
      "confirmed_message": "संपत्ति का पता पुष्टि किया गया",
      "pinned_verified": "पिन सत्यापित",
      "preview": "पता पूर्वावलोकन",
      "show_map_pin_desc_off": "संपत्ति खोज परिणामों में दिखती रहेगी, लेकिन मानचित्र पिन छिपा रहेगा।",
      "show_map_pin_desc_on": "खरीदारों/किरायेदारों के लिए खोज मानचित्र पर आपका सटीक लाल पिन दिखेगा।",
      "show_map_pin_label": "खोज मानचित्र पर पता दिखाएँ",
      "subtitle": "नीचे अपने पूरे डाक पते की पुष्टि या सुधार करें।",
      "title": "संपत्ति का पता विवरण"
    },
    "property_map_pin": {
      "address_unavailable": "इस पिन के लिए सड़क पता नहीं मिल सका। अपनी Google Maps कुंजी पर Places API और Geocoding API सक्षम करें, फिर पुनः प्रयास करें।",
      "approx_location": "अनुमानित नेटवर्क स्थान दिखाया जा रहा है। सटीक पिन के लिए ब्राउज़र GPS सक्षम करें।",
      "area_not_found": "वह क्षेत्र नहीं मिला। पड़ोस का नाम, लैंडमार्क या पूरा पता आज़माएँ।",
      "area_search_failed": "क्षेत्र खोज विफल। कनेक्शन जाँचें और पुनः प्रयास करें।",
      "area_search_label": "मानचित्र पर क्षेत्र खोजें",
      "area_search_placeholder": "लोकेलिटी, लैंडमार्क या पता खोजें",
      "confirm": "स्थान की पुष्टि करें",
      "confirmed_message": "संपत्ति स्थान की पुष्टि हो गई",
      "confirming": "सहेजा जा रहा है…",
      "edit_subtitle": "जगह खोजें, मानचित्र पैन करें या पिन खींचें। पिन मानचित्र केंद्र से सिंक रहता है।",
      "edit_title": "संपत्ति स्थान संपादित करें",
      "exit_fullscreen": "फ़ुलस्क्रीन से बाहर (Esc)",
      "fullscreen": "फ़ुलस्क्रीन",
      "latitude": "अक्षांश",
      "live_location_found": "आपका लाइव स्थान दिखाया जा रहा है",
      "locate_me": "मेरा लाइव स्थान",
      "longitude": "देशांतर",
      "osm_address_unavailable": "इस पिन के लिए सड़क पता नहीं मिल सका। पिन थोड़ा हिलाएँ या नेटवर्क जाँचें।",
      "recenter_pin": "संपत्ति पिन पर केंद्रित करें",
      "save_location": "स्थान सहेजें",
      "select_location": "अपनी संपत्ति का पिन रखने के लिए मानचित्र पर खींचें या टैप करें",
      "subtitle": "जगह खोजें, फिर मानचित्र पैन करें या पिन खींचकर सटीक स्थान चिह्नित करें।",
      "title": "अपनी संपत्ति का स्थान पिन करें"
    },
    "rera": {
      "approved": "रेरा स्वीकृत",
      "chat_confirmed_no": "रेरा पंजीकृत नहीं",
      "chat_confirmed_with_id": "रेरा पंजीकृत: हाँ (आईडी: {{id}})",
      "chat_confirmed_yes": "रेरा पंजीकृत: हाँ",
      "chat_skipped": "रेरा छोड़ें",
      "confirm_button": "पुष्टि करें और आगे बढ़ें",
      "id_label": "रेरा पंजीकरण आईडी / संख्या",
      "id_placeholder": "उदा. P02400001234",
      "label": "रेरा स्थिति",
      "not_registered": "रेरा पंजीकृत नहीं",
      "registered": "रेरा पंजीकृत",
      "skip": "छोड़ें",
      "subtitle": "क्या यह संपत्ति रेरा स्वीकृत / पंजीकृत है?",
      "title": "रेरा पंजीकरण",
      "unregistered_sub": "छूट प्राप्त या पंजीकरण लंबित",
      "verified_sub": "क्रेता का विश्वास और अनुपालन बढ़ाता है"
    },
    "sale_type": {
      "label": "बिक्री प्रकार",
      "new": "नई",
      "new_sub": "बिल्डर/डेवलपर से सीधे नई संपत्ति",
      "resale": "पुनर्विक्रय",
      "resale_sub": "वर्तमान मालिक द्वारा पुनर्विक्रय की जा रही पहले से स्वामित्व वाली संपत्ति",
      "subtitle": "यह नई बुकिंग है या पुनर्विक्रय, बताएँ",
      "title": "बिक्री प्रकार"
    },
    "security_deposit": {
      "confirm": "पुष्टि करें",
      "placeholder": "उदा. 10000 या 0",
      "title": "सुरक्षा जमा"
    },
    "submit_success": {
      "list_another": "और संपत्ति लिस्ट करें",
      "subtitle": "आपकी संपत्ति LetMeIn मार्केटप्लेस पर पोस्ट कर दी गई है",
      "title": "संपत्ति सफलतापूर्वक सूपूचित!",
      "view_properties": "मेरी संपत्तियाँ देखें"
    },
    "tag_multi_select": {
      "add_custom": "अपनी जोड़ें…",
      "continue": "जारी रखें"
    },
    "type_selector": {
      "title": "संपत्ति प्रकार"
    },
    "washroom_count": {
      "title": "वॉशरूम संख्या"
    },
    "yes_no": {
      "questions": {
        "does_it_have_a_personal_washroom": "क्या इसमें निजी वॉशरूम है?",
        "is_it_a_corner_plot": "क्या यह कॉर्नर प्लॉट है?",
        "is_it_a_corner_shop": "क्या यह कॉर्नर शॉप है?",
        "is_it_on_the_main_road": "क्या यह मुख्य सड़क पर है?",
        "is_there_a_boundary_wall": "क्या बाउंड्री वॉल है?",
        "is_washroom_available": "क्या वॉशरूम उपलब्ध है?",
        "loading_unloading_access": "क्या लोडिंग/अनलोडिंग पहुँच उपलब्ध है?",
        "truck_accessibility": "क्या ट्रक पहुँच उपलब्ध है?"
      }
    }
  },
  "help": {
    "community": {
      "description": "फ़ीचर चर्चा और अन्य उपयोगकर्ताओं से मदद के लिए हमारे समुदाय फ़ोरम में शामिल हों।",
      "title": "समुदाय",
      "visit": "समुदाय देखें →"
    },
    "contact": {
      "direct_support": "प्रत्यक्ष सहायता",
      "email_support": "ईमेल सहायता",
      "respond_time": "हम सामान्यतः 24 घंटे में जवाब देते हैं।",
      "tech_issues": "तकनीकी समस्याएँ"
    },
    "faq": {
      "q1": {
        "a": "साइडबार में 'संपत्ति पोस्ट करें' पर जाएँ। आप हमारे AI लिस्टिंग सहायक से तेज़ी से वृत्तिपूर्ण विवरण और विवर सेट कर सकते हैं।",
        "q": "मैं अपनी संपत्ति कैसे लिस्ट करूँ?"
      },
      "q2": {
        "a": "ब्रोकरेज हब मालिकों को प्रोपर्टी मैनेजर आमंत्रित करने और प्रबंधित करने देता है। आप मैनेजरों को संपत्तियाँ सौंप कर सकते और उनके प्रदर्शन ट्रैक कर सकते हैं।",
        "q": "ब्रोकरेज हब क्या है?"
      },
      "q3": {
        "a": "साइडबार से 'सदस्यता' पृष्ठ पर जाएँ। वहाँ आप अपनी वर्तमान योजना देख सकते, अपग्रेड कर सकते, या बिलिंग विवर प्रबंधित कर सकते हैं।",
        "q": "मैं अपनी सदस्यता योजना कैसे बदलूँ?"
      },
      "q4": {
        "a": "हाँ, हम सुरक्षा को गंभीर लेते हैं। आपका सभी डेटा एनक्रिप्टेड है, और हम उद्योग-मानक प्रमाणीकरण (Firebase) और भुगतान (Stripe/Razorpay) का उपयोग करते हैं।",
        "q": "क्या मेरा डेटा सुरक्षित है?"
      },
      "q5": {
        "a": "जब किरायेदार आपकी संपत्ति के बारे में पूछताछ करता है, आपको सूचना मिलेगी। फिर 'संदेश' में जाकर उनसे सीधे चैट कर सकते हैं।",
        "q": "मैं किरायेदार से कैसे संपर्क करूँ?"
      }
    },
    "form": {
      "description": "नीचे फ़ॉर्म भरें और हमारी टीम आपसे संपर्क करेगी।",
      "email": "ईमेल",
      "error": "संदेश भेजने में विफल। कृपया पुनः प्रयास करें।",
      "error_long": "सहायता अनुरोध भेजने में विफल। कृपया बाद में प्रयास करें।",
      "message": "संदेश",
      "name": "नाम",
      "placeholder_email": "john@example.com",
      "placeholder_message": "अपने मन की बात हमें और बताएं...",
      "placeholder_name": "जॉन डो",
      "placeholder_subject": "मेरी सदस्यता के बारे में प्रश्न",
      "sending": "भेजा जा रहा है...",
      "subject": "विषय",
      "submit": "संदेश भेजें",
      "success": "संदेश सफलतापूर्वक भेज दिया गया!",
      "success_long": "सहायता अनुरोध सफलतापूर्वक भेजा गया! हम जल्दी आपसे संपर्क करेंगे।",
      "title": "हमें संदेश भेजें"
    },
    "requests": {
      "loading": "संदेश लोड हो रहे हैं...",
      "need_respond": "जवाब आवश्यक",
      "none_desc_admin": "अभी कोई सहायता अनुरोध प्राप्त नहीं हुआ है।",
      "none_desc_user": "आपने अभी कोई सहायता अनुरोध नहीं भेजा है।",
      "none_found": "कोई संदेश नहीं मिला",
      "refresh": "रिफ्रेश",
      "reply": {
        "cancel": "रद्द",
        "error": "जवाब भेजने में विफल। कृपया जाँचें कि SMTP सही सेट है।",
        "label": "जवाब",
        "placeholder": "अपना जवाब लिखें...",
        "placeholder_long": "यहाँ अपना जवाब लिखें...",
        "send": "जवाब भेजें",
        "success": "जवाब सफलतापूर्वक भेज दिया गया! अनुरोध स्थिति हल कर दी गई है।"
      },
      "reply_btn": "जवाब",
      "request_resolved": "हल",
      "send_msg": "संदेश भेजें",
      "status": {
        "pending": "लंबित",
        "resolved": "हल"
      },
      "title_admin": "सभी सहायता अनुरोध",
      "title_user": "आपके सहायता अनुरोध"
    },
    "subtitle": "उत्तर पाएं या हमारी टीम से संपर्क करें।",
    "tabs": {
      "contact": "संपर्क करें",
      "faq": "अक्सर-प्रश्न",
      "inbox": "इनबॉक्स",
      "requests": "मेरे अनुरोध"
    }
  },
  "image_search_page": {
    "actions": {
      "find_similar": "समान संपत्तियाँ खोजें",
      "searching": "समान संपत्तियाँ खोजी जा रही हैं…"
    },
    "dropzone": {
      "click_browse": "ब्राउज़ करने के लिए क्लिक करें",
      "drag_drop": "ड्रैग & ड्रॉप करें या",
      "drop_here": "छवि यहाँ छोड़ें",
      "formats": "JPEG, PNG, WebP · अधिकतम 10 MB",
      "upload_photo": "संपत्ति फ़ोटो अपलोड करें"
    },
    "errors": {
      "generic": "कुछ गलत हुआ। कृपया पुनः प्रयास करें।",
      "invalid_type": "कृपया JPEG, PNG, या WebP छवि का उपयोग करें।",
      "max_size": "छवि 10 MB से कम होनी चाहिए।",
      "no_matches": "कोई मिलती-जुलती संपत्ति नहीं मिली। दूसरी छवि आज़माएँ।",
      "paid_only": "🔒 इमेज सर्च केवल पेड उपयोगकर्ताओं के लिए उपलब्ध है।"
    },
    "footer_note": "परिणाम पहले दृश्य समानता और फिर स्थान के आधार पर रैंक होते हैं।",
    "how_it_works": {
      "example": "\"गाचीबौली, हैदराबाद के पास\"",
      "prefix": "अपनी पसंद की संपत्ति की फ़ोटो अपलोड करें। हमारा AI समान लिस्टिंग खोजेगा। वैकल्पिक रूप से ऐसा लोकेशन संकेत जोड़ें",
      "suffix": "ताकि परिणाम क्षेत्र के अनुसार बेहतर हों।"
    },
    "location_context": {
      "hint": "स्थान जोड़ने से अधिक प्रासंगिक परिणाम मिलते हैं।",
      "label": "स्थान संदर्भ",
      "optional": "वैकल्पिक",
      "placeholder": "उदा. \"गाचीबौली, हैदराबाद के पास\" या \"3 BHK अपार्टमेंट\""
    },
    "preview": {
      "change": "बदलें",
      "selected_alt": "चयनित संपत्ति"
    }
  },
  "impersonation": {
    "action": "उपयोगकर्ता के रूप में देखें",
    "banner_actor": "सुपर एडमिन {{email}} के रूप में साइन इन।",
    "banner_body": "आप ऐप को {{name}} ({{email}}) के रूप में देख रहे हैं।",
    "banner_title": "इम्पर्सनेशन सक्रिय",
    "exit": "इम्पर्सनेशन समाप्त करें",
    "failed": "इम्पर्सनेशन शुरू नहीं हो सका।",
    "started": "अब इस उपयोगकर्ता के रूप में एप देख रहे हैं।",
    "stop_failed": "इम्पर्सनेशन समाप्त नहीं हो सका।"
  },
  "landing": {
    "chat_placeholder": "हमारे एआई सहायक के साथ चैट करना शुरू करें...",
    "guide_desc": "हम वैयक्तिकृत एआई अनुशंसाओं के साथ आपके लिए सही चीज़ ढूंढना आसान बनाते हैं",
    "guide_title": "एआई आपको घर तक पहुँचाए",
    "hero_desc": "चाहे आप विला, भूमि, अपार्टमेंट, छात्रावास, या कोई अन्य संपत्ति खोज रहे हों, हमारा एआई सहायक हर कदम पर आपकी मदद करने के लिए यहाँ है। तुरंत वैयक्तिकृत अनुशंसाएँ प्राप्त करें।",
    "hero_title_1": "अपनी संपत्ति खोजें।",
    "hero_title_2": "अपने सपने को जियो।",
    "showcase_desc": "आधुनिक जीवन का प्रतीक अनुभव करें",
    "showcase_title": "लक्जरी अपार्टमेंट शोकेस"
  },
  "landing_page": {
    "ai_search_btn": "AI खोज",
    "analyzing": "विश्लेषण कर रहा है...",
    "feature_ai": "AI-संचालित",
    "feature_instant": "तत्काल परिणाम",
    "feature_setup": "त्वरित सेटअप",
    "feature_verified": "सत्यापित लिस्टिंग",
    "footer": {
      "about_p1": "संपत्ति खरीदारों और विक्रेताओं को जोड़ने वाले अग्रणी AI-संचालित रियल एस्टेट प्लेटफॉर्म के रूप में, LetMeIn AI के पास <0>50,000 से अधिक मासिक सक्रिय उपयोगकर्ता</0> और हजारों सत्यापित संपत्ति लिस्टिंग हैं। हमारी अत्याधुनिक तकनीक के साथ, हम एक व्यापक संपत्ति पारिस्थितिकी तंत्र में विकसित हुए हैं, जो स्मार्ट खोज, तत्काल मूल्यांकन और विशेषज्ञ निवेश सलाह प्रदान करते हैं।",
      "about_p2": "LetMeIn AI हमारे मालिकाना एनालिटिक्स डैशबोर्ड के माध्यम से व्यापक डेटा-संचिट अंतर्दृष्टि और बाजार रुझान भी प्रदान करता है, जो घर खरीदारों को उनकी पसंद के अनुसार सटीक मूल्य पूर्वानुमान, इलाके की समीक्षा और निवेश के अवसर प्रदान करता है।",
      "about_title": "LetMeIn AI के बारे में",
      "app_coming_soon_app_store": "LetMeIn AI iOS ऐप अभी उपलब्ध नहीं है। App Store पर लाइव होने पर हम आपको सूचित करेंगे।",
      "app_coming_soon_google_play": "LetMeIn AI Android ऐप अभी उपलब्ध नहीं है। Google Play पर लाइव होने पर हम आपको सूचित करेंगे।",
      "app_coming_soon_title": "मोबाइल ऐप जल्द आ रहा है",
      "app_store_aria": "App Store पर डाउनलोड करें",
      "browse_properties": "संपत्तियाँ देखें",
      "google_play_aria": "Google Play पर प्राप्त करें",
      "privacy": "गोपनीयता नीति",
      "rights_reserved": "© 2026 LetMeIn AI. सर्वाधिकार सुरक्षित।",
      "terms": "सेवा की शर्तें"
    },
    "get_details": "विवरण देखें",
    "header": {
      "listing_intent_nav_aria": "खरीदें, किराए पर लें या बेचें",
      "nav_buy": "खरीदें",
      "nav_rent": "किराया",
      "nav_sell": "बेचें"
    },
    "header_profile_aria": "खाता मेनू",
    "hero_subtitle": "AI-संचालित संपत्ति खोज जो समझती है कि आप वास्तव में क्या ढूंढ रहे हैं।",
    "hero_title_1": "अपना",
    "hero_title_2": "स्थान खोजें",
    "hero_title_accent": "आदर्श",
    "intent_nav": {
      "buy_commercial": "बिक्री के लिए कमर्शियल",
      "buy_flats": "फ्लैट और अपार्टमेंट",
      "buy_plots": "प्लॉट और ज़मीन",
      "query_buy_commercial": "बिक्री के लिए कमर्शियल प्रॉपर्टी",
      "query_buy_flats": "बिक्री के लिए फ्लैट और अपार्टमेंट",
      "query_buy_plots": "बिक्री के लिए आवासीय प्लॉट और ज़मीन",
      "query_rent_flats": "किराए पर फ्लैट और अपार्टमेंट",
      "query_rent_houses": "किराए पर स्वतंत्र मकान और विला",
      "query_rent_pg": "किराए पर PG और शेयर्ड रहना",
      "query_sell_ai": "मैं अपनी प्रॉपर्टी बेचना चाहता हूँ और शुरुआत में मदद चाहिए",
      "rent_flats": "किराए पर फ्लैट",
      "rent_houses": "किराए पर मकान और विला",
      "rent_pg": "PG और को-लिविंग",
      "sell_ai": "बिक्री के बारे में AI से पूछें",
      "sell_list": "प्रॉपर्टी लिस्ट करें"
    },
    "listings": "लिस्टिंग",
    "listings_count_suffix": "लिस्टिंग",
    "location_permission_dialog": {
      "browser_popup_tip": "अगर ब्राउज़र में लोकेशन पूछने वाला पॉपअप दिखे, तो पहले Allow या Just this time पर क्लिक करें।",
      "browser_popup_waiting": "ब्राउज़र के ऊपर लोकेशन पॉपअप देखें, फिर Allow या Just this time पर क्लिक करें।",
      "desc_denied": "जब तक आप अनुमति नहीं देंगे, यह साइट आपकी लाइव लोकेशन का उपयोग नहीं कर सकती।",
      "desc_timeout": "आपकी लोकेशन प्राप्त करने में बहुत समय लग गया।",
      "desc_unavailable": "आपका डिवाइस अभी GPS निर्देशांक नहीं ढूँढ पाया।",
      "how_to_unblock_android": "इस साइट के लिए लोकेशन चालू करें (Android)",
      "how_to_unblock_desktop": "इस साइट के लिए लोकेशन चालू करें",
      "how_to_unblock_ios": "इस साइट के लिए लोकेशन चालू करें (iPhone / iPad)",
      "how_to_unblock_mac": "इस साइट के लिए लोकेशन चालू करें (Mac)",
      "how_to_unblock_windows": "इस साइट के लिए लोकेशन चालू करें (Windows)",
      "locating": "लोकेशन जाँची जा रही है…",
      "no_gps_note": "लोकेशन नहीं मिल सकी",
      "place_pin_instead": "मैं मैप पर पिन को ड्रैग करूँगा",
      "search_manually": "इलाके का नाम खोजें",
      "step_android_1": "Chrome में, वेबसाइट पते के बगल में लॉक आइकन पर टैप करें।",
      "step_android_2": "Permissions (या Site settings) पर टैप करें।",
      "step_android_3": "Location को Allow पर सेट करें।",
      "step_android_4": "यहाँ वापस आकर Try Again पर टैप करें।",
      "step_desktop_1": "ब्राउज़र में वेबसाइट पते के बाईं ओर लॉक आइकन पर क्लिक करें।",
      "step_desktop_2": "Location ढूँढें और Allow पर सेट करें।",
      "step_desktop_3": "ज़रूरत हो तो सिस्टम की प्राइवेसी सेटिंग में इस ब्राउज़र के लिए Location चालू करें।",
      "step_desktop_4": "यहाँ वापस आकर Try Again पर क्लिक करें।",
      "step_ios_1": "Safari में, एड्रेस बार के बाईं ओर aA (या पेज सेटिंग्स आइकन) पर टैप करें।",
      "step_ios_2": "Website Settings पर टैप करें, फिर Location चुनें।",
      "step_ios_3": "Allow चुनें।",
      "step_ios_4": "फिर भी न चले तो: iPhone Settings → Privacy & Security → Location Services → Safari Websites → Allow।",
      "step_ios_5": "यहाँ वापस आकर Try Again पर टैप करें।",
      "step_mac_1": "ब्राउज़र में वेबसाइट पते के बाईं ओर लॉक आइकन पर क्लिक करें।",
      "step_mac_2": "Location ढूँढें और Allow पर सेट करें।",
      "step_mac_3": "Mac System Settings → Privacy & Security → Location Services ऑन करें, और अपने ब्राउज़र को चेक करें।",
      "step_mac_4": "यहाँ वापस आकर Try Again पर क्लिक करें।",
      "step_windows_1": "ब्राउज़र में वेबसाइट पते के बाईं ओर लॉक आइकन पर क्लिक करें।",
      "step_windows_2": "Location ढूँढें और Allow पर सेट करें।",
      "step_windows_3": "Windows Settings → Privacy & security → Location ऑन करें, और अपने ब्राउज़र को अनुमति दें।",
      "step_windows_4": "यहाँ वापस आकर Try Again पर क्लिक करें।",
      "timeout_hint": "अगर ब्राउज़र का लोकेशन पॉपअप आया हो तो उस पर Allow करें। नहीं तो फिर से कोशिश करें, या इलाके का नाम खोजें।",
      "timeout_note": "लोकेशन में बहुत समय लग रहा है",
      "title_denied": "लोकेशन एक्सेस ब्लॉक है",
      "title_generic": "लाइव लोकेशन अनुपलब्ध है",
      "title_timeout": "लोकेशन अनुरोध टाइम आउट हो गया",
      "title_unavailable": "डिवाइस की लोकेशन नहीं मिल पा रही",
      "try_again": "पुनः प्रयास करें",
      "unavailable_hint": "कई लैपटॉप सटीक GPS नहीं दे पाते। इलाके का नाम खोजें, या मैप पर पिन खींचें।"
    },
    "location_picker": {
      "desc": "सर्वोत्तम परिणाम प्रदान करने के लिए, हमें आपका शहर जानना होगा। कृपया स्थान पहुँच की अनुमति दें या अपना शहर मैन्युअल रूप से चुनें।",
      "footer": "आपका देश और शहर हमारे AI को आपके क्षेत्र में सठीक मेल खोजने में मदद करता है।",
      "title": "स्थान आवश्यक"
    },
    "manager": {
      "badge": "संपत्ति प्रबंधक",
      "desc": "उन पेशेवरों के लिए बनाया गया है जो कई संपत्तियों का प्रबंधन करते हैं - किराएदारों को ट्रैक करें, संग्रह स्वचालित करें, और एक शक्तिशाली डैशबोर्ड से अपना रेंटल व्यवसाय बढ़ाएं।",
      "features": {
        "analytics_desc": "अपने पूरे पोर्टफोलियो में अधिभोग दर, किराये की आय के रुझान और संपत्ति के प्रदर्शन पर वास्तविक समय की अंतर्दृष्टि प्राप्त करें।",
        "analytics_title": "पोर्टफोलियो विश्लेषण",
        "collections_desc": "समय पर भुगतान अधिकतम करने के लिए स्वचालित अनुस्मारक और भुगतान ट्रैकिंग के साथ किराया संग्रह व्यवस्थित करें।",
        "collections_title": "स्वचालित संग्रह",
        "tenant_desc": "किराएदार संचार, पट्टा नवीनीकरण और रखरखाव अनुरोधों को एक एकीकृत स्थान पर प्रबंधित करें।",
        "tenant_title": "किराएदार संबंध हब"
      },
      "join_btn": "संपत्ति प्रबंधक के रूप में जुड़ें",
      "no_commitment": "कोई प्रतिबद्धता आवश्यक नहीं • मिनटों में सेटअप करें",
      "title_1": "अपने पोर्टफोलियो को बढ़ाएं,",
      "title_accent": "आसानी से।"
    },
    "nav_contact": "हमसे संपर्क करें",
    "nav_features": "विशेषताएं",
    "nav_feedback": "प्रतिक्रिया",
    "nav_get_started": "शुरू करें",
    "nav_pricing": "मूल्य निर्धारण",
    "nav_signin": "साइन इन करें",
    "no_properties_found": "कोई संपत्ति नहीं मिली",
    "owner": {
      "badge": "संपत्ति मालिक",
      "desc": "उन हजारों मालिकों से जुड़ें जो हमारे AI-संचालित मंच पर अपनी संपत्तियां सूचीबद्ध करते हैं।",
      "post_btn": "अब संपत्ति पोस्ट करें",
      "subtitle": "हमारे लचीले क्रेडिट सिस्टम के साथ केवल वही भुगतान करें जिसका आप उपयोग करते हैं",
      "title_1": "अपनी संपत्ति सूचीबद्ध करें और पाएं",
      "title_accent": "सत्यापित किराएदार तुरंत"
    },
    "popular": "लोकप्रिय:",
    "popular_properties": "लोकप्रिय संपत्तियाँ",
    "popular_properties_desc": "अपने क्षेत्र में सर्वोत्तम सौदे खोजें",
    "popular_properties_prefix": "लोकप्रिय संपत्तियां",
    "popular_tags": {
      "bhk_apartments": "3BHK अपार्टमेंट",
      "bhk_in_city": "{{city}} में 3BHK",
      "independent_house": "स्वतंत्र मकान",
      "pet_friendly": "पालतू अनुकूल",
      "villas_with_pool": "पूल वाला विला"
    },
    "preferred_agent": "पसंदीदा एजेंट",
    "preferred_agents_desc": "खरीदारों और किरायेदारों द्वारा भरोसेमंद सत्यापित संपत्ति प्रबंधक",
    "preferred_agents_prefix": "पसंदीदा एजेंट",
    "projects": {
      "badge": "नई लॉन्च",
      "card1_desc": "अपने शहर में सभी नई शुरू की गई आवासीय और वाणिज्यिक परियोजनाओं के व्यापक विवरण ब्राउज़ करें।",
      "card1_title": "सभी नई परियोजनाओं के लिए निर्देशिका",
      "card2_desc": "सुरक्षा के लिए आधिकारिक अनुपालन रिपोर्ट, कानूनी मंजूरी और RERA पंजीकरण विवरण तक पहुंचें।",
      "card2_title": "RERA से सभी रिपोर्ट",
      "card3_desc": "विशेषज्ञों से निष्पक्ष विश्लेषण, निवेश क्षमता रेटिंग और निर्माण गुणवत्ता समीक्षा प्राप्त करें।",
      "card3_title": "विशेषज्ञ समीक्षाएं और सलाह",
      "desc": "आगामी विकास, अनुपालन और विशेषज्ञ राय के बारे में वह सब कुछ जो आपको जानना आवश्यक है।",
      "title": "आगामी परियोजनाएं"
    },
    "search_placeholder": "कोशिश करें 'हैदराबाद में 3 BHK विला' या '15k से कम में किराए पर स्टूडियो'...",
    "see_all": "सभी देखें",
    "since": "से",
    "theme": "थीम"
  },
  "leases_page": {
    "actions": {
      "convert": "परिवर्तित करें",
      "reupload_signed": "हस्ताक्षरित लीज़ पुनः अपलोड करें",
      "sign_upload": "हस्ताक्षर और अपलोड",
      "signed_lease": "हस्ताक्षरित लीज़",
      "unsigned_lease": "अहस्ताक्षरित लीज़",
      "update_lease": "लीज़ अपडेट करें",
      "upload_lease": "लीज़ अपलोड करें"
    },
    "add_tenant_btn": "किरायेदार मैन्युअल जोड़ें",
    "desc_owner": "अपनी सक्रिय लीज़ और आने वाले लीड प्रबंधित करें।",
    "desc_tenant": "अपनी सक्रिय लीज़, अनुबंध विवरण देखें और दस्तावेज़ हस्ताक्षर करें।",
    "errors": {
      "add_failed": "किरायेदार जोड़ने में विफल। कृपया सुनिश्चित करें कि उपयोगकर्ता मौजूद है।",
      "convert_failed": "किरायेदार परिवर्तित करने में विफल",
      "delete_failed": "रिकॉर्ड हटाने में विफल। कृपया पुनः प्रयास करें।",
      "update_failed": "किरायेदार विवरण अपडेट करने में विफल",
      "upload_failed": "फ़ाइल अपलोड करने में विफल"
    },
    "filters": {
      "reset": "रीसेट",
      "search_placeholder": "नाम, ईमेल, संपत्ति से खोजें..."
    },
    "interest_types": {
      "lease": "📝 लीज़",
      "rent": "🏠 किराया",
      "sale": "💰 बिक्री"
    },
    "modals": {
      "add_manual": {
        "adding": "जोड़ा जा रहा है...",
        "cancel": "रद्द करें",
        "email_hint": "उपयोगकर्ता इस ईमेल से पंजीकृत होना चाहिए।",
        "email_label": "किरायेदार ईमेल *",
        "email_placeholder": "tenant@example.com",
        "end_label": "लीज़ समाप्ति *",
        "no_properties": "आपके नियंत्रण में कोई संपत्ति नहीं मिली।",
        "property_hint": "केवल वे संपत्तियाँ दिखाई जाती हैं जिनका आप प्रबंधन या स्वामित्व करते हैं।",
        "property_label": "संपत्ति चुनें *",
        "property_placeholder": "संपत्ति चुनें",
        "rent_label": "मासिक किराया (₹) *",
        "start_label": "लीज़ प्रारंभ *",
        "submit": "किरायेदार जोड़ें",
        "subtitle": "किसी मौजूदा उपयोगकर्ता को सक्रिय किरायेदार के रूप में जोड़ें।",
        "title": "किरायेदार मैन्युअल जोड़ें"
      },
      "convert": {
        "cancel": "रद्द करें",
        "desc": "<1>{{name}}</1> के लिए <3>{{property}}</3> पर लीज़ विवरण सेट करें",
        "end_label": "लीज़ समाप्ति तिथि *",
        "rent_label": "मासिक किराया (₹) *",
        "start_label": "लीज़ प्रारंभ तिथि *",
        "submit": "किरायेदार में परिवर्तित करें",
        "title": "सक्रिय किरायेदार में परिवर्तित करें"
      },
      "delete": {
        "cancel": "रद्द करें",
        "desc": "क्या आप वाकई <1>{{name}}</1> का रिकॉर्ड हटाना चाहते हैं?",
        "submit": "रिकॉर्ड हटाएँ",
        "title": "हटाने की पुष्टि",
        "warning": "यह क्रिया पूर्ववत नहीं की जा सकती।"
      },
      "edit": {
        "cancel": "रद्द करें",
        "desc": "<1>{{name}}</1> के लिए लीज़ शर्तें अपडेट करें",
        "end_label": "लीज़ समाप्ति तिथि",
        "rent_label": "मासिक किराया (₹)",
        "start_label": "लीज़ प्रारंभ तिथि",
        "submit": "परिवर्तन सहेजें",
        "title": "लीज़ विवरण संपादित करें",
        "updating": "सहेजा जा रहा है..."
      },
      "lease_doc": {
        "cancel": "रद्द करें",
        "desc_sign": "अपने लीज़ समझौते की हस्ताक्षरित प्रति अपलोड करें।",
        "desc_upload": "अपने किरायेदार की समीक्षा और हस्ताक्षर के लिए लीज़ समझौता अपलोड करें।",
        "download": "डाउनलोड",
        "file_hint": "केवल PDF, अधिकतम 5MB",
        "select_pdf": "PDF दस्तावेज़ चुनें",
        "submit_replace": "दस्तावेज़ बदलें",
        "submit_upload": "दस्तावेज़ अपलोड करें",
        "template": "लीज़ समझौता टेम्पलेट",
        "title_sign": "हस्ताक्षर और लीज़ अपलोड",
        "title_upload": "लीज़ दस्तावेज़ अपलोड करें",
        "upload_hint": "चुनने के लिए क्लिक करें या खींचकर छोड़ें"
      },
      "view": {
        "close": "बंद करें",
        "labels": {
          "email": "ईमेल पता",
          "end": "लीज़ समाप्ति",
          "inquiry": "प्रारंभिक पूछताछ",
          "property": "संपत्ति",
          "rent": "मासिक किराया",
          "start": "लीज़ प्रारंभ"
        },
        "subtitle": "{{name}} का विवरण देख रहे हैं",
        "title": "किरायेदार विवरण"
      }
    },
    "status": {
      "active": "सक्रिय",
      "application": "आवेदन",
      "inquiry": "पूछताछ"
    },
    "table": {
      "actions": "कार्रवाई",
      "anonymous_user": "अज्ञात उपयोगकर्ता",
      "date": "तिथि",
      "default_inquiry_message": "मुझे इस संपत्ति में रुचि है।",
      "interest_type": "रुचि प्रकार",
      "lead_name": "लीड नाम",
      "lease_period": "लीज़ अवधि",
      "message": "संदेश",
      "no_active_tenants": "कोई सक्रिय किरायेदार नहीं मिला। पूछताछ टैब देखें?",
      "no_inquiries": "कोई नई पूछताछ नहीं मिली।",
      "property": "संपत्ति",
      "rent": "किराया",
      "status": "स्थिति",
      "tenant": "किरायेदार",
      "to": "से"
    },
    "tabs": {
      "active": "सक्रिय किरायेदार",
      "inquiries": "लीड और पूछताछ"
    },
    "title_owner": "किरायेदार और पूछताछ",
    "title_tenant": "मेरी लीज़ और रिकॉर्ड",
    "toasts": {
      "fill_required": "कृपया सभी आवश्यक फ़ील्ड भरें।",
      "lease_doc_uploaded": "लीज़ दस्तावेज़ सफलतापूर्वक अपलोड हो गया!",
      "signed_lease_uploaded": "हस्ताक्षरित लीज़ सफलतापूर्वक अपलोड हो गई!",
      "tenant_added": "किरायेदार सफलतापूर्वक जोड़ा गया!"
    }
  },
  "listing_questions": {
    "location_set_success": ""
  },
  "location": {
    "choose_city": "अपना शहर चुनें",
    "choose_country": "देश चुनें",
    "city_label": "शहर",
    "city_loading": "शहर लोड हो रहे हैं…",
    "country_label": "देश",
    "country_loading": "देश लोड हो रहे हैं…",
    "just_open_map": "{{zoneName}} के लिए सिर्फ मैप खोलें",
    "no_cities": "इस देश के लिए कोई सक्षम शहर नहीं मिला।",
    "no_countries": "कोई समर्थित देश कॉन्फिगर नहीं है।",
    "search_city": "शहर खोजें…",
    "select_area_in": "{{zoneName}} में क्षेत्र चुनें",
    "tap_area_hint": "किसी क्षेत्र पर टैप करें या नीचे अपने इलाके का नाम बोलें/टाइप करें"
  },
  "maintenance": {
    "admin_notice": "प्रशासक पहुँच: आप अभी भी एप्लिकेशन का उपयोग कर सकते हैं।",
    "check_back": "कृपया शीघ्र ही दोबारा जांचें। किसी भी असुविधा के लिए हम क्षమా प्रार्थी हैं।",
    "description": "हम आपके अनुभव को बेहतर बनाने के लिए निर्धारित रखरखाव कर रहे हैं।",
    "title": "रखरखाव के अधीन"
  },
  "maintenance_dashboard": {
    "card": {
      "reported": "रिपोर्ट की गई:",
      "status": "स्थिति:"
    },
    "empty": {
      "subtitle": "आपके पोर्टफोलियो में सब कुछ ठीक लग रहा है!",
      "title": "कोई रखरखाव अनुरोध नहीं मिला"
    },
    "filter_status": "स्थिति फ़िल्टर",
    "filters": {
      "all": "सभी अनुरोध"
    },
    "modal": {
      "category": "श्रेणी",
      "category_placeholder": "क्या समस्या है?",
      "choose_property": "एक संपत्ति चुनें",
      "description": "अपनी किसी प्रबंधित संपत्ति के लिए नया मरम्मत या रखरखाव अनुरोध जमा करें।",
      "description_for_property": "{{propertyName}} में कुछ ठीक करना है? हमें बताएं।",
      "description_placeholder": "समस्या, यूनिट में स्थान और कोई अत्यावश्यक विवरण बताएं...",
      "issue_description": "समस्या का विवरण",
      "issue_details": "समस्या विवरण",
      "issue_details_placeholder": "कृपया बताएं क्या हो रहा है...",
      "no_properties": "कोई संपत्ति उपलब्ध नहीं",
      "priority": "प्राथमिकता",
      "select_property": "संपत्ति चुनें",
      "submit": "अनुरोध जमा करें",
      "title": "रखरखाव समस्या रिपोर्ट करें"
    },
    "priority_detail": {
      "high": "उच्च - अत्यावश्यक",
      "low": "कम - नियमित",
      "medium": "मध्यम - जल्द",
      "urgent": "अत्यावश्यक - आपात"
    },
    "property_fallback": "संपत्ति ({{id}}...)",
    "report_issue": "समस्या रिपोर्ट करें",
    "status": {
      "assigned": "नियुक्त",
      "cancelled": "रद्द",
      "completed": "पूर्ण",
      "in_progress": "प्रगति में",
      "pending": "लंबित"
    },
    "subtitle": "अपनी प्रबंधित संपत्तियों में मरम्मत अनुरोधों को ट्रैक और प्रबंधित करें।",
    "title": "रखरखाव डैशबोर्ड",
    "toasts": {
      "description_required": "कृपया समस्या का विवरण दें",
      "fields_required": "कृपया सभी आवश्यक फ़ील्ड भरें",
      "select_property": "कृपया एक संपत्ति चुनें",
      "status_update_failed": "स्थिति अपडेट करने में विफल",
      "status_updated": "स्थिति अपडेट होकर {{status}} हो गई",
      "submit_failed": "रखरखाव अनुरोध बनाने में विफल",
      "submit_success": "रखरखाव अनुरोध सफलतापूर्वक जमा हो गया!"
    }
  },
  "messages_page": {
    "compose_placeholder": "अपना संदेश लिखें...",
    "default_agent_message": "नमस्ते! मुझे आपकी सूचीबद्ध संपत्तियों में रुचि है।",
    "empty_inbox_description": "संपत्तियों के बारे में संदेश देखने के लिए साइडबार से कोई बातचीत चुनें।",
    "empty_inbox_title": "आपका इनबॉक्स",
    "errors": {
      "auth_timeout": "मैसेजिंग साइन-इन का समय समाप्त। कृपया पेज रिफ़्रेश करें और पुनः प्रयास करें।",
      "load_failed": "वार्तालाप लोड करने में विफल। कृपया रिफ़्रेश करें और पुनः प्रयास करें।",
      "load_title": "संदेश लोड नहीं हो सके",
      "send_failed": "संदेश भेजने में विफल। कृपया पुनः प्रयास करें।",
      "start_conversation_failed": "वार्तालाप शुरू करने में विफल। कृपया पुनः प्रयास करें।",
      "voice_send_failed": "वॉइस संदेश भेजने में विफल। कृपया पुनः प्रयास करें।"
    },
    "fallback_initials": "U",
    "fallback_user": "उपयोगकर्ता",
    "inbox": "इनबॉक्स",
    "loading_conversations": "बातचीत लोड हो रही है...",
    "login_required": "संदेश देखने के लिए कृपया लॉगिन करें",
    "no_history_hint": "पहला संदेश भेजकर बातचीत शुरू करें।",
    "no_history_title": "कोई बातचीत इतिहास नहीं",
    "no_results_hint": "नाम या संपत्ति से खोजने का प्रयास करें",
    "no_results_title": "कोई परिणाम नहीं मिला",
    "privacy_alert": {
      "cancel_edit": "रद्द करें और संपादित करें",
      "description": "हमने आपके संदेश में संपर्क जानकारी का पता लगाया है। आपकी सुरक्षा के लिए, हम अनुशंसा करते हैं कि सारी बातचीत प्लेटफ़ॉर्म के भीतर ही रखें।",
      "preview_label": "संदेश पूर्वावलोकन",
      "send_masked": "मास्क किया हुआ संदेश भेजें",
      "title": "गोपनीयता चेतावनी"
    },
    "property_card": {
      "badge": "",
      "untitled": ""
    },
    "property_info": {
      "load_failed": "",
      "loading": "",
      "missing_id": "",
      "open": ""
    },
    "ready_to_chat": "चैट के लिए तैयार",
    "search_placeholder": "बातचीत खोजें...",
    "title": "संदेश",
    "voice": {
      "duration": "{{seconds}}से",
      "start": "वॉइस संदेश रिकॉर्ड करें",
      "stop": "रिकॉर्डिंग रोकें"
    }
  },
  "not_available": "",
  "notifications": {
    "delete": "हटाएँ",
    "failed_to_delete": "सूचना हटाने में विफल",
    "failed_to_load": "सूचनाएँ लोड करने में विफल",
    "failed_to_mark_read": "सूचना को पढ़ा हुआ चिह्नित करने में विफल",
    "mark_as_read": "पढ़ा हुआ चिह्नित करें",
    "new_count_one": "{{count}} नया",
    "new_count_other": "{{count}} नए",
    "no_notifications": "कोई सूचना नहीं",
    "templates": {
      "new_subscription": "एक नई सदस्यता खरीदी गई!",
      "new_subscription_title": "💰 नई सदस्यता",
      "new_user_registration": "एक नया उपयोगकर्ता पंजीकृत हुआ है:\n\n👤 नाम: {{userName}}\n📧 ईमेल: {{userEmail}}\n🏷️ भूमिका: {{userRole}}\n📝 प्रकार: {{registrationType}}",
      "new_user_registration_title": "🎉 नया उपयोगकर्ता पंजीकरण"
    },
    "time": {
      "days_ago_one": "{{count}} दिन पहले",
      "days_ago_other": "{{count}} दिन पहले",
      "hours_ago_one": "{{count}} घंटे पहले",
      "hours_ago_other": "{{count}} घंटे पहले",
      "just_now": "अभी-अभी",
      "minutes_ago_one": "{{count}} मिनट पहले",
      "minutes_ago_other": "{{count}} मिनट पहले"
    },
    "title": "सूचनाएं"
  },
  "org_billing": {
    "add_credits": "संस्था में क्रेडिट जोड़ें",
    "admin_description": "अपनी संस्था का साझा वॉलेट प्रबंधित करें और सदस्यों का उपयोग देखें।",
    "contact_admin": "क्रेडिट जोड़ने के लिए अपने संस्था प्रशासक से संपर्क करें।",
    "last_n_days": "पिछले {{days}} दिन",
    "ledger_desc": "संस्था के हाल के हालीया क्रेडिट लेनदेन।",
    "member": "सदस्य",
    "member_description": "अपनी संस्था का बैलेंस और अपना उपयोग योगदान देखें।",
    "shared_balance": "साझा वॉलेट बैलेंस",
    "shared_balance_desc": "सभी संस्था सदस्यों के लिए उपलब्ध क्रेडिट।",
    "shared_balance_note": "सभी टीम सदस्यों में साझा। उपयोग इसी बैलेंस से कटता है।",
    "title": "उपयोग और बिलिंग",
    "topup_success": "संस्था वॉलेट में क्रेडिट सफलतापूर्वक जोड़े गए।",
    "usage_summary": "उपयोग सारांश"
  },
  "organizations": {
    "add_user_modal": {
      "add_user": "उपयोगकर्ता जोड़ें",
      "cancel": "रद्द करें",
      "city": "शहर",
      "creating": "बना रहा है...",
      "description": "एक नया उपयोगकर्ता बनाएँ। उपयोगकर्ता को अपना खाता सक्रिय करने के लिए एक ईमेल प्राप्त होगा।",
      "email": "ईमेल",
      "error_fields": "कृपया सभी आवश्यक फ़ील्ड भरें।",
      "error_org_required": "चयनित भूमिका के लिए संगठन आवश्यक है।",
      "error_pm_details": "संपत्ति प्रबंधकों के लिए फोन और शहर आवश्यक हैं।",
      "first_name": "पहला नाम",
      "last_name": "अंतिम नाम",
      "organization": "संगठन",
      "password": "पासवर्ड",
      "phone": "फ़ोन नंबर",
      "role": "भूमिका",
      "select_organization": "संगठन चुनें",
      "select_role": "भूमिका चुनें",
      "success": "उपयोगकर्ता सफलतापूर्वक बनाया गया है और अब सक्रिय है!",
      "title": "उपयोगकर्ता जोड़ें",
      "username": "उपयोगकर्ता नाम"
    },
    "add_user_to_org": "बिल्डर में उपयोगकर्ता जोड़ें",
    "add_user_to_org_modal": {
      "add_user": "उपयोगकर्ता जोड़ें",
      "adding": "जोड़ रहा है...",
      "cancel": "रद्द करें",
      "description": "किसी विशिष्ट भूमिका के साथ एक उपयोगकर्ता को बिल्डर में जोड़ें। केवल सुपर एडमिन ही किसी भी बिल्डर में उपयोगकर्ताओं को जोड़ सकते हैं।",
      "error_failed": "उपयोगकर्ता को बिल्डर में जोड़ने में विफल",
      "org_admin": "बिल्डर एडमिन",
      "org_member": "बिल्डर सदस्य",
      "organization": "बिल्डर",
      "role": "भूमिका",
      "select_organization": "बिल्डर चुनें",
      "select_role": "भूमिका चुनें",
      "title": "उपयोगकर्ता को बिल्डर में जोड़ें",
      "user": "उपयोगकर्ता"
    },
    "card": {
      "description": "आपके सिस्टम के सभी बिल्डरों की सूची।",
      "title": "सभी बिल्डर"
    },
    "create_org": "बिल्डर बनाएँ",
    "create_org_modal": {
      "cancel": "रद्द करें",
      "create": "बिल्डर बनाएँ",
      "creating": "बना रहा है...",
      "description": "एक नया बिल्डर बनाएँ। केवल सुपर एडमिन ही बिल्डर बना सकते हैं।",
      "error_failed": "बिल्डर बनाने में विफल रहा",
      "org_desc": "विवरण",
      "org_desc_placeholder": "बिल्डर का विवरण दर्ज करें",
      "org_name": "बिल्डर का नाम",
      "org_name_placeholder": "बिल्डर का नाम दर्ज करें",
      "org_slug": "बिल्डर स्लग",
      "org_slug_placeholder": "बिल्डर-स्लग",
      "slug_hint": "बिल्डर के लिए URL-अनुकूल पहचानकर्ता",
      "title": "बिल्डर बनाएँ"
    },
    "delete_org_modal": {
      "confirm": "\"{{name}}\" हटाएँ?",
      "delete_btn": "बिल्डर हटाएँ",
      "deleting": "हटाया जा रहा है...",
      "details_title": "बिल्डर विवरण",
      "error_failed": "बिल्डर हटाने में विफल। कृपया पुनः प्रयास करें।",
      "impact_members": "सभी बिल्डर सदस्य (अनाथ)",
      "impact_properties": "सभी बिल्डर संपत्तियाँ और डेटा",
      "title": "बिल्डर हटाएँ",
      "warning": "यह क्रिया पूर्ववत नहीं की जा सकती। इस बिल्डर से जुड़ा सभी डेटा स्थायी रूप से हटा दिया जाएगा।"
    },
    "edit_org_modal": {
      "desc_placeholder": "बिल्डर का विवरण दर्ज करें",
      "description": "बिल्डर विवरण अपडेट करें।",
      "error_failed": "बिल्डर अपडेट करने में विफल",
      "name_label": "बिल्डर का नाम",
      "name_placeholder": "बिल्डर का नाम दर्ज करें",
      "slug_label": "बिल्डर स्लग",
      "slug_placeholder": "बिल्डर-स्लग",
      "title": "बिल्डर संपादित करें"
    },
    "errors": {
      "fetch_failed": "बिल्डर प्राप्त करने में विफल।"
    },
    "invite_org_modal": {
      "cancel": "रद्द करें",
      "description": "एक नया बिल्डर स्थापित करने के लिए एक आमंत्रण ईमेल भेजें",
      "email_label": "ईमेल पता",
      "email_placeholder": "ईमेल पता दर्ज करें",
      "error_generic": "आमंत्रण भेजते समय एक त्रुटि हुई।",
      "error_invalid_email": "कृपया एक वैध ईमेल पता दर्ज करें।",
      "message_label": "संदेश (वैकल्पिक)",
      "message_placeholder": "आमंत्रण में एक व्यक्तिगत संदेश जोड़ें...",
      "send": "आमंत्रण भेजें",
      "sending": "भेजा जा रहा है...",
      "success_message": "आमंत्रण सफलतापूर्वक {{email}} को भेजा गया",
      "title": "बिल्डर स्थापित करने के लिए आमंत्रित करें"
    },
    "invite_to_setup": "बिल्डर सेटअप करने के लिए आमंत्रित करें",
    "loading": "बिल्डर लोड हो रहे हैं...",
    "search_placeholder": "बिल्डरों की खोज करें...",
    "subtitle": "बिल्डरों और उनकी सेटिंग्स को प्रबंधित करें।",
    "table": {
      "actions": "कार्य",
      "created": "बनाया गया",
      "id": "आईडी",
      "name": "नाम",
      "verified": "सत्यापित"
    },
    "title": "बिल्डर",
    "total": "कुल",
    "users": {
      "card": {
        "description": "आपके संगठन के सभी उपयोगकर्ताओं की सूची।",
        "title": "संगठन सदस्य"
      },
      "fetch_failed": "संगठन उपयोगकर्ताओं को लाने में विफल।",
      "filters": {
        "all_status": "सभी स्थिति",
        "invited": "आमंत्रित"
      },
      "invite": "उपयोगकर्ता को आमंत्रित करें",
      "remove": "उपयोगकर्ता हटाएँ",
      "search_placeholder": "उपयोगकर्ताओं की खोज करें...",
      "status": {
        "invited": ""
      },
      "subtitle": "आपके संगठन में उपयोगकर्ताओं को प्रबंधित करें।",
      "table": {
        "actions": "कार्य",
        "created": "बनाया गया",
        "name": "नाम",
        "role": "भूमिका",
        "status": "स्थिति",
        "username": "उपयोगकर्ता नाम",
        "verified": "सत्यापित"
      },
      "title": "संगठन उपयोगकर्ता",
      "total": "कुल उपयोगकर्ता"
    }
  },
  "owner_stats": {
    "active_now": "अभी सक्रिय",
    "manage_all": "सभी लिस्टिंग प्रबंधित करें",
    "post_new": "नई लिस्टिंग पोस्ट करें",
    "total_listings": "कुल लिस्टिंग",
    "total_views": "कुल व्यू"
  },
  "payment_success": {
    "actions": {
      "go_to_dashboard": "डैशबोर्ड पर जाएँ",
      "go_to_plans": "प्लान्स पर जाएँ",
      "manage_subscription": "सदस्यता प्रबंधित करें"
    },
    "error_state": {
      "title": "भुगतान सत्यापन विफल"
    },
    "errors": {
      "no_payment_info": "भुगतान जानकारी उपलब्ध नहीं है",
      "unknown": "एक अज्ञात त्रुटि हुई।",
      "verification_failed": "भुगतान सत्यापन विफल"
    },
    "loading": {
      "description": "कृपया प्रतीक्षा करें, हम आपकी सदस्यता की पुष्टि कर रहे हैं।",
      "title": "आपका भुगतान सत्यापित किया जा रहा है..."
    },
    "subscription_details": {
      "billing_cycle": "बिलिंग चक्र",
      "next_billing_date": "अगली बिलिंग तिथि",
      "plan": "प्लान",
      "status": "स्थिति",
      "title": "सदस्यता विवरण"
    },
    "success_state": {
      "description": "आपका भुगतान सफलतापूर्वक संसाधित हो गया है और आपकी सदस्यता अब सक्रिय है।",
      "subtitle": "आपकी सदस्यता के लिए धन्यवाद",
      "title": "भुगतान सफल!"
    }
  },
  "plans": {
    "add_plan_btn": "योजना जोड़ें",
    "autogenerate_btn": "योजनाएँ स्वतः उत्पन्न करें",
    "description": "अपनी सदस्यता योजनाओं और मूल्य निर्धारण का प्रबंधन करें।",
    "no_plans": {
      "description": "अपनी पहली योजना बनाकर या कुछ डिफ़ॉल्ट योजनाएँ स्वतः उत्पन्न करके प्रारंभ करें।",
      "title": "कोई योजना नहीं"
    },
    "search_placeholder": "योजनाओं की खोज करें...",
    "table": {
      "description": "आपके सिस्टम में सभी सदस्यता योजनाओं की सूची।",
      "title": "सभी योजनाएँ"
    },
    "title": "योजनाएँ",
    "types": {
      "business": "व्यवसाय",
      "single": "एकल"
    }
  },
  "pricing_page": {
    "ai_smart_search_card": {
      "ai_powered": "",
      "cta": "",
      "deep_insights": "",
      "desc": "",
      "feature1": "",
      "feature2": "",
      "feature3": "",
      "feature4": "",
      "feature5": "",
      "intelligence": "",
      "title": ""
    },
    "badge": "",
    "buy_credits_card": {
      "any_amount": "",
      "badge": "",
      "cta": "",
      "feature1": "",
      "feature2": "",
      "feature3": "",
      "feature4": "",
      "feature5": "",
      "never_expires": "",
      "subtext": "",
      "title": "",
      "validity": ""
    },
    "desc": "",
    "property_listings_card": {
      "cta": "",
      "desc": "",
      "exposure": "",
      "feature1": "",
      "feature2": "",
      "feature3": "",
      "feature4": "",
      "feature5": "",
      "high_visibility": "",
      "list_reach": "",
      "title": ""
    },
    "title": ""
  },
  "privacy_policy": {
    "last_updated": "अंतिम अपडेट: 29 अक्टूबर 2026",
    "sections": {
      "ai": {
        "body_1": "LetMeIn AI प्लेटफ़ॉर्म की मुख्य सुविधाएँ देने के लिए AI और मशीन लर्निंग का उपयोग करता है।",
        "body_2_prefix": "यदि स्वचालित प्रसंस्करण आपको प्रभावित करता है, तो मानव समीक्षा के लिए संपर्क करें",
        "body_2_suffix": "ऐसा अनुरोध करने हेतु।",
        "items": {
          "image_search": {
            "label": "",
            "value": "If you use image-based property search, uploaded images are analyzed by AI/embedding models to identify property characteristics. Images used only for a one-off search request are not kept as permanent listing media unless you separately upload them to a listing."
          },
          "listing_assistant": {
            "label": "Listing Assistant (GenUI):",
            "value": "When you use conversational listing tools, messages and extracted listing fields are processed to build and update your draft or published listing."
          },
          "natural_language": {
            "label": "",
            "value": "Your search and listing prompts may be processed by large language models (including Google Gemini and related AI services) to interpret intent and generate responses. Prompt text may be sent to those providers under their data processing terms."
          },
          "recommendations": {
            "label": "",
            "value": ""
          },
          "voice_input": {
            "label": "",
            "value": "If you use voice search or voice listing input, audio is converted to text via speech services such as Sarvam AI and/or the browser Web Speech API. We do not permanently retain raw audio recordings. Transcripts may be cached briefly; duration and provider usage may be logged for billing and reliability."
          }
        },
        "title": "5. AI और स्वचालित प्रसंस्करण"
      },
      "changes": {
        "body_1": "हम समय-समय पर इस नीति को अपडेट कर सकते हैं।",
        "body_2": "अपडेट के बाद उपयोग जारी रखना संशोधित नीति की स्वीकृति माना जाएगा।",
        "items": {
          "email_notice": "परिवर्तन प्रभावी होने से पहले ईमेल सूचना भेजना।",
          "last_updated": "पेज के शीर्ष पर 'Last updated' तिथि अपडेट करना।",
          "platform_notice": "प्लेटफ़ॉर्म पर प्रमुख सूचना प्रदर्शित करना।"
        },
        "title": "13. इस गोपनीयता नीति में परिवर्तन"
      },
      "children": {
        "body_prefix": "LetMeIn AI 18 वर्ष से कम उम्र के लिए नहीं है। यदि किसी बच्चे का डेटा साझा हुआ है, तो कृपया संपर्क करें",
        "body_suffix": "और हम उसे तुरंत हटाएँगे।",
        "title": "11. बच्चों की गोपनीयता"
      },
      "collect": {
        "payment": {
          "body": "We use Stripe as our payment processor for subscriptions, plan changes, and credit/wallet top-ups where enabled. We do not store your full credit or debit card details on our servers. Stripe collects and processes payment data in accordance with PCI-DSS standards. We retain transaction IDs, plan or credit purchase details, wallet balance metadata, and billing history needed for accounting and support.",
          "title": "2.4 भुगतान जानकारी"
        },
        "personal": {
          "body": "पंजीकरण के समय आप जो जानकारी देते हैं, हम उसे एकत्र करते हैं:",
          "items": {
            "credentials": "यूज़रनेम और एन्क्रिप्टेड पासवर्ड क्रेडेंशियल्स",
            "location": "निवास का शहर, राज्य और देश",
            "name_contact": "पूरा नाम, ईमेल पता और फोन नंबर",
            "organization": "Organization or builder name and related business account details (for org / business accounts)",
            "photo": "प्रोफाइल फोटो (यदि प्रदान की गई हो)",
            "verification": "Identity verification details when enabled for your account (for example, Aadhaar verification via DigiLocker through our verification partner). We store limited verification status and, where provided, masked identifiers such as the last four digits—not your full Aadhaar number on our servers."
          },
          "title": "2.1 व्यक्तिगत जानकारी"
        },
        "property": {
          "body": "यदि आप मालिक/प्रबंधक हैं, तो आपकी सूचीबद्ध संपत्तियों का विवरण एकत्र किया जाता है:",
          "items": {
            "address": "संपत्ति का पता, लोकेशन कोऑर्डिनेट्स और क्षेत्र विवरण",
            "details": "संपत्ति का प्रकार, आकार, कमरों की संख्या और सुविधाएँ",
            "history": "किरायेदार इतिहास और लीज़ मेटाडेटा",
            "import_sources": "Listing content you import (for example spreadsheet rows, free-text paragraphs, or property portal URLs you submit for scraping/enrichment)",
            "media": "Photographs, videos, documents, and virtual tour content uploaded for listings",
            "pricing": "मूल्य, किराया शर्तें और उपलब्धता जानकारी"
          },
          "title": "2.2 संपत्ति जानकारी"
        },
        "title": "2. हम कौन सी जानकारी एकत्र करते हैं",
        "usage": {
          "body": "प्लेटफ़ॉर्म उपयोग के दौरान कुछ तकनीकी जानकारी स्वतः एकत्र होती है:",
          "items": {
            "behavior": "देखे गए पेज, समय और नेविगेशन पथ",
            "device": "आईपी पता, ब्राउज़र प्रकार, डिवाइस प्रकार और ऑपरेटिंग सिस्टम",
            "diagnostics": "Application error and performance diagnostics (for example via Sentry), which may include technical context needed to fix issues",
            "location_data": "स्थान डेटा (शहर-स्तर), यदि अनुमति दी गई हो",
            "maps": "Map interactions and geocoding requests (for example Google Maps / Places) when you set or search locations, including approximate coordinates you confirm on a map pin",
            "messages": "In-app notifications and message delivery metadata when realtime messaging features are enabled",
            "referral": "रेफरल स्रोत और UTM पैरामीटर्स",
            "search_queries": "AI सर्च में डाली गई खोज क्वेरी",
            "voice": "Voice input used for search or listing: audio is streamed or uploaded for speech-to-text (for example Sarvam AI or on-device Web Speech). We do not permanently store raw audio files. Transcript text may be cached briefly (typically up to about 30 minutes) to improve reliability, and usage metrics (such as duration) may be logged for billing and quality."
          },
          "title": "2.3 उपयोग और तकनीकी डेटा"
        }
      },
      "contact": {
        "body": "यदि आपके कोई प्रश्न या शिकायतें हैं, हमारी गोपनीयता टीम से संपर्क करें:",
        "email": "ईमेल:",
        "security": "सुरक्षा मुद्दे:",
        "sla": "हम 30 कैलेंडर दिनों के भीतर गोपनीयता अनुरोधों का उत्तर देने का प्रयास करते हैं।",
        "support": "सामान्य सहायता:",
        "team": "LetMeIn AI — गोपनीयता टीम",
        "title": "14. संपर्क करें"
      },
      "cookies": {
        "body_1": "हम अनुभव बेहतर बनाने के लिए कुकीज़ और समान ट्रैकिंग तकनीकों का उपयोग करते हैं।",
        "body_2": "आप ब्राउज़र सेटिंग्स से कुकीज़ नियंत्रित कर सकते हैं; कुछ कुकीज़ बंद करने से सुविधा प्रभावित हो सकती है।",
        "items": {
          "analytics": {
            "label": "",
            "value": ""
          },
          "essential": {
            "label": "",
            "value": ""
          },
          "preference": {
            "label": "",
            "value": ""
          },
          "third_party": {
            "label": "",
            "value": ""
          }
        },
        "title": "4. कुकीज़ और ट्रैकिंग तकनीकें",
        "types_title": "हम किस प्रकार की कुकीज़ उपयोग करते हैं"
      },
      "introduction": {
        "body_1": "Welcome to LetMeIn AI. We are an AI-powered real estate platform connecting property seekers, owners, organizations, and property managers. We primarily operate in India and may support additional markets when enabled for your account. We are committed to protecting your personal information and your right to privacy.",
        "body_2": "यह नीति बताती है कि हम आपकी जानकारी कैसे एकत्र, उपयोग, साझा और सुरक्षित करते हैं।",
        "title": "1. परिचय"
      },
      "retention": {
        "body_1": "हम डेटा उतने समय तक रखते हैं जितना आवश्यक या कानूनन जरूरी हो।",
        "body_2": "खाता हटाने पर आवश्यकतानुसार डेटा अनाम या हटाया जाता है।",
        "items": {
          "account": {
            "label": "",
            "value": ""
          },
          "listings": {
            "label": "",
            "value": ""
          },
          "logs": {
            "label": "",
            "value": ""
          },
          "marketing": {
            "label": "",
            "value": ""
          },
          "transactions": {
            "label": "",
            "value": "Retained for 7 years (or as required by applicable financial and tax rules), including credit/wallet purchase records."
          },
          "voice": {
            "label": "Voice Transcripts:",
            "value": "Raw audio is not permanently stored by us. Short-lived transcript cache entries (when enabled) typically expire within about 30 minutes."
          }
        },
        "title": "7. डेटा प्रतिधारण"
      },
      "rights": {
        "body_1": "Depending on your location and applicable law—including India’s Digital Personal Data Protection Act, 2023 (DPDP) where it applies—you may have the following rights with respect to your personal data:",
        "body_2_prefix": "इन अधिकारों के उपयोग हेतु संपर्क करें",
        "body_2_suffix": "हम 30 दिनों में उत्तर देंगे।",
        "items": {
          "access": {
            "label": "",
            "value": ""
          },
          "erasure": {
            "label": "",
            "value": ""
          },
          "object": {
            "label": "",
            "value": ""
          },
          "portability": {
            "label": "",
            "value": ""
          },
          "rectification": {
            "label": "",
            "value": ""
          },
          "restriction": {
            "label": "",
            "value": ""
          },
          "withdraw": {
            "label": "",
            "value": ""
          }
        },
        "title": "9. आपके गोपनीयता अधिकार"
      },
      "security": {
        "body_1": "हम उद्योग-मानक सुरक्षा उपाय अपनाते हैं।",
        "body_2_prefix": "यदि आपको लगता है खाता समझौता हुआ है, तुरंत संपर्क करें",
        "items": {
          "access": "",
          "audits": "",
          "https": "",
          "infrastructure": "",
          "passwords": "",
          "tokens": ""
        },
        "title": "8. डेटा सुरक्षा"
      },
      "sharing": {
        "body": "हम आपकी व्यक्तिगत जानकारी को बेचते, किराए पर देते या व्यापार नहीं करते।",
        "items": {
          "business": {
            "label": "",
            "value": ""
          },
          "consent": {
            "label": "",
            "value": ""
          },
          "legal": {
            "label": "",
            "value": ""
          },
          "listings": {
            "label": "",
            "value": ""
          },
          "providers": {
            "label": "",
            "value": "With trusted vendors who assist in operating our platform (for example Stripe for payments, Firebase/Google for authentication and AI, AWS for hosting and media storage, Sarvam AI for speech-to-text, Google Maps for location services, Pusher for realtime notifications, and error-monitoring providers such as Sentry), under appropriate contractual safeguards."
          }
        },
        "title": "6. आपकी जानकारी साझा करना"
      },
      "third_party": {
        "body_1": "हमारा प्लेटफ़ॉर्म कुछ तृतीय-पक्ष सेवाओं के साथ एकीकृत है।",
        "body_2": "इन सेवाओं की गोपनीयता नीतियों की समीक्षा करना आपकी जिम्मेदारी है।",
        "items": {
          "aws": {
            "label": "Amazon Web Services (AWS):",
            "link_text": "AWS Privacy",
            "value": "Application hosting and object storage / CDN for property media (for example via S3 and CloudFront on media.letmein.ai)."
          },
          "facebook": {
            "label": "Facebook (Meta):",
            "link_text": "Meta Privacy Policy",
            "value": "Optional social login via Facebook OAuth when enabled."
          },
          "google": {
            "label": "Google (Firebase, Gemini AI & Maps):",
            "link_text": "Google Privacy Policy",
            "value": "Authentication, App Check / reCAPTCHA, AI-powered search and listing assistance, and Maps / Places / geocoding features."
          },
          "pusher": {
            "label": "Pusher:",
            "link_text": "Pusher Privacy Policy",
            "value": "Realtime in-app notifications and presence when messaging features are enabled."
          },
          "sarvam": {
            "label": "Sarvam AI:",
            "link_text": "Sarvam",
            "value": "Speech-to-text for voice search and voice listing input when Sarvam is enabled for your deployment."
          },
          "sentry": {
            "label": "Sentry:",
            "link_text": "Sentry Privacy Policy",
            "value": "Application error and performance monitoring to keep the service reliable."
          },
          "stripe": {
            "label": "Stripe:",
            "link_text": "Stripe Privacy Policy",
            "value": "Payment processing for subscriptions and credit/wallet top-ups."
          },
          "surepass": {
            "label": "Surepass / DigiLocker (when enabled):",
            "link_text": "Partner terms",
            "value": "Optional Aadhaar / DigiLocker identity verification for eligible accounts."
          }
        },
        "title": "10. तृतीय-पक्ष सेवाएँ"
      },
      "transfers": {
        "body_1": "LetMeIn AI is primarily operated from India. Some third-party providers (such as Google, Stripe, AWS, Sarvam, Sentry, or Pusher) may process data in other countries, including the United States and the European Union. When we transfer personal data internationally, we take steps to ensure adequate protections are in place, including:",
        "items": {
          "compliance": "वैश्विक डेटा सुरक्षा मानकों का अनुपालन सुनिश्चित करना",
          "dpas": "तृतीय-पक्ष प्रोसेसर के साथ DPA हस्ताक्षर",
          "frameworks": "उपयुक्त अंतरराष्ट्रीय डेटा ट्रांसफर फ्रेमवर्क वाले प्रदाताओं का उपयोग"
        },
        "title": "12. अंतरराष्ट्रीय डेटा स्थानांतरण"
      },
      "use": {
        "body": "हम एकत्रित जानकारी का उपयोग निम्न उद्देश्यों के लिए करते हैं:",
        "items": {
          "account_management": {
            "label": "",
            "value": ""
          },
          "ai_matching": {
            "label": "",
            "value": "To power personalized property recommendations, AI search, conversational listing assistants (GenUI), embeddings-based matching, and related natural language features."
          },
          "analytics": {
            "label": "",
            "value": ""
          },
          "communications": {
            "label": "",
            "value": ""
          },
          "fraud_prevention": {
            "label": "",
            "value": ""
          },
          "legal_compliance": {
            "label": "",
            "value": ""
          },
          "listing_tools": {
            "label": "Listing & Import Tools:",
            "value": "To help you create and manage listings, including AI-assisted listing chat and optional import from files or property URLs you provide."
          },
          "marketing": {
            "label": "",
            "value": ""
          },
          "payment_processing": {
            "label": "",
            "value": "To manage subscriptions and credit/wallet purchases, process upgrades or top-ups, and track usage-based billing (including AI, voice, and maps usage where metered)."
          },
          "service_delivery": {
            "label": "",
            "value": ""
          }
        },
        "title": "3. हम आपकी जानकारी का उपयोग कैसे करते हैं"
      }
    },
    "summary": "This Privacy Policy describes how LetMeIn AI (\"we\", \"us\", or \"our\") collects, uses, stores, and protects your personal information when you use our website, apps, and services. By using LetMeIn AI, you agree to the practices described in this policy.",
    "title": "गोपनीयता नीति"
  },
  "profile": {
    "account_settings": "खाता सेटिंग्स",
    "add_area_placeholder": "एक क्षेत्र जोड़ें (जैसे हाइटेक सिटी)",
    "add_manually": "फिर भी कस्टम क्षेत्र के रूप में जोड़ें",
    "appearance": "दिखावट",
    "appearance_settings": "दिखावट सेटिंग्स",
    "appearance_tab": {
      "auto_save": "ऑटो-सेव सक्षम",
      "auto_save_desc": "आपकी थीम प्राथमिकता स्वचालित रूप से सहेजी जाती है और आपके सभी सत्रों में लागू होगी।",
      "theme_mode": "थीम मोड",
      "theme_mode_desc": "लाइट और डार्क थीम के बीच टॉगल करें",
      "theme_pref": "थीम प्राथमिकताएं",
      "theme_pref_desc": "लाइट और डार्क मोड के बीच स्विच करें"
    },
    "basic_profile_info": "आपकी मूल प्रोफ़ाइल जानकारी",
    "billing_locale": "बिलिंग और वॉलेट",
    "billing_locale_desc": "पंजीकरण पर सेट। वॉलेट के उपयोग में आने के बाद बदलने के लिए सहायता से संपर्क करें।",
    "confirm_new_password": "नया पासवर्ड पुष्टि करें",
    "connected_accounts": "जुड़े हुए खाते",
    "control_notifications": "नियंत्रित करें कि आप सूचनाएं कैसे प्राप्त करते हैं",
    "customize_look_feel": "अपने एप्लिकेशन के रूप और अनुभव को अनुकूलित करें",
    "default_location": "डिफ़ॉल्ट स्थान",
    "edit_profile": "प्रोफ़ाइल संपादित करें",
    "email_address": "ईमेल पता",
    "enter_new_password_placeholder": "नया पासवर्ड दर्ज करें",
    "enter_old_password_placeholder": "अपना पुराना पासवर्ड दर्ज करें",
    "first_name": "पहला नाम",
    "identity": {
      "card_desc": "Your Aadhaar details are used only for identity verification and are not shared publicly.",
      "card_title": "Aadhaar verification",
      "consent": "I consent to Aadhaar verification for identity purposes on LetMeIn AI.",
      "consent_required": "Please accept the consent to continue.",
      "description": "Verify your identity using Aadhaar to build trust on the platform.",
      "digilocker_hint": "आधार OTP सत्यापन सुरक्षित रूप से पूरा करने के लिए आपको डिजीलॉकर पर रीडायरेक्ट किया जाएगा।",
      "info": "Verification helps owners, tenants, and property managers establish trust for listings and interactions.",
      "masked_aadhaar": "Aadhaar ending in {{lastFour}}",
      "pending": "सत्यापन प्रगति पर है। हम स्थिति जाँच रहे हैं...",
      "status_failed": "सत्यापन स्थिति प्राप्त नहीं हो सकी।",
      "status_unverified": "Not verified",
      "status_verified": "Verified",
      "tab_label": "Identity",
      "title": "Identity verification",
      "verified_message": "Your Aadhaar identity has been verified.",
      "verify_failed": "आधार सत्यापन विफल। कृपया पुनः प्रयास करें।",
      "verify_success": "आधार सफलतापूर्वक सत्यापित हो गया।",
      "verify_with_digilocker": "डिजीलॉकर से सत्यापित करें",
      "verifying": "Verifying..."
    },
    "last_name": "अंतिम नाम",
    "location_tab": {
      "loc_pref": "स्थान प्राथमिकताएं",
      "loc_pref_desc": "अपना पसंदीदा देश और शहर निर्धारित करें",
      "privacy": "गोपनीयता जानकारी",
      "privacy_desc": "आपकी स्थान प्राथमिकता आपके ब्राउज़र में स्थानीय रूप से संग्रहीत है। यह सेटिंग हमें हमारे सर्वर पर सटीक जीपीएस डेटा संग्रहीत किए बिना आपके अनुभव को अनुकूलित करने में मदद करती है।",
      "save_prefs": "प्राथमिकताएं सहेजें"
    },
    "manage_auth_methods": "अपनी लॉगिन विधियाँ और सोशल खाते जोड़ें या हटाएँ",
    "manage_location_prefs": "अपने डिफ़ॉल्ट देश और शहर की प्राथमिकताओं को प्रबंधित करें",
    "manage_org_public_info": "अपने संगठन की सार्वजनिक जानकारी प्रबंधित करें",
    "manage_profile_preferences": "अपनी प्रोफ़ाइल और प्राथमिकताएं प्रबंधित करें",
    "messages": {
      "account_link_failed": "{{provider}} खाता जोड़ने में विफल",
      "account_linked": "{{provider}} खाता सफलतापूर्वक जोड़ा गया!",
      "account_unlink_failed": "{{provider}} खाता हटाने में विफल",
      "account_unlinked": "{{provider}} खाता सफलतापूर्वक हटाया गया!",
      "enter_old_password": "कृपया अपना पुराना पासवर्ड दर्ज करें।",
      "location_invalid": "कृपया अपने देश में समर्थित शहर चुनें।",
      "location_update_failed": "स्थान वरीयताओं को अपडेट करने में विफल रहा",
      "location_updated": "स्थान वरीयताएँ सफलतापूर्वक अपडेट की गईं",
      "notification_permission_blocked": "सूचनाएँ अवरुद्ध हैं। कृपया उन्हें अपनी ब्राउज़र सेटिंग्स में सक्षम करें।",
      "notification_permission_denied": "सूचना की अनुमति अस्वीकृत",
      "notification_update_failed": "अधिसूचना प्राथमिकताएं अपडेट करने में विफल",
      "notification_update_success": "अधिसूचना प्राथमिकताएं सफलतापूर्वक अपडेट की गईं!",
      "notifications_not_supported": "इस ब्राउज़र में ब्राउज़र सूचनाएँ समर्थित नहीं हैं",
      "old_password_incorrect": "पुराना पासवर्ड गलत है।",
      "passwords_do_not_match": "पासवर्ड मेल नहीं खाते।",
      "profile_update_failed": "प्रोफ़ाइल अपडेट करने में विफल। कृपया पुन: प्रयास करें।",
      "profile_updated": "प्रोफ़ाइल सफलतापूर्वक अपडेट की गई!",
      "sw_not_supported": "इस ब्राउज़र में सर्विस वर्कर्स समर्थित नहीं हैं",
      "unlink_confirm": "क्या आप वाकई अपना {{provider}} खाता हटाना चाहते हैं?",
      "web_push_disabled": "ब्राउज़र सूचनाएँ अक्षम की गईं",
      "web_push_enabled": "ब्राउज़र सूचनाएँ सफलतापूर्वक सक्षम की गईं",
      "web_push_failed": "ब्राउज़र सूचनाएँ सक्षम करने में विफल"
    },
    "new_password": "नया पासवर्ड",
    "no_areas_added": "अभी तक कोई क्षेत्र नहीं जोड़ा गया है। उन क्षेत्रों को जोड़ें जहाँ आप कार्य करते हैं।",
    "no_matching_areas": "के लिए कोई मेल खाता क्षेत्र नहीं मिला",
    "notification_preferences": "अधिसूचना प्राथमिकताएं",
    "notifications": "सूचनाएं",
    "notifications_tab": {
      "email": "ईमेल सूचनाएं",
      "email_desc": "ईमेल के माध्यम से सूचनाएं प्राप्त करें",
      "in_app": "इन-ऐप सूचनाएं",
      "in_app_desc": "एप्लिकेशन के भीतर सूचनाएं प्राप्त करें",
      "settings_desc": "अपनी अधिसूचना प्राथमिकताओं को प्रबंधित करें",
      "settings_title": "अधिसूचना सेटिंग्स",
      "storage_desc": "आपकी अधिसूचना प्राथमिकताएं आपके खाते में सुरक्षित रूप से संग्रहीत हैं और आपके सभी उपकरणों पर लागू होंगी।",
      "storage_title": "प्राथमिकता भंडारण",
      "web_push": "ब्राउज़र सूचनाएँ",
      "web_push_desc": "ऐप बंद होने पर भी सूचनाएँ प्राप्त करें"
    },
    "old_password": "पुराना पासवर्ड",
    "operating_areas": "परिचालन क्षेत्र",
    "operating_areas_desc": "उन विशिष्ट क्षेत्रों को सूचीबद्ध करें जहाँ आप संपत्ति प्रबंधन सेवाएँ प्रदान करते हैं",
    "org_tab": {
      "address": "पता",
      "description": "विवरण",
      "name": "बिल्डर का नाम",
      "phone": "फ़ोन",
      "save_details": "विवरण सहेजें",
      "slug": "स्लग",
      "website": "वेबसाइट"
    },
    "organization": "संगठन",
    "organization_profile": "संगठन प्रोफ़ाइल",
    "password_settings": "पासवर्ड सेटिंग्स",
    "personal_details": "व्यक्तिगत विवरण",
    "profile": "प्रोफ़ाइल",
    "profile_information": "प्रोफ़ाइल जानकारी",
    "reenter_new_password_placeholder": "नया पासवर्ड फिर से दर्ज करें",
    "regional_settings": "क्षेत्रीय सेटिंग्स",
    "set_password_placeholder": "अपना पासवर्ड सेट करें",
    "social_account": "लॉगिन विधियाँ",
    "social_tab": {
      "auth_methods": "प्रमाणीकरण विधियाँ",
      "auth_methods_desc": "लॉगिन प्रदाताओं को जोड़ें या हटाएँ",
      "connected": "जुड़ा हुआ",
      "link": "जोड़ें",
      "linking": "जोड़ा जा रहा है...",
      "no_providers": "कोई प्रदाता नहीं मिला",
      "not_connected": "जुड़ा नहीं",
      "providers": {
        "email": "ईमेल/पासवर्ड",
        "facebook": "फेसबुक",
        "google": "गूगल",
        "phone": "फ़ोन"
      },
      "set_password": "खाता पासवर्ड सेट करें",
      "set_password_btn": "पासवर्ड सेट करें",
      "set_password_desc": "सोशल लॉगिन के अलावा ईमेल/पासवर्ड से भी लॉगिन करने के लिए पासवर्ड जोड़ें।",
      "unlink": "हटाएँ"
    },
    "update_profile_info": "अपनी व्यक्तिगत जानकारी और खाता सेटिंग्स अपडेट करें"
  },
  "property": {
    "add_to_favourites": "पसंद में जोड़ें",
    "address": "पता",
    "age_const": "निर्माण की आयु",
    "amenities_count_one": "{{count}} सुविधाएँ और विशेषताएँ — विवरण देखें",
    "amenities_count_other": "{{count}} सुविधाएँ और विशेषताएँ — विवरण देखें",
    "amenities_title": "प्रमुख सुविधाएं",
    "apartment_name": "",
    "area_type": "क्षेत्र प्रकार",
    "available_floors": "उपलब्ध मंजिलें",
    "available_from": "उपलब्धता / मूव-इन",
    "available_services": "उपलब्ध सेवाएँ",
    "back_to_my_properties": "मेरी संपत्तियों पर वापस",
    "back_to_properties": "लिस्टिंग पेज पर वापस",
    "balconies": "बालकनियाँ",
    "bathrooms": "स्नानघर",
    "baths_one": "{{count}} बाथ",
    "baths_other": "{{count}} बाथ",
    "bedrooms": "शयनकक्ष",
    "brochure": "ब्रोशर डाउनलोड करें",
    "built_up_area": "निर्मित क्षेत्र",
    "by_owner": "{{name}} द्वारा",
    "collapse_room_details": "कमरे का विवरण समेटें",
    "commercial_subtype": "व्यावसायिक उप-प्रकार",
    "common_area_amenities_title": "सामान्य क्षेत्र की सुविधाएं",
    "compare": "प्रोजेक्ट्स की तुलना करें",
    "connectivity_title": "कनेक्टिविटी और पारगमन",
    "contact_failed": "बातचीत शुरू करने में विफल। कृपया पुनः प्रयास करें।",
    "contact_loc": "सही स्थान के लिए संपर्क करें",
    "contact_owner": "मालिक से संपर्क करें",
    "contact_unavailable": "इस संपत्ति के लिए संपर्क जानकारी उपलब्ध नहीं है।",
    "corner_shop": "कोने की दुकान",
    "curfew": "कर्फ़्यू: {{time}}",
    "default_description": "इस सुंदर संपत्ति में आपका स्वागत है। अच्छी तरह से रखरखाव की गई और प्रमुख क्षेत्र में स्थित, यह आराम और सुविधा का संतुलन प्रदान करती है। अधिक जानकारी और विज़िट शेड्यूल करने के लिए हमसे संपर्क करें।",
    "delete": "हटाएँ",
    "deposit": "जमा राशि",
    "desc_title": "संपत्ति का विवरण",
    "dev_owner": "डेवलपर / मालिक",
    "developer": "डेवलपर",
    "dimensions": "आयाम",
    "directions": "",
    "edit": "संपादित करें",
    "expand_room_details": "कमरे का विवरण खोलें",
    "external_source": "मूल वेबसाइट",
    "extra_parameters_title": "",
    "facing": "मुख दिशा",
    "favourite": "पसंद",
    "fit_out": "फिट-आउट स्थिति",
    "floor": "मंजिल",
    "floor_details": "मंज़िल विवरण",
    "floor_level": "मंजिल स्तर",
    "floor_n": "मंजिल {{n}}",
    "floor_out_of": "मंजिल {{n}} ({{total}} में से)",
    "food_available": "भोजन उपलब्ध",
    "food_meals": "भोजन और आहार",
    "for": "के लिए",
    "for_rent": "किराये के लिए",
    "for_sale": "बिक्री के लिए",
    "furnishing": "फर्नीचर",
    "furnishing_status": "फर्निशिंग स्थिति",
    "gate_curfew": "गेट बंद होने का समय",
    "get_contact": "फोन और पता प्राप्त करें",
    "go_back": "वापस जाएं",
    "ground": "ग्राउंड",
    "highlights_title": "संपत्ति की मुख्य विशेषताएं",
    "house_rules": "घर के नियम",
    "immediate": "तुरंत",
    "in": "में",
    "individual": "व्यक्तिगत",
    "lifts": "लिफ्ट / एलिवेटर",
    "listing_date": "लिस्टिंग की तारीख",
    "loc_not_spec": "स्थान निर्दिष्ट नहीं है",
    "login_contact": "मालिक से संपर्क करने के लिए कृपया लॉगिन करें",
    "login_favourites": "पसंद में जोड़ने के लिए कृपया लॉगिन करें",
    "main_road_facing": "मुख्य सड़क की ओर",
    "maintenance_charges": "रखरखाव शुल्क",
    "maintenance_included": "रखरखाव शामिल",
    "map_pin_hidden": "खोज मानचित्र से छिपा हुआ",
    "map_pin_visible": "खोज मानचित्र पर दिखाई दे रहा है",
    "media_next": "अगला मीडिया",
    "media_play": "वीडियो चलाएं",
    "media_previous": "पिछला मीडिया",
    "monthly": "मासिक",
    "more_details_title": "अधिक विवरण",
    "move_in": "मूव-इन",
    "na": "N/A",
    "nearby_places_title": "आस-पास के स्थान",
    "negotiable": "परक्राम्य",
    "no_curfew": "कोई कर्फ़्यू नहीं",
    "no_food": "भोजन शामिल नहीं",
    "no_image": "कोई छवि नहीं",
    "no_photos": "कोई फोटो उपलब्ध नहीं है",
    "not_found": "संपत्ति नहीं मिली",
    "not_specified": "निर्दिष्ट नहीं",
    "open_full_page": "",
    "out_of": "में से",
    "out_of_total": "({{total}} में से)",
    "parking": "पार्किंग",
    "parking_spaces_one": "{{count}} स्थान",
    "parking_spaces_other": "{{count}} स्थान",
    "parking_spaces_plural_one": "{{count}} स्थान",
    "parking_spaces_plural_other": "{{count}} स्थान",
    "per_bed_mo": "/बिस्तर/माह",
    "pg_avail_from": "उपलब्ध: {{date}}",
    "pg_available_for_all": "सभी किरायेदार",
    "pg_available_for_anyone": "को-एड / कोई भी",
    "pg_available_for_boys": "केवल लड़के",
    "pg_available_for_girls": "केवल लड़कियाँ",
    "pg_bed_sharing": "{{count}} बेड शेयरिंग",
    "pg_food_3_meals": "3 भोजन शामिल ({{meals}})",
    "pg_food_included": "भोजन शामिल",
    "pg_food_meals_included": "{{meals}} शामिल",
    "pg_food_self_cooking": "स्वयं खाना / भोजन नहीं",
    "pg_name": "PG नाम",
    "pg_present_in": "PG कहाँ स्थित है",
    "pg_rooms_one_one": "{{count}} कमरा",
    "pg_rooms_one_other": "{{count}} कमरा",
    "pg_rooms_other_one": "{{count}} कमरे",
    "pg_rooms_other_other": "{{count}} कमरे",
    "pg_service_laundry": "लॉन्ड्री",
    "pg_service_room_cleaning": "कमरे की सफाई",
    "pg_service_warden": "वार्डन सुविधा",
    "pg_sharing_named": "{{name}} शेयरिंग",
    "pg_usps": "विशेष आकर्षण",
    "pg_usps_sub": "इस PG की मुख्य विशेषताएँ और लाभ",
    "photo_one_one": "{{count}} फोटो",
    "photo_one_other": "{{count}} फोटो",
    "photo_other_one": "{{count}} फोटो",
    "photo_other_other": "{{count}} फोटो",
    "plot_area": "प्लॉट क्षेत्र",
    "poc": "संपर्क व्यक्ति",
    "preferred_tenants": "",
    "price_breakup": "मूल्य विवरण",
    "price_rent": "किराये के लिए",
    "price_sale": "बिक्री के लिए",
    "property_name": "",
    "property_sub_type": "संपत्ति उप-प्रकार",
    "property_type": "संपत्ति प्रकार",
    "ready_to_move": "रहने के लिए तैयार",
    "remove_from_favourites": "पसंद से हटाएँ",
    "rent": "किराये",
    "rera_approved": "RERA स्वीकृत",
    "room_facilities_title": "कमरे की सुविधाएं",
    "room_photos": "कमरे की तस्वीरें",
    "room_photos_empty": "इस शेयरिंग विकल्प के लिए अभी कोई रूम फोटो अपलोड नहीं की गई है",
    "room_type": "कमरे का प्रकार",
    "sale": "बिक्री",
    "search_map_pin": "खोज मानचित्र पिन",
    "security_deposit": "सुरक्षा जमा",
    "share": "",
    "share_copied": "",
    "share_copy_failed": "",
    "share_copy_link": "",
    "share_default_title": "",
    "share_device": "",
    "share_facebook": "",
    "share_instagram": "",
    "share_instagram_copied": "",
    "share_link_copied": "",
    "share_whatsapp": "",
    "shared_room": "साझा कमरा",
    "sharing": "रूम शेयरिंग",
    "source": "स्रोत",
    "status": "स्थिति",
    "suitable_for": "उपयुक्त",
    "super_area": "बिल्ट-अप क्षेत्र",
    "total_floors": "कुल मंजिलें",
    "total_views": "कुल दृश्य",
    "truck_access": "ट्रक पहुँच",
    "types": {
      "agricultural_land": "कृषि भूमि",
      "apartment": "अपार्टमेंट",
      "builder_floor_apartment": "बिल्डर फ्लोर अपार्टमेंट",
      "bungalow": "बंगला",
      "co_living_space": "को-लिविंग स्पेस",
      "commercial": "व्यावसायिक",
      "commercial_plot": "व्यावसायिक प्लॉट",
      "development_land": "डेवलपमेंट लैंड",
      "duplex_house": "डुप्लेक्स हाउस",
      "farm_house": "फार्म हाउस",
      "farm_land": "फार्म लैंड",
      "gated_community_house": "गेटेड कम्युनिटी हाउस",
      "gated_community_villa": "गेटेड कम्युनिटी विला",
      "hostel": "हॉस्टल",
      "house": "हाउस",
      "independent_house": "स्वतंत्र हाउस",
      "independent_villa": "स्वतंत्र विला",
      "industrial_land": "औद्योगिक भूमि",
      "industrial_plot": "औद्योगिक प्लॉट",
      "land": "प्लॉट",
      "na_plot": "गैर-कृषि प्लॉट",
      "paying_guest": "पेइंग गेस्ट",
      "penthouse": "पेंटहाउस",
      "pg": "पीजी",
      "pg_accommodation": "पीजी आवास",
      "plot": "प्लॉट",
      "residential_plot": "आवासीय प्लॉट",
      "row_house": "रो हाउस",
      "service_apartment": "सर्विस अपार्टमेंट",
      "studio_apartment": "स्टूडियो अपार्टमेंट",
      "triplex_house": "ट्रिपलेक्स हाउस",
      "villa": "विला"
    },
    "under_const": "निर्माणाधीन",
    "unfurnished": "बिना फर्नीचर के",
    "video_tour": "संपत्ति वीडियो टूर",
    "view": "देखें",
    "view_details": "विवरण देखें",
    "visit_site": "साइट देखें",
    "washrooms": "वॉशरूम",
    "yes": "हाँ"
  },
  "property_draft": {
    "confirm_delete_desc": "क्या आप वाकई में इस ड्राफ्ट को हटाना चाहते हैं? यह संपत्ति और उसकी चैट प्रगति हटा दी जाएगी।",
    "confirm_delete_title": "ड्राफ्ट हटाएं?",
    "delete_draft": "ड्राफ्ट हटाएं",
    "delete_failed": "ड्राफ्ट हटाने में विफल",
    "deleted_success": "ड्राफ्ट सफलतापूर्वक हटाया गया",
    "resume": {
      "continue": "पिछली लिस्टिंग पूरी करें",
      "description": "आपकी एक अधूरी संपत्ति लिस्टिंग है। क्या आप वहीं से जारी रखना चाहेंगे या नई शुरू करेंगे?",
      "failed": "आपकी लिस्टिंग फिर से शुरू नहीं हो सकी। आप दाईं ओर प्रीव्यू में संपादन कर सकते हैं।",
      "start_new": "नई लिस्टिंग शुरू करें",
      "title": "अपनी पिछली लिस्टिंग पूरी करें?",
      "untitled": "बिना शीर्षक का ड्राफ्ट"
    },
    "status": {
      "error": "सहेजना विफल",
      "saved": "सहेजा गया",
      "saving": "सहेज रहे हैं..."
    }
  },
  "property_edit_modal": {
    "close_aria": "प्रॉपर्टी संपादन डायलॉग बंद करें",
    "errors": {
      "invalid_price_type": "अमान्य लिस्टिंग उद्देश्य।",
      "invalid_property_type": "अमान्य संपत्ति प्रकार। अपार्टमेंट, हाउस, विला, व्यावसायिक, प्लॉट/जमीन या PG चुनें।",
      "invalid_status": "अमान्य लिस्टिंग स्थिति।",
      "pin_update_required": "पता बदल गया। मैप पिन अपडेट करें, फिर सेव करें।",
      "reserved_attribute_key": "यह कुंजी सिस्टम के लिए रिजर्व्ड है। कृपया कस्टम नाम उपयोग करें।",
      "title_required": "शीर्षक आवश्यक है",
      "update_failed": "प्रॉपर्टी अपडेट नहीं हो सकी। कृपया फिर से प्रयास करें।",
      "valid_price_required": "मान्य कीमत आवश्यक है"
    },
    "subtitle": "सभी विवरण, मीडिया और विशेषताएँ एक स्थान पर अपडेट करें",
    "title": "प्रॉपर्टी संपादित करें"
  },
  "property_listing": {
    "actions": {
      "post_property": "संपत्ति पोस्ट करें"
    },
    "alerts": {
      "choose_excel_file": "कृपया Excel फ़ाइल (.xlsx) चुनें।",
      "confirm_delete_property": "क्या आप वाकई इस संपत्ति को हटाना चाहते हैं?",
      "delete_failed": "संपत्ति हटाने में विफल।",
      "property_updated": "संपत्ति सफलतापूर्वक अपडेट हो गई!",
      "update_failed": "संपत्ति अपडेट करने में विफल: {{error}}",
      "upgrade_failed_after_post": "आपकी संपत्ति पोस्ट हो गई! लेकिन हम आपकी भूमिका को स्वतः अपग्रेड नहीं कर पाए। कृपया सपोर्ट से संपर्क करें।"
    },
    "bulk_import": {
      "ai_chat": "एआई चैट",
      "btn_web_import": "मानचित्र पर लिस्टिंग आयात और समीक्षा करें",
      "card_web_import": "अन्य वेबसाइट से आयात करें",
      "excel_file": "एक्सेल फ़ाइल",
      "import_failed": "",
      "import_for_user": "उपयोगकर्ता के लिए आयात करें",
      "invalid_file_type": "कृपया मान्य Excel (.xlsx) या CSV (.csv) फ़ाइल ड्रॉप करें।",
      "my_account": "मेरा खाता",
      "page": {
        "attr_core": "मुख्य विशिष्टताएँ",
        "attr_location": "स्थान और मैप पिन",
        "attr_media": "मीडिया और सुविधाएँ",
        "browse_computer": "कंप्यूटर से चुनें",
        "change_file": "बदलें",
        "clear": "साफ़ करें",
        "coming_soon": "जल्द आ रहा है",
        "compatible_portals": "संगत रियल एस्टेट पोर्टल",
        "confirm_delete_all": "क्या आप वाकई सभी {{count}} ड्राफ्ट लिस्टिंग स्थायी रूप से हटाना चाहते हैं? यह क्रिया पूर्ववत नहीं हो सकती।",
        "confirm_delete_one": "क्या आप वाकई यह ड्राफ्ट लिस्टिंग हटाना चाहते हैं?",
        "confirm_delete_selected": "क्या आप वाकई {{count}} चयनित ड्राफ्ट लिस्टिंग हटाना चाहते हैं?",
        "crawl_ready": "मल्टी-थ्रेडेड AI क्रॉल तैयार",
        "crawl_review": "क्रॉल करें और मानचित्र पर समीक्षा करें",
        "crawling": "AI से संपत्ति विवरण और फ़ोटो क्रॉल हो रहे हैं...",
        "delete_all": "सभी हटाएँ",
        "delete_all_failed": "सभी ड्राफ्ट हटाने में विफल।",
        "delete_draft_tooltip": "ड्राफ्ट हटाएँ",
        "delete_one_failed": "ड्राफ्ट हटाने में विफल।",
        "delete_selected": "हटाएँ ({{count}})",
        "delete_selected_failed": "कुछ ड्राफ्ट हटाने में विफल।",
        "deleted_all": "सभी {{count}} ड्राफ्ट हटाए गए।",
        "deleted_drafts": "{{count}} ड्राफ्ट हटाए गए।",
        "direct_import": "सीधा आयात (ड्राफ्ट के रूप में सहेजें)",
        "download_paragraph_failed": "पैराग्राफ टेम्पलेट डाउनलोड विफल।",
        "download_standard_failed": "मानक टेम्पलेट डाउनलोड विफल।",
        "draft_deleted": "ड्राफ्ट हटाया गया।",
        "draft_missing_coords": "इस ड्राफ्ट में कीमत या स्थान निर्देशांक नहीं हैं। पहले \"संपादित करें\" या \"मानचित्र पर समीक्षा\" करें।",
        "drafts_desc": "इंटरैक्टिव मैप पर समीक्षा/संपादन करें, या लंबित ड्राफ्ट को लाइव खोज पर बैच प्रकाशित करें।",
        "drafts_title": "सहेजी ड्राफ्ट लिस्टिंग",
        "drafts_total": "{{count}} कुल",
        "drop_active": "अपलोड करने के लिए स्प्रेडशीट यहाँ छोड़ें",
        "drop_here": "अपनी संपत्ति शीट यहाँ खींचें और छोड़ें",
        "enter_url": "कृपया कम से कम एक मान्य संपत्ति URL दर्ज करें।",
        "facebook": "फेसबुक",
        "facebook_desc": "Facebook Marketplace लिस्टिंग और रियल एस्टेट ग्रुप पोस्ट से एक क्लिक में आयात करें।",
        "filter_all": "सभी ({{count}})",
        "filter_needs_pin": "पिन चाहिए ({{count}})",
        "filter_pinned": "पिन किए ({{count}})",
        "format_columns": "मानक कॉलम",
        "format_columns_desc": "BHK, कीमत, इलाके के लिए संरचित हेडर",
        "format_paragraph": "AI स्मार्ट पैराग्राफ",
        "format_paragraph_desc": "AI द्वारा पार्स किए जाने वाले मुक्त पाठ नोट्स",
        "import_finished": "आयात पूरा: {{success}} आयात, {{failed}} विफल।",
        "import_first": "अपनी पहली संपत्तियाँ आयात करें",
        "import_queued": "आयात बैकग्राउंड वर्कर में कतारबद्ध!",
        "import_success": "{{count}} संपत्तियाँ सफलतापूर्वक आयात हुईं!",
        "importing_urls": "{{count}} लिस्टिंग URL आयात और पार्स हो रहे हैं...",
        "insert_sample_urls": "नमूना URL डालें",
        "instagram": "इंस्टाग्राम",
        "instagram_desc": "पोस्ट या रील लिंक पेस्ट करें। AI फ़ोटो, कीमत, BHK और कैप्शन अपने आप निकालता है।",
        "loading_drafts": "सहेजे ड्राफ्ट लोड हो रहे हैं...",
        "location_pinned": "स्थान पिन किया",
        "multi_portal_badge": "मल्टी-पोर्टल AI क्रॉलर",
        "need_import_now": "अभी लिस्टिंग आयात करनी है?",
        "need_import_now_desc": "आज आप बल्क स्प्रेडशीट अपलोड कर सकते हैं या वेब लिस्टिंग URL से सीधे आयात कर सकते हैं।",
        "needs_location_pin": "स्थान पिन चाहिए",
        "no_drafts": "कोई सहेजा ड्राफ्ट नहीं",
        "no_drafts_desc": "आपके पास कोई लंबित ड्राफ्ट नहीं है। अधूरी संपत्तियाँ, बल्क अपलोड या वेब आयात यहाँ दिखेंगे।",
        "no_drafts_match": "आपकी खोज या फ़िल्टर से कोई ड्राफ्ट मेल नहीं खाता।",
        "no_valid_rows": "शीट में कोई मान्य संपत्ति पंक्ति नहीं मिली। कृपया टेम्पलेट जाँचें।",
        "none_ready_publish": "चयनित ड्राफ्ट में मान्य शीर्षक/कीमत और मैप पिन नहीं है। पहले \"मानचित्र पर समीक्षा\" से पिन लगाएँ।",
        "page_subtitle": "स्प्रेडशीट अपलोड करें, संपत्ति वेब लिंक स्क्रैप करें, या सहेजे ड्राफ्ट प्रबंधित करें।",
        "parse_failed": "AI से शीट पार्स करने में विफल।",
        "parsing_desc": "समीक्षा स्क्रीन खोलने से पहले BHK, कीमत, सुविधाएँ और मैप पिन निकाले जा रहे हैं।",
        "parsing_title": "AI आपकी संपत्ति लिस्टिंग पार्स और जियोलोकेट कर रहा है...",
        "portal_custom": "कस्टम लिस्टिंग लिंक",
        "portal_independent": "स्वतंत्र बिल्डर साइटें",
        "preview_on_map": "मानचित्र पर पूर्वावलोकन और समीक्षा",
        "processing_ai": "AI से प्रोसेस हो रहा है...",
        "publish": "प्रकाशित करें",
        "publish_failed": "ड्राफ्ट प्रकाशित करने में विफल।",
        "publish_ready": "तैयार प्रकाशित करें ({{count}})",
        "publish_ready_failed": "तैयार ड्राफ्ट प्रकाशित करने में विफल। कृपया पुनः प्रयास करें।",
        "publish_selected": "चयनित प्रकाशित करें ({{count}})",
        "publish_tooltip": "सीधे लाइव लिस्टिंग पर प्रकाशित करें",
        "ready_for_parsing": "पार्सिंग के लिए तैयार",
        "recommended_hint": "सुझाव: मानचित्र पर समीक्षा से पते जाँचें, निर्देशांक समायोजित करें और प्रकाशित करने से पहले विवरण देखें।",
        "refresh_drafts": "ड्राफ्ट रीफ़्रेश करें",
        "remove_file": "फ़ाइल हटाएँ",
        "review_all_on_map": "सभी मानचित्र पर समीक्षा",
        "review_on_map_n": "मानचित्र पर समीक्षा ({{count}})",
        "review_pin": "पिन समीक्षा",
        "review_pin_tooltip": "लिस्टिंग संपादित करें और इंटरैक्टिव मैप पर पिन जाँचें",
        "row_error": "पंक्ति {{row}}: {{title}} — {{error}}",
        "search_drafts_placeholder": "शीर्षक, स्थान से ड्राफ्ट खोजें...",
        "select_all": "सभी चुनें ({{count}})",
        "select_format": "स्प्रेडशीट प्रारूप चुनें",
        "selected_count": "{{count}} चयनित",
        "social_badge": "सुविधा सक्रिय विकास में है",
        "social_desc": "मल्टीमॉडल AI निष्कर्षण से सोशल पोस्ट, रील्स, वीडियो वॉकथ्रू और मैसेजिंग कैटलॉग से सीधे संपत्ति लिस्टिंग आयात करें।",
        "social_title": "सोशल मीडिया से संपत्ति आयात",
        "soon": "जल्द",
        "supported_attributes": "समर्थित विशेषताएँ",
        "supports_files": "Microsoft Excel (.xlsx) या CSV (.csv) 25 MB तक समर्थित",
        "tab_drafts": "सहेजे ड्राफ्ट",
        "tab_social": "सोशल मीडिया",
        "tab_spreadsheet": "स्प्रेडशीट आयात",
        "tab_web_scraping": "वेब स्क्रैपिंग",
        "template_paragraph": "पैराग्राफ निष्कर्षण",
        "template_paragraph_desc": "प्रति पंक्ति मुक्त पाठ",
        "template_standard": "मानक कॉलम",
        "template_standard_desc": "Excel .xlsx टेम्पलेट",
        "templates_desc": "AI पार्सिंग और निर्देशांक खोज में अधिकतम सटीकता के लिए मैप किए गए हेडर वाली नमूना स्प्रेडशीट का उपयोग करें।",
        "templates_subtitle": "भरने के लिए तैयार पूर्व-कॉन्फ़िगर फ़ाइलें",
        "templates_title": "आधिकारिक टेम्पलेट",
        "untitled_draft": "बिना शीर्षक ड्राफ्ट",
        "upload_desc": "Excel या CSV से बल्क में संपत्तियाँ जोड़ें। हमारा AI पाइपलाइन पते को सटीक मैप निर्देशांक में बदलता है और सुविधाएँ, BHK तथा कीमत अपने आप पार्स करता है।",
        "upload_title": "संपत्ति स्प्रेडशीट अपलोड करें",
        "url_extract_failed": "दिए गए URL से संपत्ति निकाल नहीं सके। कृपया सुनिश्चित करें कि URL उपलब्ध हैं।",
        "url_import_failed": "संपत्ति URL आयात करने में विफल।",
        "urls_desc": "संपत्ति या प्रोजेक्ट URL पेस्ट करें (प्रति पंक्ति एक)। क्रॉलर शीर्षक, कॉन्फ़िगरेशन, फ़्लोर प्लान, कीमत, सुविधाएँ, फ़ोटो निकालता है और मैप पर पिन लगाता है।",
        "urls_detected_one": "{{count}} लिस्टिंग URL मिला",
        "urls_detected_other": "{{count}} लिस्टिंग URL मिले",
        "urls_label": "संपत्ति लिस्टिंग URL (प्रति पंक्ति एक)",
        "web_scraping_title": "यूनिवर्सल वेब स्क्रैपिंग",
        "whatsapp": "WhatsApp कैटलॉग",
        "whatsapp_desc": "WhatsApp Business कैटलॉग या फ़ॉरवर्ड किए गए संदेशों से लिस्टिंग सिंक करें।",
        "youtube": "YouTube टूर",
        "youtube_desc": "AI वॉकथ्रू वीडियो से संपत्ति विशेषताएँ, फ़्लोर लेआउट और कीफ़्रेम निकालता है।"
      },
      "resume_in_chat_tooltip": "एआई संपत्ति लिस्टिंग चैट में फिर से शुरू करें और संपादित करें",
      "select_user": "उपयोगकर्ता चुनें",
      "subtitle": "स्प्रेडशीट अपलोड करें, संपत्ति वेब लिंक स्क्रैप करें, या सहेजे ड्राफ्ट प्रबंधित करें।",
      "tab_web_import": "वेब आयात"
    },
    "descriptions": {
      "default": "अपनी संपत्तियों और लिस्टिंग का प्रबंधन करें।",
      "show_all": "प्लेटफ़ॉर्म पर सभी लिस्टिंग देखें।",
      "tenant_add": "हमारे AI सहायक का उपयोग करके अपनी संपत्ति बताएं। पोस्ट करने के बाद, आपका खाता अपने आप ओनर में अपग्रेड हो जाएगा।"
    },
    "filters": {
      "all_purposes": "सभी उद्देश्य",
      "all_types": "सभी प्रकार",
      "detect_location": "मेरा स्थान पहचानें",
      "property_type": "संपत्ति प्रकार",
      "purpose": "उद्देश्य",
      "quick_filters": "त्वरित फ़िल्टर",
      "reset_all": "सभी रीसेट करें",
      "search_location": "स्थान खोजें",
      "search_location_placeholder": "शहर, क्षेत्र...",
      "search_title_placeholder": "शीर्षक..."
    },
    "headers": {
      "all_properties": "सभी संपत्तियां",
      "dashboard": "डैशबोर्ड",
      "list_new_property": "नई संपत्ति सूचीबद्ध करें",
      "my_properties": "मेरी संपत्तियां",
      "post_your_property": "अपनी संपत्ति पोस्ट करें"
    },
    "pagination": {
      "page": "पेज {{page}}",
      "showing": "{{total}} में से {{shown}} संपत्तियां दिख रही हैं"
    },
    "portfolio": {
      "managed": "Managed Portfolio",
      "owned": "Owned"
    },
    "statuses": {
      "archived": "संग्रहीत",
      "draft": "ड्राफ्ट",
      "rented": "किराए पर",
      "sold": "बेचा गया"
    },
    "unknown_error": "अज्ञात त्रुटि",
    "upgrade_overlay": {
      "description": "आपकी संपत्ति पोस्ट हो गई है! हम आपके खाते को ओनर खाते में बदल रहे हैं। बस एक पल…",
      "title": "आपका खाता अपग्रेड किया जा रहा है"
    },
    "view": {
      "grid": "ग्रिड",
      "table": "तालिका"
    }
  },
  "property_listing_chat": {
    "a11y": {
      "assistant_message": "सहायक संदेश",
      "conversation": "संपत्ति लिस्टिंग बातचीत",
      "your_message": "आपका संदेश"
    },
    "empty": {
      "description": "अपनी संपत्ति का वर्णन करने के लिए चैट शुरू करें। जैसे-जैसे हम विवरण एकत्र करेंगे, वे आपकी समीक्षा के लिए यहाँ दिखाई देंगे।",
      "title": "अभी तक कोई विवरण नहीं"
    },
    "errors": {
      "chat_generic": "क्षमा करें, एक त्रुटि हुई। कृपया पुनः प्रयास करें।",
      "hint_prefix": "💡",
      "submit_failed_prefix": "❌ संपत्ति सबमिट करने में विफल।",
      "submit_failed_retry": "❌ संपत्ति सबमिट करने में विफल। कृपया पुनः प्रयास करें।",
      "supported_locations": "समर्थित स्थान: {{list}}"
    },
    "input": {
      "aria": "अपनी संपत्ति का वर्णन करें",
      "placeholder": "अपनी संपत्ति का वर्णन करें... (उदा., \"हैदराबाद, बंजारा हिल्स में 3 बेडरूम अपार्टमेंट, 1500 वर्ग फुट, किराया 25000/माह\")",
      "send_aria": "संदेश भेजें",
      "send_title": "संदेश भेजें"
    },
    "review": {
      "additional_details": "अतिरिक्त विवरण",
      "amenities": "सुविधाएँ",
      "area": "क्षेत्र / लोकेलिटी",
      "bath_short_one": "{{count}} बाथ",
      "bath_short_other": "{{count}} बाथ",
      "bed_short_one": "{{count}} बेड",
      "bed_short_other": "{{count}} बेड",
      "city": "शहर",
      "connectivity": "कनेक्टिविटी",
      "description": "विवरण",
      "floor": "मंजिल:",
      "floor_of_total": "{{floor}} में से {{total}}",
      "furnishing": "फर्निशिंग:",
      "highlights": "मुख्य बिंदु",
      "location_details": "स्थान विवरण",
      "location_unknown": "स्थान अज्ञात",
      "more_images_one": "+{{count}} और",
      "more_images_other": "+{{count}} और",
      "nearby": "आस-पास",
      "negotiable": "💰 बातचीत योग्य",
      "new_property": "नई संपत्ति",
      "parking": "पार्किंग:",
      "parking_spaces_one": "{{count}} स्थान",
      "parking_spaces_other": "{{count}} स्थान",
      "per_month": "/ माह",
      "pincode": "पिन कोड",
      "preview_alt": "पूर्वावलोकन {{index}}",
      "sqft_suffix": "{{value}} वर्ग फुट",
      "state_country": "राज्य और देश",
      "street": "सड़क:",
      "title": "संपत्ति विवरण की समीक्षा करें",
      "uploaded_images_one": "अपलोड की गई छवियाँ ({{count}})",
      "uploaded_images_other": "अपलोड की गई छवियाँ ({{count}})",
      "views": "दृश्य"
    },
    "submit_listing": "लिस्टिंग सबमिट करें",
    "title": "अपनी संपत्ति सूचीबद्ध करें",
    "uploaded_images_message_one": "मैंने {{count}} छवि अपलोड की है",
    "uploaded_images_message_other": "मैंने {{count}} छवियाँ अपलोड की हैं",
    "voice": {
      "fallback_property_type": "संपत्ति",
      "summary_complete_no_city": "मैं समझ गया कि आप एक {{type}} सूचीबद्ध करना चाहते हैं। मेरे पास आवश्यक विवरण हैं!",
      "summary_complete_with_city": "मैं समझ गया कि आप {{city}} में एक {{type}} सूचीबद्ध करना चाहते हैं। मेरे पास आवश्यक विवरण हैं!",
      "summary_incomplete_no_city": "मैं समझ गया कि आप एक {{type}} सूचीबद्ध करना चाहते हैं। यदि आप और विवरण जोड़ना चाहते हैं तो बताएँ।",
      "summary_incomplete_with_city": "मैं समझ गया कि आप {{city}} में एक {{type}} सूचीबद्ध करना चाहते हैं। यदि आप और विवरण जोड़ना चाहते हैं तो बताएँ।"
    },
    "welcome": "नमस्ते! मैं आपकी संपत्ति सूचीबद्ध करने में मदद करने के लिए यहाँ हूँ। आप टेक्स्ट में विवरण दे सकते हैं या आवाज़ का उपयोग कर सकते हैं। अपनी संपत्ति के बारे में बताएँ - प्रकार, स्थान, आकार, मूल्य और कोई विशेष विशेषताएँ।",
    "widgets": {
      "bathrooms": "बाथरूम",
      "bedrooms": "बेडरूम",
      "locality_label": "क्षेत्र",
      "parking_spaces": "पार्किंग स्थान"
    }
  },
  "property_listing_form": {
    "amenities_hint": "ℹ️ लिफ्ट और बालकनी अपने आप सुविधाओं की सूची में शामिल हैं",
    "complete_required_fields": "प्रकाशित करने के लिए आवश्यक फ़ील्ड पूरे करें:",
    "display_only_amenities": "यह केवल प्रदर्शित करने के लिए है - मान amenities में है",
    "done": "पूर्ण",
    "edit_location": "स्थान संपादित करें",
    "edit_location_description": "अपनी संपत्ति के निर्देशांक अपडेट करने के लिए मानचित्र पिन समायोजित करें।",
    "errors": {
      "failed_to_create": "संपत्ति बनाने में विफल",
      "submit_failed": "संपत्ति सबमिट करने में त्रुटि। कृपया पुनः प्रयास करें।",
      "supported_locations": "समर्थित स्थान"
    },
    "extracted_fields": "LetMeIn AI ने {{total}} में से {{count}} फ़ील्ड निकाले",
    "labels": {
      "additional_details": "",
      "age_of_construction": "निर्माण की आयु",
      "apartment_name": "",
      "area": "क्षेत्रफल",
      "area_locality": "क्षेत्र / लोकेलिटी",
      "area_type": "एरिया प्रकार",
      "assured_returns": "निश्चित रिटर्न",
      "available_for": "उपलब्धता",
      "available_from": "उपलब्धता",
      "available_services": "",
      "balconies": "बालकनी",
      "bathrooms": "बाथरूम",
      "bedrooms": "बेडरूम",
      "booking_token_amount": "बुकिंग / टोकन राशि",
      "boundary_wall": "बाउंड्री वॉल",
      "car_spaces_count": "",
      "ceiling_height": "छत की ऊँचाई",
      "city": "शहर",
      "commercial_subtype": "व्यावसायिक प्रकार",
      "common_area_amenities": "साझा क्षेत्र सुविधाएँ",
      "connectivity": "कनेक्टिविटी",
      "corner_plot": "कॉर्नर प्लॉट",
      "corner_shop": "कॉर्नर शॉप / यूनिट",
      "country": "देश",
      "currently_leased_out": "वर्तमान में किराए पर",
      "entrance_width": "प्रवेश द्वार की चौड़ाई",
      "expected_price": "अपेक्षित किराया/मूल्य",
      "extra_pantry": "पैंट्री",
      "facing": "मुख",
      "floor_number": "मंज़िल संख्या",
      "floors_allowed_for_construction": "अनुमत मंजिलें",
      "food_available": "भोजन उपलब्ध",
      "furnishing": "फर्निशिंग",
      "gate_closing_time": "गेट बंद होने का समय",
      "ideal_for_businesses": "आदर्श उपयोग",
      "intent": "उद्देश्य",
      "land_zoning": "भूमि ज़ोनिंग",
      "lifts": "लिफ्ट/एलिवेटर",
      "listing_subtype": "संपत्ति उप-प्रकार",
      "loading_unloading_access": "लोडिंग / अनलोडिंग",
      "location": "स्थान",
      "maintenance_charges": "रखरखाव शुल्क",
      "nearby_businesses": "आसपास के व्यवसाय",
      "nearby_places": "नज़दीकी स्थान",
      "open_sides": "खुले किनारे",
      "parking": "",
      "parking_spaces": "पार्किंग स्थान",
      "personal_washroom": "व्यक्तिगत वॉशरूम",
      "pg_name": "PG नाम",
      "pg_present_in": "PG कहाँ स्थित है",
      "pg_rules": "PG नियम",
      "pg_usps": "विशेष आकर्षण",
      "pincode": "पिनकोड",
      "plot_breadth": "प्लॉट की चौड़ाई (फीट)",
      "plot_length": "प्लॉट की लंबाई (फीट)",
      "plot_subtype": "प्लॉट प्रकार",
      "possession_status": "कब्ज़ा स्थिति",
      "power_supply": "बिजली आपूर्ति",
      "preferred_tenants": "",
      "property_amenities": "संपत्ति सुविधाएँ",
      "property_name": "",
      "property_type": "संपत्ति प्रकार",
      "road_width": "सड़क की चौड़ाई",
      "road_width_facing_plot": "प्लॉट के सामने सड़क",
      "room_facilities_short": "कमरे की सुविधाएँ",
      "room_sharing": "रूम शेयरिंग",
      "security_deposit": "सुरक्षा जमा",
      "state": "राज्य",
      "street_address": "सड़क का पता",
      "tenant_preference": "किरायेदार प्राथमिकता",
      "title": "शीर्षक",
      "total_floors": "कुल मंजिलें",
      "truck_accessibility": "ट्रक पहुँच",
      "washroom_available": "वॉशरूम उपलब्ध",
      "washroom_count": "वॉशरूम संख्या"
    },
    "listing_progress": "लिस्टिंग प्रगति",
    "map_pin_needed_desc": "मानचित्र पर सटीक संपत्ति स्थान की पुष्टि करने के लिए यहाँ क्लिक करें।",
    "map_pin_needed_title": "प्रकाशित करने के लिए मानचित्र पिन आवश्यक",
    "negotiable_price": "💰 बातचीत योग्य मूल्य",
    "pg": {
      "anyone": "कोई भी",
      "available_floors": "उपलब्ध मंजिलें",
      "beds_per_room": "प्रति कमरा बिस्तर",
      "boys": "लड़के",
      "girls": "लड़कियाँ",
      "rent_per_bed_short": "किराया/बिस्तर",
      "rooms": "कमरे",
      "sharing_double": "डबल",
      "sharing_four": "चार शेयरिंग",
      "sharing_single": "सिंगल",
      "sharing_triple": "ट्रिपल"
    },
    "pg_section": "PG विवरण (आवश्यक)",
    "pin_map_action": "मानचित्र पिन करें",
    "pincode_resolve_failed": "चयनित शहर के लिए वह पिनकोड हल नहीं हो सका।",
    "placeholders": {
      "age_of_construction": "चुनें",
      "apartment_name": "",
      "area": "उदा. 2250",
      "area_locality": "उदा. साउथ बैंक",
      "area_type": "उदा. कार्पेट, बिल्ट-अप",
      "available_for": "चुनें",
      "booking_token_amount": "उदा. 100000",
      "city": "उदा. ब्रिस्बेन",
      "connectivity": "उदा. मेट्रो स्टेशन, बस स्टॉप",
      "country": "उदा. ऑस्ट्रेलिया",
      "facing": "उदा. ईस्ट",
      "floor_number": "उदा. 15",
      "food_available": "चुनें",
      "furnishing": "उदा. सेमी-फर्निश्ड",
      "highlights": "",
      "intent": "बिक्री/किराया",
      "maintenance_amount": "उदा. 5000",
      "maintenance_frequency": "मासिक",
      "nearby_places": "उदा. स्कूल, अस्पताल, मॉल",
      "number_example_2": "उदा. 2",
      "number_example_3": "उदा. 3",
      "pg_name": "उदा. श्री साई PG",
      "pg_present_in": "चुनें",
      "pincode": "उदा. 500032",
      "price_example": "उदा. 80,000",
      "property_name": "",
      "room_sharing": "शेयरिंग चुनें",
      "security_deposit": "उदा. 10000 या 0",
      "select_property_type": "संपत्ति प्रकार चुनें",
      "state": "उदा. क्वींसलैंड",
      "street_address": "भवन का नाम, सड़क, लैंडमार्क…",
      "street_address_unconfirmed": "सड़क पता भरने के लिए चैट विजेट में पता पुष्टि करें…",
      "title": "उदा. 3 BHK लग्ज़री फ्लैट",
      "total_floors": "उदा. 10"
    },
    "posting": "प्रकाशित हो रहा है...",
    "preferred_tenants_hint": "",
    "preview": {
      "connectivity": "कनेक्टिविटी पूर्वावलोकन",
      "nearby_places": "नज़दीकी स्थान पूर्वावलोकन"
    },
    "set_location_pin": "मानचित्र स्थान सेट करें *",
    "status": {
      "in_progress": "प्रगति में",
      "ready_to_list": "लिस्ट करने के लिए तैयार"
    },
    "submit": "प्रकाशित करें",
    "title": "संपत्ति लिस्टिंग पूर्वावलोकन",
    "units": {
      "acres": "एकड़",
      "bigha": "बीघा",
      "cents": "सेंट",
      "guntas": "गुंठा",
      "marla": "मरला",
      "sqft": "वर्ग फुट",
      "sqyd": "वर्ग गज"
    },
    "validation": {
      "incomplete_sharing": "कृपया सभी शेयरिंग विवरण पूरे करें",
      "missing_area": "क्षेत्र / लोकेलिटी आवश्यक है",
      "missing_available_for": "किरायेदार प्राथमिकता आवश्यक है",
      "missing_deposit": "मान्य सुरक्षा जमा आवश्यक है",
      "missing_intent": "लिस्टिंग उद्देश्य (किराया / बिक्री) आवश्यक है",
      "missing_map_pin": "मानचित्र स्थान पिन आवश्यक है",
      "missing_pg_name": "PG नाम आवश्यक है",
      "missing_pg_present_in": "भवन प्रकार आवश्यक है",
      "missing_price": "मान्य मूल्य/किराया आवश्यक है",
      "missing_room_sharing": "रूम शेयरिंग विकल्प आवश्यक है",
      "missing_type": "संपत्ति प्रकार आवश्यक है"
    }
  },
  "property_manager_details": {
    "actions": {
      "back": "वापस",
      "back_home": "होम पर वापस जाएँ",
      "contact_agent": "एजेंट से संपर्क करें",
      "view_details": "विवरण देखें"
    },
    "badges": {
      "preferred": "प्राथमिक"
    },
    "empty": {
      "no_active_listings": "कोई सक्रिय लिस्टिंग नहीं",
      "no_active_listings_desc": "इस एजेंट की कोई सार्वजनिक संपत्ति सूचीबद्ध नहीं है।"
    },
    "errors": {
      "load_failed": "मैनेजर विवरण लोड करने में विफल",
      "not_found": "मैनेजर नहीं मिला"
    },
    "fallback": {
      "agent": "एजेंट",
      "city": "हैदराबाद",
      "deal_types": {
        "rent_lease": "किराया/लीज़",
        "sale": "बिक्री"
      },
      "independent_agent": "स्वतंत्र एजेंट",
      "initials": "PM"
    },
    "labels": {
      "baths": "बाथ",
      "beds": "बेड",
      "company": "कंपनी",
      "member_since": "सदस्य since",
      "no_images": "कोई छवि नहीं",
      "sqft": "वर्गफुट"
    },
    "loading_profile": "प्रोफ़ाइल लोड हो रही है...",
    "results_count_one": "",
    "results_count_other": "",
    "sections": {
      "active_listings": "सक्रिय लिस्टिंग",
      "active_listings_desc": "{{name}} द्वारा प्रबंधित प्रीमियम संपत्तियाँ देखें",
      "operating_areas": "कार्य क्षेत्र",
      "specializations": "विशेषज्ञता"
    },
    "stats": {
      "buyers_served": "सेवा प्राप्त खरीदार",
      "deals_closed": "पूर्ण डील्स",
      "for_rent": "किराए हेतु संपत्तियाँ",
      "for_sale": "बिक्री हेतु संपत्तियाँ"
    }
  },
  "rbac": {
    "matrix": {
      "cancel_btn": "रद्द करें",
      "edit_btn": "अनुमतियाँ संपादित करें",
      "role_column": "भूमिका",
      "save_btn": "परिवर्तन सहेजें",
      "title": "अनुमति मैट्रिक्स"
    },
    "roles": {
      "create_btn": "भूमिका बनाएँ",
      "create_dialog": {
        "description": "एक नई भूमिका बनाएँ और उसे अनुमतियाँ असाइन करें।",
        "title": "नई भूमिका बनाएँ"
      },
      "description": "भूमिकाओं और उनकी अनुमतियों को प्रबंधित करें।",
      "search_placeholder": "भूमिकाएँ खोजें...",
      "title": "भूमिकाएँ"
    }
  },
  "redisInsight": {
    "appCache": "",
    "colDesc": "",
    "colPrefix": "",
    "colTtl": "",
    "colType": "",
    "connection": "",
    "connectionDesc": "",
    "error": "",
    "key": "",
    "keyDetails": "",
    "match": "",
    "next": "",
    "nextCursor": "",
    "noKeys": "",
    "prefixTableDesc": "",
    "prefixTableTitle": "",
    "refresh": "",
    "runScan": "",
    "scanComplete": "",
    "scanDesc": "",
    "scanTitle": "",
    "sensitiveBody": "",
    "sensitiveTitle": "",
    "stats": "",
    "subtitle": "",
    "tabBrowse": "",
    "tabOverview": "",
    "tabPrefixes": "",
    "title": "",
    "view": ""
  },
  "reports": {
    "access_logs_desc": "सिस्टम-व्यापी एक्सेस लॉग ट्रैक करें",
    "bulk_export": "बल्क निर्यात",
    "categories": {
      "analytics": "विश्लेषण",
      "billing": "बिलिंग",
      "growth": "विकास",
      "management": "प्रबंधन",
      "messages": "संदेश",
      "security": "सुरक्षा"
    },
    "coming_soon_message": "व्यापक रिपोर्टिंग मॉड्यूल वर्तमान में विकास अधीन है। जल्द ही आप इस डैशबोर्ड से सीधे कस्टम रिपोर्ट तैयार कर सकेंगे, स्वचालित निर्यात शेड्यूल कर सकेंगे और गहन प्रदर्शन मेट्रिक्स का विश्लेषण कर सकेंगे।",
    "coming_soon_title": "जल्द आ रहा है: उन्नत रिपोर्टिंग",
    "compliance_log_desc": "पूर्ण अनुपालन और स्थिति लॉग",
    "demographic_desc": "प्लेटफ़ॉर्म उपयोगकर्ता जनसांख्यिकीय डेटा",
    "description_superadmin": "उच्च-स्तरीय प्लेटफ़ॉर्म ऑडिट, राजस्व स्ट्रीम और सिस्टम लॉग तक पहुँचें।",
    "description_user": "विस्तृत सिस्टम और संपत्ति रिपोर्ट जनरेट करें, देखें और निर्यात करें।",
    "executive_desc": "एक-पृष्ठ कार्यकारी सारांश",
    "filter": "फ़िल्टर करें",
    "financial_desc": "वित्तीय प्रदर्शन का अवलोकन",
    "generate_new": "नया जनरेट करें",
    "items": {
      "compliance_check": {
        "description": "सभी पंजीकृत व्यावसायिक संस्थाओं की ऑडिट स्थिति।",
        "name": "संगठन अनुपालन जांच"
      },
      "consolidated_revenue": {
        "description": "स्ट्राइप लेनदेन की मात्रा और सदस्यता MRR का विवरण।",
        "name": "समेकित राजस्व रिपोर्ट"
      },
      "growth_analysis": {
        "description": "उपयोगकर्ताओं और संगठनों के लिए साल-दर-साल वृद्धि मेट्रिक्स।",
        "name": "प्लेटफॉर्म विकास विश्लेषण - Q1 2026"
      },
      "maintenance_report": {
        "description": "सभी चल रहे और पूरे हो चुके रखरखाव कार्यों की स्थिति अद्यतन।",
        "name": "संपत्ति रखरखाव रिपोर्ट"
      },
      "monthly_review": {
        "description": "संपत्ति प्रदर्शन, ट्रैफ़िक और लीड का व्यापक अवलोकन।",
        "name": "मासिक प्रदर्शन समीक्षा - जनवरी 2026"
      },
      "revenue_export": {
        "description": "स्ट्राइप लेनदेन इतिहास और सदस्यता स्थिति विवरण।",
        "name": "राजस्व और सदस्यता निर्यात"
      },
      "security_audit": {
        "description": "एक्सेस लॉग और संवेदनशील सिस्टम परिवर्तनों का पूरा ट्रेस।",
        "name": "सुरक्षा ऑडिट और सिस्टम लॉग"
      },
      "tenant_log": {
        "description": "संभावित किरायेदारों से सभी संदेशों और पूछताछ का विस्तृत विवरण।",
        "name": "किरायेदार संपर्क लॉग"
      }
    },
    "load_more": "और रिपोर्ट लोड करें",
    "property_audit": "संपत्ति ऑडिट",
    "raw_export_desc": "सभी डेटा को रॉ प्रारूप में निर्यात करें",
    "recent_reports": "हालिया रिपोर्ट",
    "reports_list_desc": "आपके हाल ही में जेनरेट किए गए डेटा निर्यात की सूची।",
    "revenue_matrix": "राजस्व मैट्रिक्स",
    "sample_data_badge": "",
    "sample_file_type": "",
    "security_logs": "सुरक्षा लॉग",
    "title_superadmin": "प्लेटफ़ॉर्म इंटेलिजेंस",
    "title_user": "सिस्टम रिपोर्ट",
    "user_analytics": "उपयोगकर्ता विश्लेषण",
    "view": "देखें",
    "visual_summary": "दृश्य सारांश"
  },
  "reset_password": {
    "actions": {
      "reset": "पासवर्ड रीसेट करें",
      "resetting": "रीसेट किया जा रहा है..."
    },
    "description": "नीचे अपना नया पासवर्ड दर्ज करें।",
    "errors": {
      "expired_link": "रीसेट लिंक अमान्य या समाप्त हो चुका है। कृपया नया लिंक मांगें।",
      "invalid_token": "अमान्य या अनुपस्थित टोकन।",
      "min_length": "पासवर्ड कम से कम 8 अक्षरों का होना चाहिए।",
      "password_mismatch": "पासवर्ड मेल नहीं खाते।"
    },
    "fields": {
      "confirm_password_label": "नया पासवर्ड पुष्टि करें",
      "confirm_password_placeholder": "नया पासवर्ड दोबारा दर्ज करें",
      "new_password_label": "नया पासवर्ड",
      "new_password_placeholder": "नया पासवर्ड दर्ज करें"
    },
    "success": {
      "redirecting": "लॉगिन पर भेजा जा रहा है...",
      "title": "आपका पासवर्ड रीसेट हो गया है!"
    },
    "title": "अपना पासवर्ड रीसेट करें"
  },
  "roles": {
    "admin": "एडमिन",
    "individual": "",
    "org_admin": "संगठन एडमिन",
    "org_user": "संगठन उपयोगकर्ता",
    "owner": "मालिक",
    "property_manager": "संपत्ति प्रबंधक",
    "super_admin": "सुपर एडमिन",
    "tenant": "किरायेदार"
  },
  "search": {
    "all_results_desc": "{{total}} में से {{shown}} संपत्तियां दिखाई गईं",
    "all_results_title": "सभी खोज परिणाम",
    "featured_listing": "विशेष लिस्टिंग",
    "load_more_failed": "और संपत्तियां लोड नहीं हो सकीं। कृपया पुनः प्रयास करें।",
    "loading_more": "लोड हो रहा है…",
    "matches_found_one": "{{count}} मिलान मिला",
    "matches_found_other": "{{count}} मिलान मिले",
    "modify_btn": "खोज संशोधित करें",
    "modify_placeholder": "बताएं कि आप अपनी खोज को कैसे बदलना चाहते हैं…",
    "more_matches": "और मिलान",
    "show_more": "और दिखाएं",
    "sponsored": "प्रायोजित",
    "view_all_results_one": "सभी {{count}} परिणाम देखें",
    "view_all_results_other": "सभी {{count}} परिणाम देखें"
  },
  "search_chips": {
    "clear_all": "सभी हटाएँ",
    "within_km": "{{n}} किमी के भीतर",
    "within_m": "{{n}} मी के भीतर"
  },
  "settings": {
    "choose_language": "अपने अनुभव के लिए भाषा चुनें",
    "features": {
      "controls": {
        "description": "सभी उपयोगकर्ताओं के लिए सुविधाओं को चालू या बंद करें",
        "title": "सुविधा नियंत्रण"
      },
      "description": "एप्लिकेशन की सुविधाओं को सक्षम या अक्षम करें",
      "items": {
        "aadhaar_verification": {
          "description": "उपयोगकर्ताओं के लिए आधार OTP सत्यापन सक्षम करें",
          "title": "आधार सत्यापन"
        },
        "ai_chat": {
          "description": "एआई-संचालित चैट सहायक को सक्षम करें",
          "title": "एआई चैट"
        },
        "geo_search": {
          "description": "PostGIS रेडियस खोज, मैप परिणाम, और /assistant",
          "title": "जिओ मैप खोज"
        },
        "property_comparison": {
          "description": "उपयोगकर्ताओं को कई संपत्तियों की तुलना करने की अनुमति दें",
          "title": "संपत्ति तुलना"
        },
        "toon_format": {
          "description": "एलएलएम से TOON प्रारूप प्रतिक्रियाओं को सक्षम करें",
          "title": "एलएलएम के लिए TOON प्रारूप"
        },
        "voice_search": {
          "description": "ध्वनि-आधारित संपत्ति खोज को सक्षम करें",
          "title": "ध्वनि खोज"
        }
      },
      "storage": {
        "firestore": {
          "db_info": "फायरस्टोर डेटाबेस का उपयोग कर रहा है",
          "description": "कॉन्फ़िगर करें कि फायरस्टोर का उपयोग करते समय टोकन उपयोग और गतिविधि लॉग कहाँ संग्रहीत किए जाते हैं।",
          "status_label": "फायरस्टोर कनेक्शन",
          "test_btn": "कनेक्शन का परीक्षण करें",
          "title": "फायरबेस / फायरस्टोर स्टोरेज"
        }
      },
      "title": "सुविधा फ़्लैग"
    },
    "firebase": {
      "description": "टोकन उपयोग और गतिविधि लॉग के लिए फ़ायरस्टोर कनेक्शन और स्टोरेज बैकएंड (डेटाबेस बनाम फ़ायरस्टोर)।",
      "test_to_verify": "यह सत्यापित करने के लिए कनेक्शन का परीक्षण करें कि फ़ायरस्टोर कॉन्फ़िगर किया गया है।"
    },
    "general": {
      "description": "बुनियादी एप्लिकेशन सेटिंग्स कॉन्फ़िगर करें",
      "site_config": {
        "contact_email": "संपर्क ईमेल",
        "contact_email_placeholder": "contact@example.com",
        "description": "आपके एप्लिकेशन के बारे में बुनियादी जानकारी",
        "max_image_upload_mb": "अधिकतम छवि अपलोड आकार (MB)",
        "max_image_upload_mb_description": "एक अपलोड संपत्ति छवि का अधिकतम आकार (MB)।",
        "max_media_limit": "प्रति संपत्ति लिस्टिंग अधिकतम मीडिया (फोटो और वीडियो टूर)",
        "max_media_limit_description": "प्रति संपत्ति लिस्टिंग में अनुमत कुल मीडिया (फोटो + वीडियो टूर)।",
        "max_scraper_video_limit": "प्रति संपत्ति अधिकतम स्क्रेप्ड वीडियो (वेब स्क्रेपिंग)",
        "max_scraper_video_limit_description": "प्रति लिस्टिंग से स्क्रेप करने के लिए अधिकतम वीडियो टूर।",
        "max_video_upload_mb": "अधिकतम वीडियो अपलोड आकार (MB)",
        "max_video_upload_mb_description": "एक अपलोड संपत्ति वीडियो का अधिकतम आकार (MB)।",
        "site_description": "साइट विवरण",
        "site_description_placeholder": "AI-संचालित रियल एस्टेट प्लेटफ़ॉर्म",
        "site_name": "साइट का नाम",
        "site_name_placeholder": "मेरा रियल एस्टेट ऐप",
        "title": "साइट कॉन्फ़िगरेशन"
      },
      "title": "सामान्य सेटिंग्स"
    },
    "interface_language": "इंटरफ़ेस की भाषा",
    "language": "भाषा",
    "language_preferences": "भाषा प्राथमिकताएं",
    "language_saved": "भाषा प्राथमिकताएं सफलतापूर्वक अपडेट की गईं",
    "languages": "भाषाएं",
    "media": {
      "description": "संपत्ति मीडिया सीमाएं, वीडियो अपलोड आकार और वेब स्क्रैपर सेटिंग्स कॉन्फ़िगर करें",
      "subtitle": "प्रति लिस्टिंग फोटो संख्या, वीडियो टूर सीमा और अधिकतम फ़ाइल अपलोड आकार को नियंत्रित करें",
      "title": "मीडिया और वीडियो अपलोड सीमाएं"
    },
    "mobile": {
      "open_sections": "सेटिंग्स विभाग खोलें"
    },
    "no_permission": "आपके पास सिस्टम सेटिंग्स तक पहुँचने की अनुमति नहीं है। केवल व्यवस्थापक ही सिस्टम सेटिंग्स का प्रबंधन कर सकते हैं।",
    "save": "परिवर्तन सहेजें",
    "sections": {
      "advanced": "उन्नत",
      "api": "एपीआई कॉन्फ़िग",
      "auth": "प्रमाणीकरण",
      "email": "ईमेल कॉन्फ़िग",
      "features": "फीचर फ्लैग्स",
      "firebase": "फ़ायरबेस",
      "general": "सामान्य",
      "media": "मीडिया और अपलोड",
      "payment": "भुगतान"
    },
    "select_from_available": "उपलब्ध भाषाओं में से चुनें",
    "select_language": "अपनी पसंदीदा भाषा चुनें",
    "sidebar": {
      "description": "वैश्विक एप्लिकेशन सेटिंग्स प्रबंधित करें",
      "title": "सिस्टम सेटिंग्स"
    }
  },
  "sidebar": {
    "activity_logs": "गतिविधि लॉग",
    "administration": "प्रशासन",
    "all_properties": "सभी संपत्तियां",
    "all_subscriptions": "सभी सदस्यताएं",
    "analytics": "एनालिटिक्स",
    "analytics_reports": "एनालिटिक्स और रिपोर्ट्स",
    "api_usage": "एपीआई उपयोग",
    "auth_matrix": "प्रमाणीकरण मैट्रिक्स",
    "brokerage_hub": "ब्रोकरेज हब",
    "dashboard": "डैशबोर्ड",
    "feedback": "प्रतिक्रिया",
    "google_maps_usage": "मानचित्र और स्थान लागत",
    "help_support": "सहायता और समर्थन",
    "import_properties": "संपत्तियां आयात करें",
    "list_my_properties": "मेरी संपत्तियों की सूची",
    "list_properties": "संपत्ति सूचीबद्ध करें",
    "logout": "लॉग आउट",
    "manage_plans": "योजनाएं प्रबंधित करें",
    "manage_roles": "भूमिकाएं प्रबंधित करें",
    "messages": "संदेश",
    "my_favourites": "मेरी पसंद",
    "my_leases": "मेरे पट्टे",
    "my_properties": "मेरी संपत्तियां",
    "my_subscription": "मेरी सदस्यता",
    "org_properties": "संगठन की संपत्तियां",
    "org_users": "संगठन उपयोगकर्ता",
    "organizations": "बिल्डर",
    "owner": "मालिक",
    "profile": "प्रोफ़ाइल",
    "property_search": "संपत्ति खोज",
    "redis_insight": "रेडिस इनसाइट",
    "reports": "रिपोर्ट्स",
    "revenue": "राजस्व",
    "reviews": "समीक्षाएँ",
    "roles_perms": "भूमिकाएं और अनुमतियां",
    "settings": "सेटिंग्स",
    "subscription": "सदस्यता",
    "tenant": "किरायेदार",
    "tenants": "किरायेदार और पूछताछ",
    "token_usage": "टोकन उपयोग",
    "transactions": "लेन-देन",
    "usage_billing": "उपयोग और बिलिंग",
    "users": "उपयोगकर्ता"
  },
  "simple_test": {
    "button": "मुझे क्लिक करें",
    "description": "इस न्यूनतम पृष्ठ का पता लगाएँ और अनुवाद करें।",
    "title": "सरल अनुवाद परीक्षण"
  },
  "single_phase": "",
  "subscription": {
    "active": "सक्रिय",
    "auto_renewal": "स्वतः नवीनीकरण",
    "billing_info": "बिलिंग जानकारी",
    "cancel_btn": "सदस्यता रद्द करें",
    "cancel_desc": "क्या आप वाकई अपनी सदस्यता रद्द करना चाहते हैं? इससे आपके बिलिंग चक्र के अंत में आपको मुफ्त योजना में डाउनग्रेड कर दिया जाएगा।",
    "change_btn": "योजना बदलें",
    "choose_plan": {
      "back_to_manage": "वापस योजनाएँ प्रबंधित करें",
      "back_to_sub": "वापस मेरी सदस्यता पर जाएँ",
      "forever": "हमेशा के लिए",
      "monthly": "मासिक",
      "regular_desc": "अपनी मुख्य सदस्यता योजना चुनें",
      "regular_plans": "नियमित योजनाएँ",
      "subscribe": "सदस्यता लें",
      "subtitle": "अपनी आवश्यकताओं के लिए सही योजना चुनें।",
      "title": "अपनी योजना चुनें",
      "yearly": "वार्षिक"
    },
    "confirm_cancel": "रद्दीकरण की पुष्टि करें",
    "current_plan": "वर्तमान योजना",
    "disabled": "अक्षम",
    "enabled": "सक्षम",
    "free_tier": "मुफ्त टियर",
    "inactive": "निष्क्रिय",
    "keep_btn": "सदस्यता रखें",
    "next_billing": "अगली बिलिंग तिथि",
    "org_plan_desc": "आपकी सदस्यता आपके संगठन द्वारा प्रदान की जाती है।",
    "plan_details": "योजना विवरण",
    "status": "स्थिति",
    "title": "आपकी सदस्यता",
    "upgrade_btn": "योजना अपग्रेड करें",
    "using_org_plan": "संगठन योजना का उपयोग कर रहे हैं"
  },
  "terms_of_service": {
    "contact": {
      "prefix": ""
    },
    "last_updated": "अंतिम अपडेट: 30 जनवरी, 2026",
    "sections": {
      "accounts": {
        "body": "खाता बनाते समय दी गई जानकारी सटीक, पूर्ण और अद्यतन होनी चाहिए। उल्लंघन की स्थिति में आपका खाता समाप्त किया जा सकता है।",
        "title": "3. उपयोगकर्ता खाते"
      },
      "agreement": {
        "body": "LetMeIn AI का उपयोग करके, आप इन सेवा शर्तों से सहमत होते हैं। यदि आप शर्तों के किसी भाग से असहमत हैं, तो आप सेवा का उपयोग नहीं कर सकते।",
        "title": "1. शर्तों से सहमति"
      },
      "changes": {
        "body": "हम कभी भी इन शर्तों को संशोधित कर सकते हैं। संशोधन के बाद सेवा उपयोग जारी रखने पर आप संशोधित शर्तों से बंधे होंगे।",
        "title": "7. शर्तों में परिवर्तन"
      },
      "description": {
        "body": "LetMeIn AI संपत्ति मालिकों के लिए संपत्तियां सूचीबद्ध करने और उपयोगकर्ताओं के लिए विभिन्न प्रकार के आवास खोजने हेतु एक प्लेटफ़ॉर्म प्रदान करता है।",
        "title": "2. सेवा का विवरण"
      },
      "liability": {
        "body": "LetMeIn AI और उसके भागीदार किसी अप्रत्यक्ष, आकस्मिक या परिणामी क्षति के लिए उत्तरदायी नहीं होंगे।",
        "title": "6. दायित्व की सीमा"
      },
      "listings": {
        "body": "मालिक और प्रबंधक अपनी पोस्ट की गई संपत्ति जानकारी की सटीकता और वैधता के लिए जिम्मेदार हैं।",
        "title": "4. संपत्ति सूचीकरण"
      },
      "prohibited": {
        "body": "आप निम्नलिखित गतिविधियाँ नहीं करेंगे:",
        "items": {
          "automation": "\"रोबोट्स\", \"स्पाइडर्स\" या \"ऑफलाइन रीडर्स\" जैसे स्वचालित सिस्टम का उपयोग करना।",
          "copying": "सेवा के किसी भी हिस्से की प्रतिलिपि बनाना, वितरित करना या प्रकट करना।",
          "interference": "सिस्टम की अखंडता/सुरक्षा में हस्तक्षेप करने या सर्वर संचार को डिकोड करने का प्रयास करना।"
        },
        "title": "5. निषिद्ध गतिविधियाँ"
      }
    },
    "title": "सेवा की शर्तें"
  },
  "three_phase": "",
  "token_usage": {
    "by_endpoint": "एंडपॉइंट के अनुसार",
    "by_member": "सदस्य के अनुसार",
    "calls": "कॉल",
    "days": "दिन",
    "description": "टोकन उपयोग, प्रदाता और एंडपॉइंट के अनुसार लागत देखें, और CSV निर्यात करें। केवल व्यवस्थापक के लिए।",
    "endpoint": "एंडपॉइंट",
    "export_csv": "टोकन उपयोग CSV निर्यात करें",
    "export_ledger_csv": "लेजर CSV निर्यात करें",
    "member": "सदस्य",
    "no_org_data": "कोई संस्था उपयोग डेटा नहीं मिला। पहले Summary टैब लोड करें।",
    "org_name": "बिल्डर",
    "org_overview": "संस्था अवलोकन",
    "organization": "संस्था",
    "summary": {
      "card_description": "प्रदाता और एंडपॉइंट के अनुसार कुल टोकन और लागत।",
      "card_title": "सारांश"
    },
    "tabs": {
      "by_format": "फॉर्मैट के अनुसार",
      "by_org": "संस्था के अनुसार",
      "by_user": "उपयोगकर्ता के अनुसार",
      "daily": "दैनिक",
      "recent": "हाल का",
      "summary": "सारांश"
    },
    "title": "टोकन / एलएलएम उपयोग",
    "tokens": "टोकन",
    "total_calls": "कुल कॉल",
    "total_tokens": "कुल टोकन"
  },
  "topup_page": {
    "actions": {
      "change_amount": "राशि बदलें",
      "continue_to_payment": "भुगतान के लिए जारी रखें",
      "pay_with_razorpay": "Razorpay से भुगतान करें"
    },
    "amount_help": "{{description}} न्यूनतम {{min}}, अधिकतम {{max}}.",
    "amount_label": "राशि (USD)",
    "amount_label_inr": "राशि (INR)",
    "amount_placeholder": "उदा. 20",
    "amount_placeholder_inr": "उदा. 500",
    "checkout": {
      "amount_label": "राशि",
      "description": "{{target}} में {{amount}} जोड़ने के लिए भुगतान विवरण दर्ज करें।",
      "loading_form": "भुगतान फ़ॉर्म लोड हो रहा है...",
      "pay_amount": "{{amount}} भुगतान करें",
      "processing": "प्रोसेस हो रहा है..."
    },
    "description": {
      "org": "क्रेडिट आपके संगठन के साझा वॉलेट में जोड़े जाएंगे।",
      "personal": "क्रेडिट आपके व्यक्तिगत बैलेंस में जोड़े जाएंगे।"
    },
    "errors": {
      "payment_failed": "भुगतान विफल",
      "razorpay_load_failed": "Razorpay चेकआउट लोड करने में विफल",
      "start_payment_failed": "भुगतान शुरू करने में विफल"
    },
    "loading": "लोड हो रहा है...",
    "org_notice_amount": {
      "prefix": "ये क्रेडिट",
      "suffix": "में जोड़े जाएंगे और सभी सदस्य उपयोग कर सकेंगे।",
      "wallet": "संगठन के साझा वॉलेट"
    },
    "org_notice_checkout": {
      "prefix": "आप",
      "suffix": "में टॉप-अप कर रहे हैं — सभी सदस्य इसका उपयोग कर सकते हैं।",
      "wallet": "संगठन वॉलेट"
    },
    "razorpay_description": "अपने वॉलेट में क्रेडिट जोड़ें",
    "razorpay_notice": "आप Razorpay (यूपीआई, कार्ड, नेटबैंकिंग) से भुगतान करेंगे। भुगतान के बाद क्रेडिट जोड़े जाएँगे।",
    "targets": {
      "org_wallet": "संगठन वॉलेट",
      "personal_balance": "आपका बैलेंस"
    },
    "title": {
      "org": "संगठन में क्रेडिट जोड़ें",
      "personal": "क्रेडिट जोड़ें"
    }
  },
  "transactions": {
    "description": "सभी भुगतान लेनदेन देखें और प्रबंधित करें।",
    "headers": {
      "credited": "क्रेडिट किया",
      "download": "चालान डाउनलोड करें",
      "item": "वस्तु",
      "paid": "भुगतान",
      "payment_method": "भुगतान विधि",
      "transaction_id": "लेनदेन आईडी",
      "type": "प्रकार",
      "user": "उपयोगकर्ता"
    },
    "items": {
      "org_topup": "संस्था वॉलेट ({{gateway}})",
      "personal_topup": "व्यक्तिगत वॉलेट ({{gateway}})"
    },
    "search_placeholder": "खोजें",
    "table": {
      "description": "आपके सिस्टम में सभी भुगतान लेनदेन की सूची।",
      "title": "सभी लेनदेन"
    },
    "title": "शीर्षक",
    "types": {
      "other": "अन्य",
      "plan": "योजना",
      "topup": "क्रेडिट टॉप-अप"
    }
  },
  "translationDemo": {
    "actions": {
      "decrement": "अनुवाद डेमो क्रियाएँ: घटाएँ",
      "increment": "अनुवाद डेमो क्रियाएँ: बढ़ाएँ",
      "loading": "अनुवाद डेमो क्रियाएँ: लोड हो रहा है",
      "reset": "अनुवाद डेमो क्रियाएँ: रीसेट करें",
      "submit": "अनुवाद डेमो क्रियाएँ: सबमिट करें"
    },
    "badge": "अनुवाद डेमो बैज",
    "bestPractices": {
      "tip1": "अनुवाद डेमो सर्वोत्तम अभ्यास: युक्ति 1",
      "tip2": "अनुवाद डेमो सर्वोत्तम अभ्यास: युक्ति 2",
      "tip3": "अनुवाद डेमो सर्वोत्तम अभ्यास: युक्ति 3",
      "tip4": "अनुवाद डेमो सर्वोत्तम अभ्यास: युक्ति 4"
    },
    "counter": {
      "label": "अनुवाद डेमो काउंटर: लेबल",
      "message_one": "अनुवाद डेमो काउंटर: संदेश (एक)",
      "message_other": "अनुवाद डेमो काउंटर: संदेश (अन्य)"
    },
    "description": "अनुवाद डेमो: विवरण",
    "examples": {
      "greeting": {
        "label": "अनुवाद डेमो उदाहरण: अभिवादन लेबल",
        "message": "अनुवाद डेमो उदाहरण: अभिवादन संदेश"
      },
      "simple": {
        "label": "अनुवाद डेमो उदाहरण: सरल लेबल",
        "text": "अनुवाद डेमो उदाहरण: सरल पाठ"
      }
    },
    "footer": {
      "text": "अनुवाद डेमो: पाद लेख"
    },
    "notifications": {
      "error": "अनुवाद डेमो सूचनाएँ: त्रुटि",
      "info": "अनुवाद डेमो सूचनाएँ: जानकारी",
      "success": "अनुवाद डेमो सूचनाएँ: सफलता"
    },
    "sections": {
      "basic": {
        "description": "अनुवाद डेमो अनुभाग: बुनियादी विवरण",
        "title": "अनुवाद डेमो के बुनियादी अनुभाग का शीर्षक"
      },
      "bestPractices": {
        "description": "अनुवाद डेमो के सर्वोत्तम अभ्यास अनुभाग का विवरण",
        "title": "अनुवाद डेमो के सर्वोत्तम अभ्यास अनुभाग का शीर्षक"
      },
      "conditional": {
        "description": "अनुवाद डेमो के शर्त-आधारित अनुभाग का विवरण",
        "title": "अनुवाद डेमो के शर्त-आधारित अनुभाग का शीर्षक"
      },
      "pluralization": {
        "description": "अनुवाद डेमो के बहुवचन अनुभाग का विवरण",
        "title": "अनुवाद डेमो के बहुवचन अनुभाग का शीर्षक"
      },
      "statuses": {
        "description": "अनुवाद डेमो के स्थिति अनुभाग का विवरण",
        "title": "अनुवाद डेमो के स्थिति अनुभाग का शीर्षक"
      }
    },
    "status": {
      "error": "अनुवाद डेमो की स्थिति: त्रुटि",
      "success": "अनुवाद डेमो की स्थिति: सफलता"
    },
    "title": "अनुवाद डेमो का शीर्षक"
  },
  "user_roles_page": {
    "access_denied": {
      "description": "आपको यूज़र रोल प्रबंधन देखने की अनुमति नहीं है।",
      "title": "प्रवेश निषिद्ध"
    },
    "actions": {
      "assign_role": "रोल असाइन करें"
    },
    "alerts": {
      "assign_failed": "रोल असाइन करने में विफल।",
      "role_assigned": "रोल सफलतापूर्वक असाइन हुआ!",
      "select_user_role": "कृपया यूज़र और रोल दोनों चुनें।"
    },
    "dialog": {
      "global_role": "ग्लोबल रोल",
      "organization_label": "संगठन (वैकल्पिक)",
      "organization_placeholder": "ग्लोबल रोल",
      "role_label": "रोल",
      "role_placeholder": "रोल चुनें",
      "title": "यूज़र को रोल असाइन करें",
      "user_label": "यूज़र",
      "user_placeholder": "यूज़र चुनें"
    },
    "loading": "यूज़र रोल लोड हो रहे हैं...",
    "search_placeholder": "यूज़र्स खोजें...",
    "showing_users_one": "",
    "showing_users_other": "",
    "subtitle": "यूज़र्स के लिए रोल असाइन और प्रबंधित करें",
    "table": {
      "name": "नाम",
      "roles": "रोल्स",
      "status": "स्थिति"
    },
    "title": "यूज़र रोल प्रबंधन"
  },
  "validation": {
    "accept_terms": "आपको नियम और शर्तें स्वीकार करनी होंगी",
    "billing_country_required": "",
    "city_required_signup": "शहर आवश्यक है",
    "invalid_email": "कृपया एक वैध ईमेल पता दर्ज करें",
    "org_name_min": "बिल्डर का नाम कम से कम 4 अक्षर का होना चाहिए",
    "password_complexity": "पासवर्ड में कम से कम एक बड़ा अक्षर, एक छोटा अक्षर और एक संख्या होनी चाहिए",
    "password_min": "पासवर्ड कम से कम 8 अक्षर का होना चाहिए",
    "passwords_mismatch": "पासवर्ड मेल नहीं खाते",
    "phone_country": "",
    "username_min": "उपयोगकर्ता नाम कम से कम 2 अक्षर का होना चाहिए"
  },
  "verify_email": {
    "actions": {
      "go_to_login": "लॉगिन पर जाएँ"
    },
    "descriptions": {
      "error": "आपका ईमेल सत्यापित करने में समस्या हुई।",
      "pending": "कृपया प्रतीक्षा करें, हम आपका ईमेल सत्यापित कर रहे हैं।",
      "success": "आपका ईमेल सत्यापित हो गया है! लॉगिन पर भेजा जा रहा है..."
    },
    "messages": {
      "invalid_token": "अमान्य या अनुपस्थित सत्यापन टोकन।",
      "verification_failed": "सत्यापन विफल। लिंक अमान्य या समाप्त हो सकता है।",
      "verified": "आपका ईमेल सत्यापित हो गया है!",
      "verifying": "आपका ईमेल सत्यापित किया जा रहा है..."
    },
    "title": "ईमेल सत्यापन"
  },
  "voice": {
    "failed_start": "",
    "hold_to_speak": "बोलने के लिए दबाकर रखें, टॉगल करने के लिए टैప్ करें",
    "live_connect_failed": "",
    "mic_denied": "माइक्रोफ़ोन एक्सेस अस्वीकार कर दिया गया",
    "no_mic": "कोई माइक्रोफ़ोन नहीं मिला",
    "no_speech": "कोई आवाज़ नहीं पहचानी गई",
    "not_supported": "इस ब्राउज़र में वॉयस इनपुट समर्थित नहीं है",
    "permission_denied": "माइक्रोफ़ोन अनुमति अस्वीकार कर दी गई",
    "recognition_error": "स्पीच रिकग्निशन त्रुटि",
    "stop_recording": "रिकॉर्डिंग रोकें",
    "transcribing": "ऑडियो ट्रांसक्राइब हो रहा है...",
    "transcribing_btn": "ट्रांसक्राइब हो रहा है...",
    "transcription_failed": "ट्रांसक्रिप्शन विफल रहा"
  }
}
